import * as i0 from '@angular/core';
import { InjectionToken, Injectable, NgModule, Inject } from '@angular/core';
import * as i3 from '@angular/common/http';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { tap, catchError, map, merge as merge$1, distinctUntilKeyChanged, first, filter, throttle, startWith, switchMap, distinctUntilChanged, shareReplay, combineLatest, throttleTime, scan, debounceTime } from 'rxjs/operators';
import { EMPTY, of, throwError, merge, Subject, interval, identity } from 'rxjs';
import * as i3$1 from '@brafton/skynet-angular-security-service';
import minimatch from 'minimatch';
import objectHash from 'object-hash';
import * as i6 from '@brafton/assets-api';
import { FileContentType, PlatformUploadResponse, InputType } from '@brafton/common-framework-library';

const ATLAS_CLIENT_CONFIG = new InjectionToken('atlasClientConfig');

class Error {
}
class ErrorDetails {
}

var CacheEntry;
(function (CacheEntry) {
    CacheEntry["cacheManager"] = "cache_manager";
    CacheEntry["selectedFeed"] = "selected_feed";
    CacheEntry["feeds"] = "feeds";
    CacheEntry["projectManager"] = "project_manager";
    CacheEntry["accountManager"] = "account_manager";
    CacheEntry["projectContributor"] = "project_contributor";
    CacheEntry["sow"] = "sow";
    CacheEntry["sows"] = "sows";
    CacheEntry["sowSummary"] = "sow_summary";
    CacheEntry["productionProject"] = "production_project";
    CacheEntry["productionProjectAssets"] = "production_project_assets";
    CacheEntry["productionProjects"] = "production_projects";
    CacheEntry["productionPhaseMessages"] = "production_phase_messages";
    CacheEntry["productionPhase"] = "production_phase";
    CacheEntry["ideaList"] = "idea_list";
    CacheEntry["ideaMessages"] = "idea_messages";
    CacheEntry["idea"] = "idea";
})(CacheEntry || (CacheEntry = {}));
var CacheMode;
(function (CacheMode) {
    CacheMode[CacheMode["preferCache"] = 0] = "preferCache";
    CacheMode[CacheMode["preferApi"] = 1] = "preferApi";
    CacheMode[CacheMode["merged"] = 2] = "merged";
})(CacheMode || (CacheMode = {}));
class CacheEntryClass {
    constructor(cacheEntry, keyId) {
        this.cacheEntry = cacheEntry;
        this.keyId = keyId;
    }
    get cacheKey() {
        return `${this.cacheEntry}_${this.keyId}`;
    }
}

var SocketAction;
(function (SocketAction) {
    SocketAction["Ping"] = "ping";
    SocketAction["SetFeed"] = "setFeed";
    SocketAction["Typing"] = "typing";
})(SocketAction || (SocketAction = {}));
var SocketEventType;
(function (SocketEventType) {
    SocketEventType["Pong"] = "pong";
    SocketEventType["Ping"] = "ping";
    SocketEventType["Refresh"] = "refresh";
    SocketEventType["Notification"] = "notification";
    SocketEventType["SetFeed"] = "setfeed";
    SocketEventType["Typing"] = "typing";
    SocketEventType["Unknown"] = "unknown";
})(SocketEventType || (SocketEventType = {}));
class SocketWrapper {
    constructor(action, data) {
        this.action = action;
        this.data = data;
    }
    toJSON() {
        var dataJson = JSON.stringify(this.data);
        var obj = { "action": this.action, "data": dataJson };
        return JSON.stringify(obj);
    }
}
class SocketBaseEvent {
    constructor(eventType) {
        var capitalised = eventType;
        this.eventType = { id: eventType.toString(), name: this.capitalizeFirstLetter(eventType.toString()) };
    }
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}
class SocketPongEvent extends SocketBaseEvent {
    constructor() {
        super(SocketEventType.Pong);
    }
}
class SocketPingEvent extends SocketBaseEvent {
    constructor() {
        super(SocketEventType.Ping);
    }
}
class SocketSetFeedEvent extends SocketBaseEvent {
    constructor(feedId) {
        super(SocketEventType.SetFeed);
        this.feedId = feedId;
    }
}
class SocketTypingEvent extends SocketBaseEvent {
    constructor(topic, dateTime, profile) {
        super(SocketEventType.Typing);
        this.topic = topic;
        this.profile = profile;
    }
}
class SocketTypingRequest extends SocketBaseEvent {
    constructor(topic, dateTime) {
        super(SocketEventType.Typing);
        this.topic = topic;
    }
}
class SmartWrapperOptions {
    constructor(cacheExpireTime, preferCacheOnInitialLoad, refreshOnFeedChange, debug, debounceRefreshes, refreshOnSocketTopic) {
        this.cacheExpireTime = 1;
        this.preferCacheOnInitialLoad = true;
        this.refreshOnFeedChange = false;
        this.refreshOnSocketTopic = true;
        if (cacheExpireTime)
            this.cacheExpireTime = cacheExpireTime;
        if (preferCacheOnInitialLoad !== undefined || preferCacheOnInitialLoad !== null)
            this.preferCacheOnInitialLoad = preferCacheOnInitialLoad;
        if (debug !== undefined || debug !== null)
            this.debug = debug;
        if (refreshOnFeedChange !== undefined || refreshOnFeedChange !== null)
            this.refreshOnFeedChange = refreshOnFeedChange;
        if (debounceRefreshes)
            this.debounceRefreshes = debounceRefreshes;
        if (refreshOnSocketTopic !== undefined)
            this.refreshOnSocketTopic = refreshOnSocketTopic;
    }
    refresh() {
        if (this.refreshSubject) {
            this.refreshSubject.next('External Refresh');
        }
    }
    loadMore() {
        if (this.loadMoreSubject) {
            this.loadMoreSubject.next();
        }
    }
}

class UserRegister {
}
class UserProfileInvite {
}

var PropertyTypeEnum;
(function (PropertyTypeEnum) {
    PropertyTypeEnum[PropertyTypeEnum["Title"] = 0] = "Title";
    PropertyTypeEnum[PropertyTypeEnum["Description"] = 1] = "Description";
    PropertyTypeEnum[PropertyTypeEnum["ImageUrl"] = 2] = "ImageUrl";
    PropertyTypeEnum[PropertyTypeEnum["PublishDate"] = 3] = "PublishDate";
    PropertyTypeEnum[PropertyTypeEnum["CanonicalUrl"] = 4] = "CanonicalUrl";
    PropertyTypeEnum[PropertyTypeEnum["Body"] = 5] = "Body";
})(PropertyTypeEnum || (PropertyTypeEnum = {}));

class UnitsAndCounts {
}
class DateUnitsAndCounts extends UnitsAndCounts {
}
class DateUnitsAvailabilityAndCounts extends DateUnitsAndCounts {
}
class UnitsAvailabilityAndCounts extends UnitsAndCounts {
}
class DateOwnerUnitsAndCounts extends UnitsAndCounts {
}
class DateOwnerUnitsAvailabilityAndCounts extends DateOwnerUnitsAndCounts {
}

class EnumBase {
    constructor(name, id) {
        this.name = name;
        this.id = id;
    }
}
//export class WorkType {
//  public name: string;
//  public id: string;
//  constructor(name: string, id: string) {
//    this.name = name;
//    this.id = id;
//  }
//}
//export abstract class CommonWorkTypes {
//  public static GeneralAI: WorkType = new WorkType("General AI", "654e675ce41441565f852c2d");
//  public static KeywordsOutlineAIWork: WorkType = new WorkType("Keywords > Outline AI Work", "655f37b3070e1a692d48d64b");
//  public static OutlineKeywordCopyAIWork: WorkType = new WorkType("Outline & Keywords > Copy AI Work", "655f37d5070e1a692d48d64c");
//  public static CopyKeywordsOptimizationAIWork: WorkType = new WorkType("Copy Keywords Optimization AI Work", "655f37ff070e1a692d48d64d");
//  public static CopyTweetsAIWork: WorkType = new WorkType("Copy > Tweets AI Work", "6560a31ebc364729a6ac0af3");
//  public static TitleImageAIWork: WorkType = new WorkType("Title > Image AI Work", "6560dca0a7298e47bccc8626");
//  public static TextWork: WorkType = new WorkType("Text Work", "6558db028719f0c582c6ad85");
//  public static AttachmentWork: WorkType = new WorkType("Attachment Work", "6558db0b8719f0c582c6ad86");
//  public static Planning: WorkType = new WorkType("Planning", "5a3278190adf480001b52ab4");
//  public static RevisionApproval: WorkType = new WorkType("Revision Approval", "5c58280eb2f3f80001708c7b");
//  public static RevisionEditing: WorkType = new WorkType("Revision Editing", "5c58281bb2f3f80001708c7c");
//  public static PublishContentLibrary: WorkType = new WorkType("Publish Content Library", "62d1a0cb6b6737fb1a6a207a");
//  public static PublishLocationUpdate: WorkType = new WorkType("Publish Location Update", "632ad2d68e0e1e560f4a2b94");
//  public static Publish: WorkType = new WorkType("Publish", "5c9e0055d3476e0001b4e8ae");
//  public static ProductionWork: WorkType = new WorkType("Production Work", "61b79b3ba26b06fe16594771");
//  public static KeywordSEOTitleAIWork: WorkType = new WorkType("Keyword > SEO Title AI Work", "656498684d49c1ab51c10e87");
//  public static TitleCopyKeywordsMetaDataAIWork: WorkType = new WorkType("Title & Copy & Keywords > Metadata AI Work", "656498824d49c1ab51c10e88");
//}

class OwnerUnitsAndCounts extends UnitsAndCounts {
}
class OwnerUnitsAvailabilityAndCounts extends OwnerUnitsAndCounts {
}
class PersonTerm {
}
class ProfileAlert {
}
class TermType extends EnumBase {
    constructor(name, id) {
        super(name, id);
    }
    static GetAll() {
        let all = [TermType.PTO, TermType.Sick, TermType.NationalHoliday, TermType.Leave,
            TermType.Travel, TermType.Work, TermType.Weekend, TermType.Overtime];
        return all;
    }
    static FromId(pid) {
        let result = this.GetAll().find((x) => x.id == pid);
        return result;
    }
}
TermType.Sick = new TermType("Sick", "Sick");
TermType.PTO = new TermType("PTO", "PTO");
TermType.NationalHoliday = new TermType("National Holiday", "NationalHoliday");
TermType.Leave = new TermType("Leave", "Leave");
TermType.Travel = new TermType("Travel", "Travel");
TermType.Work = new TermType("Work", "Work");
TermType.Weekend = new TermType("Weekend", "Weekend");
TermType.Overtime = new TermType("Overtime", "Overtime");
TermType.Unknown = new TermType("Unknown Term Type", "UnknownTermType");

class AtlasAuthInterceptor {
    constructor() { }
    /**
     * Get the auth token from the service.
     * Clone the request and replace the original headers with
     * cloned headers, updated with the authorization.
     * send cloned request with header to the next handler.
     *
     * @param req
     * @param next
     */
    intercept(req, next) {
        if (req.url.includes('atlas-api') ||
            req.url.includes('localhost:19505')) {
            const token = localStorage.getItem(`id_token_delegate_atlas-api`);
            const authReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`),
            });
            const returnMimeReq = authReq.clone({
                headers: authReq.headers.set('Content-Type', 'application/json'),
            });
            return next.handle(returnMimeReq);
        }
        return next.handle(req);
    }
}
AtlasAuthInterceptor.ɵfac = function AtlasAuthInterceptor_Factory(t) { return new (t || AtlasAuthInterceptor)(); };
AtlasAuthInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AtlasAuthInterceptor, factory: AtlasAuthInterceptor.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtlasAuthInterceptor, [{
        type: Injectable
    }], function () { return []; }, null); })();

const ATLAS_SERVICES = [];
class AtlasServiceModule {
    //constructor(webSocket: WebsocketService) {
    //  // Not using the Web Socket Service directly, but by injecting it here we initialise it.
    //}
    static forRoot() {
        return {
            ngModule: AtlasServiceModule,
            providers: [
                ATLAS_SERVICES,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: AtlasAuthInterceptor,
                    multi: true,
                },
            ],
        };
    }
}
AtlasServiceModule.ɵfac = function AtlasServiceModule_Factory(t) { return new (t || AtlasServiceModule)(); };
AtlasServiceModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AtlasServiceModule });
AtlasServiceModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        ATLAS_SERVICES,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AtlasAuthInterceptor,
            multi: true,
        },
    ], imports: [HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtlasServiceModule, [{
        type: NgModule,
        args: [{
                providers: [
                    ATLAS_SERVICES,
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: AtlasAuthInterceptor,
                        multi: true,
                    },
                ],
                imports: [HttpClientModule],
                exports: [],
                declarations: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AtlasServiceModule, { imports: [HttpClientModule] }); })();

class JsonEncryptDecrypt {
    constructor() { }
    findReferences(obj, catalog) {
        if (obj && typeof obj === 'object') {
            const id = obj.$id;
            if (typeof id === 'string') {
                catalog[id] = obj;
            }
            if (Object.prototype.toString.apply(obj) === '[object Array]') {
                let i;
                for (i = 0; i < obj.length; i += 1) {
                    this.findReferences(obj[i], catalog);
                }
            }
            else {
                for (const name in obj) {
                    if (obj.hasOwnProperty(name)) {
                        if (typeof obj[name] === 'object') {
                            this.findReferences(obj[name], catalog);
                        }
                    }
                }
            }
        }
    }
    resolveReferences(obj, catalog) {
        if (obj && typeof obj === 'object') {
            let i;
            let item;
            let id;
            if (Object.prototype.toString.apply(obj) === '[object Array]') {
                for (i = 0; i < obj.length; i += 1) {
                    item = obj[i];
                    if (item && typeof item === 'object') {
                        id = item.$ref;
                        if (typeof id === 'string') {
                            obj[i] = catalog[id];
                        }
                        else {
                            obj[i] = this.resolveReferences(item, catalog);
                        }
                    }
                }
            }
            else if (obj.$values && Object.prototype.toString.apply(obj.$values) === '[object Array]') {
                const arr = new Array();
                for (i = 0; i < obj.$values.length; i += 1) {
                    item = obj.$values[i];
                    if (item && typeof item === 'object') {
                        id = item.$ref;
                        if (typeof id === 'string') {
                            arr[i] = catalog[id];
                        }
                        else {
                            arr[i] = this.resolveReferences(item, catalog);
                        }
                    }
                    else {
                        arr[i] = item;
                    }
                }
                obj = arr;
            }
            else {
                let name;
                for (name in obj) {
                    if (obj.hasOwnProperty(name)) {
                        if (typeof obj[name] === 'object') {
                            item = obj[name];
                            if (item) {
                                id = item.$ref;
                                if (typeof id === 'string') {
                                    obj[name] = catalog[id];
                                }
                                else {
                                    obj[name] = this.resolveReferences(item, catalog);
                                }
                            }
                        }
                    }
                }
            }
        }
        return obj;
    }
    getDecycledCopy(obj, catalog) {
        let i;
        let name;
        let nu;
        switch (typeof obj) {
            case 'object':
                if (obj === null ||
                    obj instanceof Boolean ||
                    obj instanceof Date ||
                    obj instanceof Number ||
                    obj instanceof RegExp ||
                    obj instanceof String) {
                    return obj;
                }
                for (i = 0; i < catalog.length; i += 1) {
                    if (catalog[i] === obj) {
                        return { $ref: i.toString() };
                    }
                }
                obj.$id = catalog.length.toString();
                catalog.push(obj);
                if (Object.prototype.toString.apply(obj) === '[object Array]') {
                    nu = [];
                    for (i = 0; i < obj.length; i += 1) {
                        nu[i] = this.getDecycledCopy(obj[i], catalog);
                    }
                }
                else {
                    nu = {};
                    for (name in obj) {
                        if (Object.prototype.hasOwnProperty.call(obj, name)) {
                            nu[name] = this.getDecycledCopy(obj[name], catalog);
                        }
                    }
                }
                return nu;
            case 'number':
            case 'string':
            case 'boolean':
            default:
                return obj;
        }
    }
    decycle(obj) {
        const catalog = [];
        const newObj = this.getDecycledCopy(obj, catalog);
        return newObj;
    }
    retrocycle(obj) {
        const catalog = [];
        this.findReferences(obj, catalog);
        return this.resolveReferences(obj, catalog);
    }
}
JsonEncryptDecrypt.ɵfac = function JsonEncryptDecrypt_Factory(t) { return new (t || JsonEncryptDecrypt)(); };
JsonEncryptDecrypt.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: JsonEncryptDecrypt, factory: JsonEncryptDecrypt.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonEncryptDecrypt, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class CacheService {
    constructor(jsonDecryptEncrypt) {
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.interval = null;
        // 10 mins in Milliseconds
        const timerInMilliseconds = 1000 * 60 * 10;
        // Sets a interval of timerInMilliseconds(10 mins) and call this.getCacheManger()
        // and removeExpiredKeys
        this.interval = setInterval(() => {
            this.removeExpiredKeys();
        }, timerInMilliseconds);
    }
    ngOnDestroy() {
        // Stops the counter when the service is destroyed
        clearInterval(this.interval);
    }
    /**
     * Clear out a cache entry from both local storage and the cache manager
     * @param key
     */
    clearCache(key) {
        this.removeFromCacheManager(key);
    }
    remove(key) {
        localStorage.removeItem(key);
    }
    removeAll() {
        const cacheManager = this.getCacheManager();
        // iterate through cache manager in reverse
        for (let i = cacheManager.length - 1; i >= 0; i--) {
            const res = cacheManager[i];
            if (res.cacheKey !== CacheEntry.selectedFeed) {
                // Removes the element from local cache
                this.remove(res.cacheKey);
                // Deletes the element fron this.cacheManager
                cacheManager.splice(i, 1);
            }
        }
        // update the cachemanager although should basically be empty bar the selectedFeed
        this.setCacheManager(cacheManager);
    }
    setModel(key, value, expireTime = 2) {
        //if (!value) {
        //  this.remove(key);
        //  return;
        //}
        const decrypt = this.jsonDecryptEncrypt.decycle(value);
        let success = false;
        let retries = 20;
        // get ready to loop storage until success, whilst clearing out the oldest keys if we fail.
        do {
            // store in localStorage but ignore quote exceeded errors...
            try {
                localStorage.setItem(key, JSON.stringify(decrypt));
                success = true;
            }
            catch (error) {
                // ignore all errors on setItem for now
                console.log('Storage quota limit reached - removing oldest cache entry:' + error?.message);
                this.removeOldestCacheEntry();
                retries = retries - 1;
            }
        } while (success === false && retries > 0);
        if (retries === 0)
            console.log('Ran out of retries for removing oldest cache entry');
        const expiredMilliseconds = 1000 * 60 * 60 * expireTime;
        this.addToCacheManager(expiredMilliseconds, key);
    }
    getModel(key) {
        const cacheItemTemp = localStorage.getItem(key);
        if (!cacheItemTemp) {
            return EMPTY;
        }
        const cacheItem = JSON.parse(cacheItemTemp);
        const retroCycle = this.jsonDecryptEncrypt.retrocycle(cacheItem);
        return of(retroCycle);
    }
    removeExpiredKeys() {
        // Make sure this.cacheManager exists else get it from the local cache if still null return
        const cacheManager = this.getCacheManager();
        if (!cacheManager || cacheManager.length === 0) {
            return;
        }
        // Get date now in milliseonds now since January 1, 1970
        const dateNow = new Date().getTime();
        // this is important - you must iterate through the array in reverse, so that as we trim off entries, we don't change the index values of ref'd array entries
        for (let i = cacheManager.length - 1; i >= 0; i--) {
            const res = cacheManager[i];
            // Checks to see if element has expired
            if (res.cacheExpireTime < dateNow) {
                // Removes the element from local cache
                this.remove(res.cacheKey);
                // Deletes the element fron this.cacheManager
                cacheManager.splice(i, 1);
            }
        }
        this.setCacheManager(cacheManager);
    }
    removeOldestCacheEntry() {
        // Make sure this.cacheManager exists else get it from the local cache if still null return
        const cacheManager = this.getCacheManager();
        if (!cacheManager || cacheManager.length === 0) {
            return;
        }
        // sort cache manager entries so that the oldest is first.
        const sorted = cacheManager.sort((a, b) => a.cacheExpireTime - b.cacheExpireTime);
        // pick out the last entry.
        const entryToRemove = sorted[0];
        // remove the cache entry
        this.removeFromCacheManager(entryToRemove.cacheKey);
    }
    getCacheManager() {
        // Get local storage copy of cacheManage
        const cacheItemTemp = localStorage.getItem(CacheEntry.cacheManager);
        // Check to see if there is a localstorage value if not return
        if (!cacheItemTemp) {
            return [];
        }
        // Return retroCycled Copy to element that requested it
        return JSON.parse(cacheItemTemp);
    }
    removeFromCacheManager(key) {
        // Make sure that we have the most up todate CacheManger
        let cacheManager = this.getCacheManager();
        // filter out cache manager entry
        const filteredCacheManager = cacheManager.filter(c => c.cacheKey !== key);
        // remove local storage of cache entry
        this.remove(key);
        // Set the CacheManager
        this.setCacheManager(filteredCacheManager);
    }
    addToCacheManager(expireTime, key) {
        if (key === CacheEntry.selectedFeed) {
            return;
        }
        // Make sure that we have the most up todate CacheManger
        let cacheManager = this.getCacheManager();
        // Convert expireTime to a date object in milliseconds since January 1, 1970
        const expiredTime = new Date().getTime() + expireTime;
        // Add new element to CacheManger if it exists or creates new array
        if (cacheManager) {
            // Checks to see if element is already in the array if so return Index location
            const index = cacheManager.findIndex((el) => el.cacheKey === key);
            // If index is a valid and not -1 overwrite existing element data else add element to the back of the array
            if (index !== -1) {
                cacheManager[index] = {
                    cacheKey: key,
                    cacheExpireTime: expiredTime,
                };
            }
            else {
                cacheManager.push({ cacheKey: key, cacheExpireTime: expiredTime });
            }
        }
        else {
            cacheManager = [{ cacheKey: key, cacheExpireTime: expiredTime }];
        }
        // Set the CacheManager
        this.setCacheManager(cacheManager);
    }
    setCacheManager(cacheManager) {
        // Make Sure this.cacheManager Exists else Leave
        if (!cacheManager) {
            return;
        }
        // Add to this.cacheManger to local storage Key cache_manager
        localStorage.setItem(CacheEntry.cacheManager, JSON.stringify(cacheManager));
    }
    // Cache Helper
    wrapper(apiCall, cacheEntry, expireTime, cacheMode = CacheMode.merged) {
        if (cacheMode === CacheMode.preferCache) {
            const cache = this.getModel(cacheEntry);
            if (cache === EMPTY) {
                const api = apiCall().pipe(tap((res) => {
                    this.setModel(cacheEntry, res, expireTime);
                }), catchError((error) => {
                    return throwError(error);
                }));
                return api;
            }
            return cache;
        }
        if (cacheMode === CacheMode.preferApi) {
            const api = apiCall().pipe(tap((res) => {
                this.setModel(cacheEntry, res, expireTime);
            }), catchError((error) => {
                return throwError(error);
            }));
            return api;
        }
        {
            const api = apiCall().pipe(tap((res) => {
                this.setModel(cacheEntry, res, expireTime);
            }), 
            // this is the API HTTP error catch - which we must pass on
            catchError((error) => {
                return throwError(error);
            }));
            const getCache = this.getModel(cacheEntry);
            return merge(getCache, api);
        }
    }
}
CacheService.ɵfac = function CacheService_Factory(t) { return new (t || CacheService)(i0.ɵɵinject(JsonEncryptDecrypt)); };
CacheService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CacheService, factory: CacheService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CacheService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: JsonEncryptDecrypt }]; }, null); })();

class AtlasSharedService {
    static handleError(operation = 'operation', result) {
        const res = (error) => {
            if (error instanceof HttpErrorResponse) {
                const pError = new Error();
                pError.status = error.status;
                pError.statusText = error.statusText;
                pError.details = error.error;
                return throwError(pError);
            }
            const res = of(result);
            return res;
        };
        return res;
    }
}

class FeedService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(http, cacheService, authService, config) {
        this.http = http;
        this.cacheService = cacheService;
        this.authService = authService;
        this.config = config;
        this.appName = 'atlas-api';
        this.setFeedSubject = new Subject();
        this.config = config;
    }
    /**
     * Lists all of the allowable feeds
     */
    listFeeds() {
        return this.cacheService.wrapper(() => this.http
            .get(
        // eslint-disable-next-line max-len
        `${this.config.atlasApiEndpoint}/api/feed/client-policy`)
            .pipe(catchError(AtlasSharedService.handleError())), CacheEntry.feeds, 4, CacheMode.preferCache);
    }
    /**
     * Returns an observable stream of the current selected feed, or if none selected defaults to the first in the list
     * */
    selectedFeed() {
        // setup the api vs cache pipe for selected feed
        const apiPipe = this.cacheService.wrapper(() => this.listFeeds().pipe(map((res) => res[0])), CacheEntry.selectedFeed, 9999, CacheMode.preferCache);
        // combine above pipe with the optional ping fired from SetFeed()
        const combinedPipeWithSetFeedPing = apiPipe.pipe(merge$1(this.setFeedSubject), 
        // only emit when the value changes - ie if the same thing gets pinged twice somehow, we don't double emit.
        distinctUntilKeyChanged('id'));
        return combinedPipeWithSetFeedPing;
    }
    /**
     * Sets the current feed, updates cache and fires any subscribed observers of the SelectedFeed() obs
     * @param feedId
     */
    setFeed(feedId) {
        const canViewAllFeeds = this.authService.hasPermission('readAllFeeds');
        const canViewPodFeeds = this.authService.hasPermission('readPodFeeds');
        const profileID = this.authService.profileId;
        const observablePipe = this.cacheService.wrapper(() => this.listFeeds().pipe(map((res) => res.find((feed) => feed.id === feedId))), CacheEntry.selectedFeed, 9999, CacheMode.preferApi);
        // we're using first() here as we only need to listen to this pipe once, and first() automatically unsubscribes after the first result is emitted
        observablePipe.pipe(first()).subscribe((feed) => {
            // clearing cache on change of feed
            this.cacheService.removeAll();
            // trigger the internal subject so that subscribers of SelectedFeed get pinged
            this.setFeedSubject.next(feed);
            // we don't actually need to do anything else here, just be sure that we do subscribe - otherwise the whole pipe doesn't run.
        });
    }
}
FeedService.ɵfac = function FeedService_Factory(t) { return new (t || FeedService)(i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(CacheService), i0.ɵɵinject(i3$1.BfAuthService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
FeedService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FeedService, factory: FeedService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FeedService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i3.HttpClient }, { type: CacheService }, { type: i3$1.BfAuthService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class WebsocketService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param authService
     */
    constructor(authService, http, cacheService, jsonDecryptEncrypt, config) {
        this.authService = authService;
        this.http = http;
        this.cacheService = cacheService;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.config = config;
        this.appName = 'atlas-api';
        this.lostPings = 0;
        this.reconnectAttempts = 0;
        this.reconnectAttemptLimit = 10;
        this.profileId = 0;
        this.typingProfiles = [];
        this.typingTimeouts = [];
        this.typingTimeoutInMs = 10000;
        this.lastTypingEmit = [];
        this.config = config;
        this.subjects = [];
        this.typingSubjects = [];
        this.cacheSubscriptions = [];
        this.authService.profileIdAsync.subscribe((profileId) => {
            console.log('ProfileId: ' + profileId);
            this.profileId = profileId;
            if (profileId == 0) {
                console.log('Doesn\'t appear we\'re logged in, exiting');
                return;
            }
            this.connect();
        });
    }
    // This is the only public method
    // Subscribe to topic
    subscribeToRefreshTopic(topic) {
        this.subjects[topic] || (this.subjects[topic] = new Subject());
        // starts with forces an initial callback
        return this.subjects[topic];
        // we should setup some sort of watcher on this array to delete / remove entries once all subscriptions have been destroyed
    }
    // just an empty subject to use when not doing socket refreshes
    nullRefreshTopic() {
        const nullSubject = new Subject();
        return nullSubject;
    }
    subscribeToTypingTopic(topic) {
        if (this.typingSubjects[topic] != null)
            return this.typingSubjects[topic];
        this.typingSubjects[topic] = new Subject().
            pipe(map((value, index) => {
            if (this.typingProfiles[topic] == null)
                this.typingProfiles[topic] = [];
            var profiles = this.typingProfiles[topic];
            if (this.typingTimeouts[topic] == null)
                this.typingTimeouts[topic] = [];
            var timeouts = this.typingTimeouts[topic];
            if (value != null) {
                if (timeouts[value.profile.id])
                    clearTimeout(timeouts[value.profile.id]);
                if (profiles.filter(x => x.id === value.profile.id).length == 0) {
                    profiles.push(value.profile);
                }
                timeouts[value.profile.id] = setTimeout(() => {
                    var obj = profiles.filter(x => x.id === value.profile.id)[0];
                    var index = profiles.indexOf(obj);
                    profiles.splice(index, 1);
                    this.typingSubjects[topic].next(null);
                }, this.typingTimeoutInMs);
            }
            return profiles;
        }), filter(// Cannot use distinctUntilChanged because previous and next are both references to the same object and so it never works, this is why I'm stringifying it to break the reference
        (value, index) => {
            var topicIds = this.typingProfiles[topic];
            if (this.lastTypingEmit[topic] == null)
                this.lastTypingEmit[topic] = [];
            var json = JSON.stringify(topicIds);
            if (this.lastTypingEmit[topic] != json) {
                this.lastTypingEmit[topic] = json;
                return true;
            }
            return false;
        }));
        return this.typingSubjects[topic];
        // we should setup some sort of watcher on this array to delete / remove entries once all subscriptions have been destroyed
    }
    sendTypingInfo(topic) {
        if (this.socket != undefined && this.socket.readyState == WebSocket.OPEN) {
            let event = new SocketTypingRequest(topic, new Date(Date.now()));
            this.socket.send((new SocketWrapper(SocketAction.Typing, event)).toJSON());
        }
    }
    subscribeToTyping(topic, event) {
        event.pipe(throttle(val => interval(this.typingTimeoutInMs - 2000))).subscribe(() => {
            this.sendTypingInfo(topic);
        });
    }
    subscribeToInternalRefreshTopic(topic) {
        return;
    }
    makeApiCall(apiUrl) {
        return () => {
            return this.http
                .get(apiUrl)
                .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
        };
    }
    wrapper(websocketTopic, expireTime, cacheMode = CacheMode.merged) {
        if (websocketTopic[0] !== "/") {
            websocketTopic = `/${websocketTopic}`;
        }
        var subscriptionKey = websocketTopic.split('?', 1)[0];
        if (this.cacheSubscriptions[subscriptionKey] == null) {
            this.cacheSubscriptions[subscriptionKey] = this.subscribeToRefreshTopic(subscriptionKey).pipe(startWith(0), switchMap(((refresh) => {
                // if we've got an actual refresh topic - then switch to only api - as there's no point emitting the cached version as well
                if (typeof refresh !== 'number') {
                    cacheMode = CacheMode.preferApi;
                }
                var apiCall = this.makeApiCall(`${this.config.atlasApiEndpoint}/api${websocketTopic}`);
                const cacheKey = `${websocketTopic.split('?', 1)[0]}`;
                var wrapper = this.cacheService.wrapper(apiCall, cacheKey, expireTime, cacheMode);
                return wrapper;
            })), distinctUntilChanged((prev, next) => objectHash(prev) === objectHash(next)), shareReplay());
        }
        return this.cacheSubscriptions[subscriptionKey];
    }
    wrapperWithRefresh(websocketTopic, expireTime, cacheMode = CacheMode.merged, refresh) {
        if (websocketTopic[0] !== "/") {
            websocketTopic = `/${websocketTopic}`;
        }
        var subscriptionKey = websocketTopic.split('?', 1)[0];
        if (this.cacheSubscriptions[subscriptionKey] == null) {
            this.cacheSubscriptions[subscriptionKey] = this.subscribeToRefreshTopic(subscriptionKey).pipe(startWith(0), combineLatest(refresh.pipe(startWith(0))), switchMap((([refresh, manualRefresh]) => {
                // if we've got an actual refresh topic - then switch to only api - as there's no point emitting the cached version as well
                if (typeof refresh !== 'number' || typeof manualRefresh !== 'number') {
                    cacheMode = CacheMode.preferApi;
                }
                var apiCall = this.makeApiCall(`${this.config.atlasApiEndpoint}/api${websocketTopic}`);
                const cacheKey = `${websocketTopic.split('?', 1)[0]}`;
                var wrapper = this.cacheService.wrapper(apiCall, cacheKey, expireTime, cacheMode);
                return wrapper;
            })), distinctUntilChanged((prev, next) => objectHash(prev) === objectHash(next)), shareReplay());
        }
        return this.cacheSubscriptions[subscriptionKey];
    }
    wrapperWithAltTopic(urlSlug, websocketTopic, expireTime, cacheMode = CacheMode.merged) {
        if (urlSlug[0] !== "/") {
            urlSlug = `/${urlSlug}`;
        }
        if (websocketTopic[0] !== "/") {
            websocketTopic = `/${websocketTopic}`;
        }
        // setup subscription caching on the full url slug (including querystringst
        var subscriptionKey = urlSlug;
        if (this.cacheSubscriptions[subscriptionKey] == null) {
            // subscribe to websocket topic using the parameterized string
            this.cacheSubscriptions[subscriptionKey] = this.subscribeToRefreshTopic(websocketTopic).pipe(startWith(0), switchMap(((refresh) => {
                // if we've got an actual refresh topic - then switch to only api - as there's no point emitting the cached version as well
                if (typeof refresh !== 'number') {
                    cacheMode = CacheMode.preferApi;
                }
                const apiCall = this.makeApiCall(`${this.config.atlasApiEndpoint}/api${urlSlug}`);
                // cache on the full url with query string
                const cacheKey = `${urlSlug}`;
                var wrapper = this.cacheService.wrapper(apiCall, cacheKey, expireTime, cacheMode);
                return wrapper;
            })), distinctUntilChanged((prev, next) => objectHash(prev) === objectHash(next)), shareReplay());
        }
        return this.cacheSubscriptions[subscriptionKey];
    }
    innerSocketWrapper(urlSlug, websocketTopic, options) {
        // nothing passed so start with all default values
        if (!options)
            options = new SmartWrapperOptions(1, true);
        if (urlSlug[0] !== '/') {
            urlSlug = `/${urlSlug}`;
        }
        if (websocketTopic[0] !== '/') {
            websocketTopic = `/${websocketTopic}`;
        }
        // setup subscription caching on the full url slug (including querystrings)
        var subscriptionKey = urlSlug;
        if (this.cacheSubscriptions[subscriptionKey] != null) {
            if (options.debug === true)
                console.log(`loading existing subscription - ${subscriptionKey}`);
        }
        if (this.cacheSubscriptions[subscriptionKey] == null) {
            if (options.debug === true)
                console.log(`creating new susbcription - ${subscriptionKey}`);
            const localReset = new Subject();
            const localForceRefresh = new Subject();
            const loading = new Subject();
            const localRequestNextPage = new Subject();
            // a pipe that spits out the page number to load, and resets to page 1 on any refresh command
            const pageNoPipe = localForceRefresh.pipe(startWith(0), throttleTime(5000), map(r => 'refresh'), merge$1(localRequestNextPage), scan((acc, cur) => cur === 'refresh' ? 1 : acc + 1, 0), distinctUntilChanged());
            // two inbound call types
            // 1. new subsrcription
            // - - if cache return cache first, then make api call and return that as well, on the latter call ensure the local refresh emits 'localReset'
            // 2. refresh request
            const data = localForceRefresh
                .pipe(startWith(0), throttleTime(5000), 
            // the locall refresh force starts with 0, so that we know to load on initial connection, and is then throttled to 10 seconds
            // the throttle should ensure that if there were multiple subscribers to the same shared subscription - on a socket refresh, they would each still receive
            // the refresh ping and all of them would then issue a reload request to the shared inner sub.
            // the throttle does the opposite of debounceTime() in that it pings on the first emit that it gets and then wont ping again for any subsequent emit within the timeframe
            combineLatest(pageNoPipe), switchMap(([refresh, pageNo]) => {
                if (options.debug === true)
                    console.log('start inner api request - ' + urlSlug);
                const urlSlugWithPage = urlSlug.replace('page=1', `page=${pageNo}`);
                var apiCall = this.makeApiCall(`${this.config.atlasApiEndpoint}/api${urlSlugWithPage}`);
                loading.next(true);
                const cacheKey = `${urlSlugWithPage}`;
                // if refresh = 0 then must be the first load, so do the preferCache load - ie only hitting API if we must
                if (refresh === 0) {
                    var cacheMode = options.preferCacheOnInitialLoad ? CacheMode.preferCache : CacheMode.merged;
                    var initialLoadWrapper = this.cacheService.wrapper(apiCall, cacheKey, options.cacheExpireTime, cacheMode).pipe(tap(c => {
                        loading.next(false);
                        if (options.debug === true)
                            console.log('inner prefercache response - ' + urlSlug);
                    }), catchError(error => {
                        loading.next(false);
                        return error;
                    }));
                    return initialLoadWrapper;
                }
                // otherwise must be a refresh request, in which case
                else {
                    var reloadWrapper = this.cacheService
                        .wrapper(apiCall, cacheKey, options.cacheExpireTime, CacheMode.preferApi)
                        .pipe(tap((d) => {
                        if (options.debug === true)
                            console.log('inner prefer api response - ' + urlSlug);
                        localReset.next('localReset');
                        loading.next(false);
                    }));
                    return reloadWrapper;
                }
            }), 
            // this is for automatic paging and paging accumulation
            scan((acc, prods) => {
                // if no paging just wrap up in an accumulator of the current value - ie just passthrough.
                if (!urlSlug.includes('page=')) {
                    acc['results'] = prods;
                    return acc;
                }
                // when on page 1 / a base line refresh - we store results into the accumulator
                if (prods.page === 1) {
                    acc['results'] = prods;
                    acc['previous'] = prods;
                }
                // if the loaded result equals the page number of that in the accumulator we must be refreshing / socket pinging on existing data
                // if so we just take the refreshed / reloaded most recent page, and merge it on top of the previous resuls.
                // leaving the previous results store in place in case of another refresh.
                else if (prods.page === acc?.results?.page && acc?.previous) {
                    acc.results = this.mergeLists(acc.previous, prods);
                }
                // so this is when we must be loading a new page
                // so store the current total results as previous, and mrege the previous and the new page of results and return
                else if (acc.previous) {
                    acc.previous = acc.results;
                    acc.results = this.mergeLists(acc.previous, prods);
                }
                // this is just a fall back if/when something unexpected happens - like acc is empty and results response that is not on page 1.
                else {
                    acc['results'] = prods;
                    acc['previous'] = prods;
                }
                return acc;
            }, {}), 
            // this just maps out from the accumnulator the main results so that our output type object remains the same.
            map((results) => results.results), shareReplay(1));
            //need to merge the socket ropic, and a manual call from the api load so that we can emit clean or dirty for this pipe to emit
            const localRefresh = (options.refreshOnSocketTopic === true ? this.subscribeToRefreshTopic(websocketTopic) : this.nullRefreshTopic()).pipe(
            // possible option to avoid multiple close calls of the same refresh topic
            options.debounceRefreshes ? debounceTime(options.debounceRefreshes || 0) : identity, startWith(0), 
            //tap(t => console.log('inner socket refresh response')),
            merge$1(localReset), map((i) => {
                if (options.debug === true)
                    console.log('inner merged socket refresh / api refresh response - ' + urlSlug);
                if (i === 'localReset' || i === 0) {
                    if (options.debug === true)
                        console.log('sending - data is clean - ' + urlSlug);
                    return 'clean';
                }
                else {
                    if (options.debug === true)
                        console.log('sending - data is dirty - ' + urlSlug);
                    return 'dirty';
                }
            }), 
            // we need to ignore this now as if the refresh comes within the above 5000 throttle time to the api, then we can get stuck on 'dirty' - which won't refire again, as it's not a change...
            //distinctUntilChanged(),
            throttleTime(150), shareReplay(1));
            // combined data pipe, refresh pipe, and request refresh object
            const obj = { data: data, refresh: localRefresh, forceRefresh: localForceRefresh, loading: loading.pipe(distinctUntilChanged()), loadMore: localRequestNextPage };
            this.cacheSubscriptions[subscriptionKey] = obj;
        }
        return this.cacheSubscriptions[subscriptionKey];
    }
    smartApiWrapper(urlSlug, socketTopic = '', options) {
        if (socketTopic === '')
            socketTopic = urlSlug;
        var innerW = this.innerSocketWrapper(urlSlug, socketTopic, options);
        const ref = innerW.refresh.pipe(
        //tap(t => console.log('pre-filter refresh fire - ' + t)),
        // only react if the latest value is 'dirty' - ie if clean we dont' need to do anything.
        filter(r => r === 'dirty'), tap(t => {
            if (options.debug === true)
                console.log('outer refresh sub fire - ' + t + ' ' + urlSlug);
            innerW.forceRefresh.next('request refresh');
        }), 
        // this is designed to specifically block ANY event from emitting any further than this - ie we don't want to emit it - it's just here so that we can still start the subscribe chain
        filter(r => r === 'xsdertfgj'), 
        // typing cheat to make the typescript think it's all the same observable type.
        map(r => r));
        // pass back a reference to the force refresh subject;
        if (options) {
            options.refreshSubject = innerW.forceRefresh;
            options.loading = innerW.loading;
            options.loadMoreSubject = innerW.loadMore;
        }
        // merge the two obs together - so that the subscription is chained, even though the refresh obs should never emit.
        //const data = innerW.data.pipe(tap((d) => console.log('outer data sub fire')));
        const merged = innerW.data.pipe(merge$1(ref));
        return merged;
    }
    /**
     * Merge PagedList.
     */
    mergeLists(mainList, additionalPageList) {
        const results = {};
        results.items = mainList.items.concat(additionalPageList.items);
        results.pageSize = additionalPageList.pageSize;
        results.page = additionalPageList.page;
        results.totalItems = additionalPageList.totalItems;
        results.totalPages = additionalPageList.totalPages;
        // copy units if they exist
        if (additionalPageList?.totalUnits) {
            results.totalUnits = additionalPageList.totalUnits;
            results.rangeUnits = additionalPageList.rangeUnits;
        }
        return results;
    }
    connect() {
        if (this.socket != undefined && this.socket.readyState == WebSocket.OPEN) {
            console.log('Already connected, will need to disconnect');
            this.socket.onclose = () => {
                console.log('Disconnected');
                this.connect();
            };
            this.socket.close();
            return;
        }
        console.log('Connecting...');
        let atlasToken = window.localStorage.getItem('id_token_delegate_atlas-api');
        let url = this.config.atlasWebSocketEndpint + '/?token=' + atlasToken;
        this.socket = new WebSocket(url);
        this.socket.onmessage = (event) => this.onMessage(event);
        this.socket.onerror = () => {
            this.socket?.close();
        };
        this.socket.onopen = () => {
            this.reconnectAttempts = 0;
            this.lostPings = 0;
            this.lastPingSent = undefined;
            this.sendPing();
            this.intervalId = window.setInterval(() => this.sendPing(), 30000);
        };
        window.onbeforeunload = () => {
            if (this.socket != undefined) {
                this.socket.onclose = function () { }; // Disable onclose handler
                this.socket.close();
            }
        };
        this.socket.onclose = () => {
            console.log('Connection has been lost - Attempt: ' + this.reconnectAttempts + '/' + this.reconnectAttemptLimit);
            // We want to reconnect if connection lost
            if (this.reconnectAttempts >= this.reconnectAttemptLimit) {
                // Don't bother reconnecting.
                console.log('Reconnect attempts ' + this.reconnectAttempts + ' are over the limit of ' + this.reconnectAttemptLimit + ' giving up');
            }
            else {
                if (this.intervalId != undefined) {
                    window.clearInterval(this.intervalId);
                }
                console.log('Reconnecting in 5 seconds..');
                this.reconnectAttempts++;
                window.setTimeout(() => this.connect(), 5000);
            }
        };
    }
    onMessage(messageEvent) {
        //console.log('Message receieved');
        let obj = JSON.parse(messageEvent.data);
        if (obj.eventType.id == 'ping') {
            const pingObj = obj;
            // Ignore this event, this is really for the servers benefit anyway.
        }
        else if (obj.eventType.id == 'pong') {
            const pongObj = obj;
            this.lastPingSent = undefined; // By setting to undefined we know the server got our message
        }
        else if (obj.eventType.id == 'notification') {
            const notificationObj = obj;
            // Display notification
            alert(notificationObj.message);
        }
        else if (obj.eventType.id == 'refresh') {
            const refreshObj = obj;
            // Display refresh
            console.log('Topic refresh: ' + refreshObj.topic);
            // do globb based match / search on topic keys and then call next on each that match
            const matchedSubjects = Object.keys(this.subjects).filter(k => minimatch(k, refreshObj.topic));
            matchedSubjects.forEach(subkey => {
                const subject = this.subjects[subkey];
                if (subject != null) {
                    subject.next(refreshObj);
                }
            });
            //const subject =  this.subjects[refreshObj.topic] as Subject<ISocketTopicRefreshEvent>;
            //if (subject != null) {
            //  subject.next(refreshObj);
            //}
        }
        else if (obj.eventType.id == 'typing') {
            const typingObj = obj;
            // Typing event
            console.log('Typing event: ' +
                typingObj.topic +
                ' by ' +
                typingObj.profile.displayName);
            const subject = this.typingSubjects[typingObj.topic];
            if (subject != null) {
                subject.next(typingObj);
            }
        }
    }
    sendPing() {
        if (this.socket != undefined && this.socket.readyState == WebSocket.OPEN) {
            if (this.lastPingSent != undefined && ((Date.now() - this.lastPingSent) / 1000) > 25) {
                console.log('The last ping got lost');
                // The last ping got lost.
                this.lostPings++;
            }
            //else {
            //  console.log('The last ping didn\'t get lost');
            //}
            if (this.lostPings > 1) {
                this.socket.close();
                window.clearInterval(this.intervalId);
                return;
            }
            this.lastPingSent = Date.now();
            this.socket.send((new SocketWrapper(SocketAction.Ping, new SocketPingEvent())).toJSON());
        }
    }
}
WebsocketService.ɵfac = function WebsocketService_Factory(t) { return new (t || WebsocketService)(i0.ɵɵinject(i3$1.BfAuthService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(CacheService), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
WebsocketService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WebsocketService, factory: WebsocketService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WebsocketService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i3$1.BfAuthService }, { type: i3.HttpClient }, { type: CacheService }, { type: JsonEncryptDecrypt }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class AssetsService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, jsonDecryptEncrypt, websocket, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * List templates
     * @param feedId
     */
    listTemplates(feedId) {
        let params = new HttpParams();
        if (feedId) {
            params = params.set('feedId', feedId.toString());
        }
        // formal url slug
        const urlSlug = `/assets/templates?${params.toString()}`;
        const socketTopic = `/assets/templates`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, new SmartWrapperOptions(500, false, true));
    }
    uploadSuccess(assetFileId, filename, fileContentType, fileSizeInBytes) {
        let request = {
            fileSizeInBytes: fileSizeInBytes,
            fileContentType: fileContentType,
            filename: filename,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/assets/${assetFileId}/uploaded`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
AssetsService.ɵfac = function AssetsService_Factory(t) { return new (t || AssetsService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
AssetsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AssetsService, factory: AssetsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AssetsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class AuditService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    getTotals() {
        return this.feedService.selectedFeed().pipe(switchMap((f) => {
            return this.cacheService.wrapper(() => {
                return this.http
                    .get(`${this.config.atlasApiEndpoint}/api/${f.id}/Audit/total`)
                    .pipe(catchError(AtlasSharedService.handleError()));
            }, new CacheEntryClass(CacheEntry.projectContributor, f.id).cacheKey, 196);
        }));
    }
    getGroupedByDepartment() {
        return this.feedService.selectedFeed().pipe(switchMap((f) => {
            return this.cacheService.wrapper(() => {
                return this.http
                    .get(`${this.config.atlasApiEndpoint}/api/${f.id}/Audit/department`)
                    .pipe(catchError(AtlasSharedService.handleError()));
            }, new CacheEntryClass(CacheEntry.projectContributor, f.id).cacheKey, 196);
        }));
    }
    getGroupedByMonth() {
        return this.feedService.selectedFeed().pipe(switchMap((f) => {
            return this.cacheService.wrapper(() => {
                return this.http
                    .get(`${this.config.atlasApiEndpoint}/api/${f.id}/Audit/month`)
                    .pipe(catchError(AtlasSharedService.handleError()));
            }, new CacheEntryClass(CacheEntry.projectContributor, f.id).cacheKey, 196);
        }));
    }
    getGroupedByProduct() {
        return this.feedService.selectedFeed().pipe(switchMap((f) => {
            return this.cacheService.wrapper(() => {
                return this.http
                    .get(`${this.config.atlasApiEndpoint}/api/${f.id}/Audit/product`)
                    .pipe(catchError(AtlasSharedService.handleError()));
            }, new CacheEntryClass(CacheEntry.projectContributor, f.id).cacheKey, 196);
        }));
    }
    getGroupedBySow() {
        return this.feedService.selectedFeed().pipe(switchMap((f) => {
            return this.cacheService.wrapper(() => {
                return this.http
                    .get(`${this.config.atlasApiEndpoint}/api/${f.id}/Audit/sow`)
                    .pipe(catchError(AtlasSharedService.handleError()));
            }, new CacheEntryClass(CacheEntry.projectContributor, f.id).cacheKey, 196);
        }));
    }
}
AuditService.ɵfac = function AuditService_Factory(t) { return new (t || AuditService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
AuditService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuditService, factory: AuditService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuditService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class CampaignService {
    /**
     * Initialises a new instance of the CampaignService class.
     *
     * @param http
     * @param config
     */
    constructor(feedService, http, jsonDecryptEncrypt, websocket, assetFileService, assetsService, config) {
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.assetFileService = assetFileService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * Add an attachment to the campaign.
     * @param campaignId
     * @param phaseId only provide this if the attach,ent is for a campaign phase.
     * @param assetSetId
     * @param assetFileId
     * @param filename
     * @param comment
     */
    addAttachment(campaignId, phaseId, assetSetId, assetFileId, filename, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            filename: filename,
            comment: comment,
        };
        if (phaseId) {
            return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/phase/${phaseId}/addattachment`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        else {
            return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/addattachment`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Add a comment to a campaign
     * @param campaignId
     * @param phaseId only provide this if the message is for a campaign phase.
     * @param comment
     */
    addMessage(campaignId, phaseId, comment) {
        let request = { comment: comment };
        if (phaseId) {
            return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/phase/${phaseId}/addmessage`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        else {
            return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/addmessage`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Cancel a campaign project
     * @param campaignId
     * @param phaseId
     */
    cancel(campaignId, phaseId, comment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/cancel`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the campaign contribtors.
     * @param campaignId
     * @param contributorOwnerIdAdditions
     * @param contributorOwnerIdRemovals
     * @param phaseId
     */
    changeContributors(campaignId, contributorOwnerIdAdditions, contributorOwnerIdRemovals, phaseId) {
        let request = { contributorOwnerIdAdditions: contributorOwnerIdAdditions, contributorOwnerIdRemovals: contributorOwnerIdRemovals, phaseId: phaseId };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/changecontributors`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the owner of a campaign.
     * @param campaignId
     * @param ownerId
     * @param phaseId
     * @param comment
     */
    changeOwner(campaignId, ownerId, phaseId, comment) {
        let request = {
            ownerId: ownerId,
            phaseId: phaseId,
            comment: comment
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/changeowner`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the campaign dates.
     * @param campaignId
     * @param dueDate
     * @param phaseId
     */
    changeDates(campaignId, startDate, endDate, phaseId) {
        let request = { dueDate: endDate, phaseId: phaseId };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/changedates`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the profile image of a campaign.
     * @param campaignId
     * @param phaseId only provide this if the attach,ent is for a campaign phase.
     * @param assetSetId
     * @param assetFileId
     * @param filename
     * @param comment
     */
    changeProfileImage(campaignId, assetSetId, assetFileId, filename, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            filename: filename,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/changeprofileimage`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Force complete the whole campaign.
     * @param campaignId
     * @param comment
     */
    completeCampaign(campaignId, comment) {
        let request = { comment: comment };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/complete`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a new campaign
     * @param name
     * @param templateId
     */
    createCampaign(organizationId, name, templateId, startDate, endDate) {
        let request = {
            name: name,
            templateId: templateId,
            startDate: startDate,
            endDate: endDate,
        };
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/campaigns/${organizationId}`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Delete a campaign project
     * @param campaignId
     */
    delete(campaignId) {
        return this.http.delete(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}`)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /***
     * Get's a campaign from the api, whilst also subsribing to the websocket refresh topic, and using a merge cache strategy
     */
    getCampaign(campaignId, options) {
        return this.websocket.smartApiWrapper(`/campaigns/${campaignId}`, `/campaigns/${campaignId}`, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get all assets for a campaign.
     * @param campaignId
     */
    getCampaignAssets(campaignId, options) {
        return this.websocket.smartApiWrapper(`/campaigns/${campaignId}/assets`, `/campaigns/${campaignId}/assets`, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Hold a campaign project
     * @param campaignId
     */
    hold(campaignId, comment) {
        let request = {
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/hold`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
    * Link a file url to the campaign.
    * @param campaignId
    * @param phaseId optional
    * @param url
    */
    linkFile(campaignId, phaseId, url, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            fileUrl: url,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        if (phaseId) {
            return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/phase/${phaseId}/upload-link`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        else {
            return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/upload-link`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
   * Lists the project contributors for the campaign.
   * @param campaignId
   */
    listContributors(campaignId, options) {
        return this.websocket.smartApiWrapper(`/campaigns/${campaignId}/contributors`, `/campaigns/${campaignId}/contributors`, options || new SmartWrapperOptions(1, false));
    }
    /**
     * List all campaigns on the current feed and using a merge cache strategy
     * @param page
     * @param pageSize
     * @param workStatusTypeIds
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listCampaigns(page, pageSize, feedIds, ownerIds, workStatusTypeIds, fromDate, toDate, ownerId, orderByCriteria, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed id criteria
        if (feedIds)
            params = params.set('feedIds', feedIds);
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (workStatusTypeIds)
            params = params.set('workStatuses', workStatusTypeIds.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/campaigns?${params.toString()}`;
        const results = this.websocket.smartApiWrapper(urlSlug, 'campaigns', options || new SmartWrapperOptions(8, false, true));
        return results;
    }
    listContent(campaignId, page, pageSize, statuses, ownerId, fromDate, toDate, orderByCriteria, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        params = params.set('campaignId', campaignId);
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/campaigns/${campaignId}/content?${params.toString()}`;
        const socketTopic = `/content`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false));
    }
    listIdeas(campaignId, page, pageSize, workStatusTypeIds, fromDate, toDate, ownerId, orderByCriteria, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        params = params.set('campaignId', campaignId);
        if (workStatusTypeIds)
            params = params.set('statuses', workStatusTypeIds.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/campaigns/${campaignId}/ideas?${params.toString()}`;
        const socketTopic = `/ideas`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false));
    }
    listIdeaStages(campaignId, page, pageSize, workStatusTypeIds, fromDate, toDate, ownerId, orderByCriteria, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        params = params.set('campaignId', campaignId);
        if (workStatusTypeIds)
            params = params.set('statuses', workStatusTypeIds.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/campaigns/${campaignId}/ideastages?${params.toString()}`;
        const socketTopic = `/ideas`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false));
    }
    /**
     * List all messages for a campaign
     * @param campaignId
     * @param phaseId
     * @param page
     * @param pageSize
     */
    listMessages(campaignId, phaseId, page, pageSize, options) {
        return this.websocket.smartApiWrapper(`/campaigns/${campaignId}/messages`, `/campaigns/${campaignId}/messages`, options || new SmartWrapperOptions(8, false));
    }
    /**
     * Lists productions within a campaign
     * @param campaignId
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listProductions(campaignId, page, pageSize, statuses, ownerId, fromDate, toDate, orderByCriteria, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        params = params.set('campaignId', campaignId);
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/campaigns/${campaignId}/productions?${params.toString()}`;
        const socketTopic = `/productions`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false));
    }
    /**
     * Lists production calendar within a campaign
     * @param campaignId
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listProductionCalendar(campaignId, page, pageSize, statuses, ownerId, fromDate, toDate, orderByCriteria, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        params = params.set('campaignId', campaignId);
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/campaigns/${campaignId}/productioncalendar?${params.toString()}`;
        const socketTopic = `/productions`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false));
    }
    listProductionStages(campaignId, page, pageSize, statuses, ownerId, fromDate, toDate, orderByCriteria, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        params = params.set('campaignId', campaignId);
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/campaigns/${campaignId}/productionstages?${params.toString()}`;
        const socketTopic = `/productions`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false));
    }
    listProductionTasks(campaignId, page, pageSize, statuses, ownerId, fromDate, toDate, orderByCriteria, workTypeIds, workTypeNotIds, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        params = params.set('campaignId', campaignId);
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // included worktype
        if (workTypeIds)
            params = params.set('workTypeIds', workTypeIds);
        // exclude worktypes
        if (workTypeNotIds)
            params = params.set('workTypeNotIds', workTypeNotIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/campaigns/${campaignId}/productiontasks?${params.toString()}`;
        const socketTopic = `/tasks`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false));
    }
    /**
     * Rename a campaign
     * @param campaignId
     * @param name
     * @param phaseId
     */
    renameProject(campaignId, name, phaseId) {
        let request = { name: name, phaseId: phaseId };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/rename`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a campaign phase.
     * @param campaignId
     * @param phaseId
     * @param name
     */
    renamePhase(campaignId, phaseId, name) {
        let request = { name: name };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/phase/${phaseId}/rename`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Resume a campaign project
     * @param campaignId
     * @param phaseId
     */
    resume(campaignId, phaseId, comment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/resume`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Request the upload of a binary file to the asset system.
     * @param campaignId
     * @param phaseId only provide this if in the context of a phase.
     * @param filename
     * @param fileType
     * @param fileSizeInBytes
     */
    requestUpload(campaignId, phaseId, filename, fileType, fileSizeInBytes, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            filename: filename,
            fileType: fileType,
            fileSizeInBytes: fileSizeInBytes,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        if (phaseId) {
            return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/phase/${phaseId}/upload`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        else {
            return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/upload`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
      * Get the campaign object totals.
      */
    objectTotals(campaignId) {
        return this.websocket.wrapperWithAltTopic(`/campaigns/${campaignId}/objecttotals`, `objecttotals`, 1);
    }
    /**
       * Get the campaign productiontotals.
       */
    productionTotals(campaignId) {
        return this.websocket.wrapperWithAltTopic(`/campaigns/${campaignId}/productiontotals`, `productiontotals`, 1);
    }
    /**
     * Remove an attachment from a campaign.
     * @param campaignId
     * @param assetSetId
     * @param comment
     */
    removeAttachment(campaignId, assetSetId, assetFileId, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/removeattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename an attachment from a campaign.
     * @param ideaId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameAttachment(campaignId, assetSetId, assetFileId, newName, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            name: newName
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/renameattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
       * Get the space-type totals.
       */
    spaceTotals(campaignId, options) {
        return this.websocket.smartApiWrapper(`/campaigns/${campaignId}/spacetotals`, `spaces`, options || new SmartWrapperOptions(2, false, true));
    }
    /**
       * Get the status-type totals.
       */
    statusTotals(campaignId, options) {
        return this.websocket.smartApiWrapper(`/campaigns/${campaignId}/statustotals`, `spaces`, options || new SmartWrapperOptions(2, false, true));
    }
    /**
     * update the tags on a campaign
     * @param campaignId
     * @param comment
     * @param existingTagIdsToAdd
     * @param existingTagIdsToRemove
     * @param newTagNamesToCreateAndAdd
     * @param phaseId
     */
    updateTags(campaignId, comment, existingTagIdsToAdd, existingTagIdsToRemove, newTagNamesToCreateAndAdd, phaseId) {
        let request = {
            comment: comment,
            existingTagIdsToAdd: existingTagIdsToAdd,
            existingTagIdsToRemove: existingTagIdsToRemove,
            newTagNamesToCreateAndAdd: newTagNamesToCreateAndAdd,
            phaseId: phaseId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/campaigns/${campaignId}/updatetags`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    getExtension(fileName) {
        let split = fileName.split('.'); // Split by dot
        return split.pop();
    }
    /**
     * Upload a binary file.
     * @param campaignId
     * @param phaseId optional
     * @param file
     */
    uploadFile(campaignId, phaseId, file, feedId, organizationId, assetSetId, assetFileId) {
        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
        let safeFileName = file.name.replace("&", "_");
        let ext = this.getExtension(file.name);
        return this.assetFileService.GetMimeTypeForFile(file).pipe(switchMap((fileTypeResult) => {
            let fileType;
            if (fileTypeResult == null) {
                if (file.type == null) {
                    fileType = new FileContentType(ext, "application/octet-stream"); // Been unable to sniff content type - treat as unknown binary with ext that was provided.
                }
                else {
                    fileType = new FileContentType(ext, file.type);
                }
            }
            else {
                // CFB hack
                if (fileTypeResult.mime == "application/x-cfb") {
                    // CFB is the only file type that we can't properly sniff, all we know is it's a legacy office type (doc, xls etc)
                    // As it's legacy it's not worth putting too much effort in, so we'll just assume its valid and use the provided ext (not the sniffed ext which will be .cfb) to determine the type.
                    if (ext == "doc") {
                        fileType = new FileContentType(ext, "application/msword");
                    }
                    else if (ext == "xls") {
                        fileType = new FileContentType(ext, "application/vnd.ms-excel");
                    }
                    else if (ext == "ppt" || ext == "pps") {
                        fileType = new FileContentType(ext, "application/vnd.ms-powerpoint");
                    }
                    else {
                        fileType = new FileContentType(ext, file.type);
                    }
                }
                else {
                    fileType = new FileContentType(fileTypeResult.ext, fileTypeResult.mime); // Breaking dependency on File-Type library.
                }
            }
            return this.requestUpload(campaignId, phaseId, safeFileName, fileType, file.size, feedId, organizationId, assetSetId, assetFileId).pipe(switchMap((response) => {
                return this.assetFileService.BucketUploadAsync(response.assetFileId, response.awsUrl, file).pipe(switchMap((uploadResponse) => {
                    if (uploadResponse.status === 200) {
                        return this.assetsService.uploadSuccess(response.assetFileId, safeFileName, fileType, file.size).pipe(map((uploadSuccessResponse) => {
                            // We're now uploaded and told Assets the file is uploaded.
                            return new PlatformUploadResponse(uploadSuccessResponse, uploadResponse.progress, false, true);
                        }));
                    }
                    else if (uploadResponse.status == null && uploadResponse.progress > 0) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, true, false));
                    }
                    else if (uploadResponse instanceof HttpErrorResponse) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, false, false));
                    }
                    // We could be waiting for the first response from the server, so return a progress update.
                    return of(new PlatformUploadResponse(null, 0, true, false));
                }));
            }), catchError(AtlasSharedService.handleError()));
        }));
    }
}
CampaignService.ɵfac = function CampaignService_Factory(t) { return new (t || CampaignService)(i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
CampaignService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CampaignService, factory: CampaignService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CampaignService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class ContentService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(feedService, http, websocket, assetFilesService, assetsService, config) {
        this.feedService = feedService;
        this.http = http;
        this.websocket = websocket;
        this.assetFilesService = assetFilesService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * Add an attachment to the content version.
     * @param contentId
     * @param versionId
     * @param assetSetId
     * @param assetFileId
     * @param filename
     * @param comment
     */
    addAttachment(contentId, versionId, assetSetId, assetFileId, filename, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            filename: filename,
            comment: comment,
        };
        if (versionId) {
            return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.post(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/versions/${versionId}/addattachment`, request)
                .pipe(catchError(AtlasSharedService.handleError()))), first());
        }
        else {
            return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.post(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/addattachment`, request)
                .pipe(catchError(AtlasSharedService.handleError()))), first());
        }
    }
    /**
     * Add a comment to the content task.
     * @param contentId
     * @param versionId
     * @param taskId
     * @param comment
     */
    addComment(contentId, versionId, taskId, comment) {
        let request = { comment: comment };
        if (taskId) {
            return this.feedService.selectedFeed().pipe(switchMap((feed) => this.http.put(`${this.config.atlasApiEndpoint}/api/${feed.id}/content/${contentId}/versions/${versionId}/tasks/${taskId}/addcomment`, request)
                .pipe(catchError(AtlasSharedService.handleError()))), first());
        }
        else if (versionId) {
            return this.feedService.selectedFeed().pipe(switchMap((feed) => this.http.put(`${this.config.atlasApiEndpoint}/api/${feed.id}/content/${contentId}/versions/${versionId}/addcomment`, request)
                .pipe(catchError(AtlasSharedService.handleError()))), first());
        }
        else {
            return this.feedService.selectedFeed().pipe(switchMap((feed) => this.http.put(`${this.config.atlasApiEndpoint}/api/${feed.id}/content/${contentId}/addcomment`, request)
                .pipe(catchError(AtlasSharedService.handleError()))), first());
        }
    }
    /**
     * Change the task dates.
     * @param contentId
     * @param date
     */
    changeDate(contentId, date) {
        let request = { startDate: date, dueDate: date };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/changedate`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Change the owner of a content item.
     * @param contentId
     * @param ownerId
     */
    changeOwner(contentId, ownerId, comment) {
        let request = {
            ownerId: ownerId,
            comment: comment
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/changeowner`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Change the target product type of the content item.
     * @param contentId
     * @param productTypeTagId
     * @param phaseId
     */
    changeProductType(contentId, productTypeTagId, comment) {
        let request = {
            productTypeTagId: productTypeTagId,
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/changeproducttype`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Change the task dates.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param startDate
     * @param dueDate
     * @param phaseId
     */
    changeTaskDates(contentId, versionId, taskId, startDate, dueDate) {
        let request = { startDate: startDate, dueDate: dueDate };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/versions/${versionId}/tasks/${taskId}/changedates`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Delete a content item
     * @param contentId
     */
    delete(contentId) {
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.delete(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}`)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Remove associate to an existing campaign to the content item
     * @param contentId
     * @param name
     * @param templateId
     * @param comment
     */
    deSelectCampaign(contentId, comment) {
        let request = {
            campaignId: undefined,
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.post(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/deselectcampaign`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Mark as content item as draft
     * @param contentId
     */
    draft(contentId, comment) {
        let request = {
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/draft`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Duplicates an existing content item.
     * @param contentId
     */
    duplicate(contentId, comment) {
        let request = {
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/duplicate`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Get's the head details of a content item
     * @param contentId
     */
    getContentItem(contentId, options) {
        return this.websocket.smartApiWrapper(`/content/${contentId}`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get's the assets for a content item.
     * @param contentId
     */
    getContentAssets(contentId, options) {
        return this.websocket.smartApiWrapper(`/content/${contentId}/assets`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Hold a content item
     * @param contentId
     * @param phaseId
     */
    hold(contentId, comment) {
        let request = {
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/hold`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Import a new content item into the content library.
     * @param name
     * @param assets
     * @param existingTagIdsToAdd
     * @param newTagNamesToCreateAndAdd
     * @param productTypeTagId
     * @param campaignId
     * @param publishDate
     * @param publishURL
     */
    import(name, assets, existingTagIdsToAdd, newTagNamesToCreateAndAdd, productTypeTagId, campaignId, publishDate, publishURL) {
        let request = {
            name: name,
            assets: assets,
            existingTagIdsToAdd: existingTagIdsToAdd,
            newTagNamesToCreateAndAdd: newTagNamesToCreateAndAdd,
            productTypeTagId: productTypeTagId,
            campaignId: campaignId,
            publishDate: publishDate,
            publishURL: publishURL,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.post(`${this.config.atlasApiEndpoint}/api/${f.id}/content/import`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
    * Link a file url to the content version.
    * @param contentId
    * @param versionId
    * @param url
    */
    linkFile(contentId, versionId, url, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            fileUrl: url,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/content/${contentId}/versions/${versionId}/upload-link`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * List content items
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     * @param campaignIds
     * @param contentTypeIds
     * @param tagsIds
     */
    listContent(page = 1, pageSize = 10, feedIds, statuses, ownerId, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed id criteria
        if (feedIds)
            params = params.set('feedIds', feedIds);
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // formal url slug
        const urlSlug = `/content?${params.toString()}`;
        const socketTopic = `/content`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * List content calendar entries
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     * @param campaignIds
     * @param contentTypeIds
     * @param tagsIds
     */
    listContentCalendar(page = 1, pageSize = 10, statuses, ownerId, fromDate, toDate, campaignIds, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // formal url slug
        const urlSlug = `/content/calendar?${params.toString()}`;
        const socketTopic = `/content`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
   * Lists the project contributors for a piece of content.
   * @param contentId
   */
    listContributors(contentId, options) {
        return this.websocket.smartApiWrapper(`/content/${contentId}/contributors`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * List publish tasks
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     * @param campaignIds
     * @param contentTypeIds
     * @param tagsIds
     */
    listPublishTasks(page = 1, pageSize = 10, statuses, ownerId, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // formal url slug
        const urlSlug = `/content/publishtasks?${params.toString()}`;
        const socketTopic = `/content/publishtasks`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * Complete a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    publish(contentItemId, versionId, taskId, publishURL, publishedDate, comment) {
        let request = {
            publishURL: publishURL,
            publishedDate: publishedDate,
            comment: comment
        };
        return this.feedService.selectedFeed().pipe(switchMap((feed) => this.http.post(`${this.config.atlasApiEndpoint}/api/${feed.id}/content/${contentItemId}/versions/${versionId}/tasks/${taskId}/publish`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Remove an attachment from a content item.
     * @param contentId
     * @param versionId
     * @param assetSetId
     * @param comment
     */
    removeAttachment(contentId, versionId, assetSetId, assetFileId, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.post(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/versions/${versionId}/removeattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Rename an attachment from a content.
     * @param contentId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameAttachment(contentId, assetSetId, assetFileId, newName, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            name: newName
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/renameattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Remove a publish task.
     * @param contentId
     * @param versionId
     * @param publishTaskId
     * @param comment
     */
    removePublishTask(contentId, versionId, publishTaskId, comment) {
        let request = {
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.post(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/versions/${versionId}/tasks/${publishTaskId}/removepublish`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Rename a content item.
     * @param contentId
     * @param newName
     */
    renameContentItem(contentId, newName) {
        let request = {
            name: newName,
            comment: null
        };
        return this.feedService.selectedFeed().pipe(switchMap((feed) => this.http.put(`${this.config.atlasApiEndpoint}/api/${feed.id}/content/${contentId}/rename`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Reset a publish task.
     * @param contentId
     * @param versionId
     * @param publishTaskId
     * @param comment
     */
    resetPublishTask(contentId, versionId, publishTaskId, comment) {
        let request = {
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.post(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/versions/${versionId}/tasks/${publishTaskId}/resetpublish`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Resume a content item
     * @param contentId
     */
    resume(contentId, comment) {
        let request = {
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/resume`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * Request the upload of a binary file to the asset system.
     * @param contentId
     * @param versionId
     * @param filename
     * @param fileType
     * @param fileSizeInBytes
     */
    requestUpload(contentId, versionId, filename, fileType, fileSizeInBytes, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            filename: filename,
            fileType: fileType,
            fileSizeInBytes: fileSizeInBytes,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/content/${contentId}/versions/${versionId}/upload`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Assoiate an existing campaign to the content item
     * @param contentId
     * @param name
     * @param templateId
     * @param comment
     */
    selectCampaign(contentId, campaignId, comment) {
        let request = {
            campaignId: campaignId,
            comment: comment,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.put(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/selectcampaign`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    /**
     * update the tags on a content item.
     * @param contentId
     * @param comment
     * @param existingTagIdsToAdd
     * @param existingTagIdsToRemove
     * @param newTagNamesToCreateAndAdd
     * @param phaseId
     */
    updateTags(contentId, comment, existingTagIdsToAdd, existingTagIdsToRemove, newTagNamesToCreateAndAdd, phaseId) {
        let request = {
            comment: comment,
            existingTagIdsToAdd: existingTagIdsToAdd,
            existingTagIdsToRemove: existingTagIdsToRemove,
            newTagNamesToCreateAndAdd: newTagNamesToCreateAndAdd,
            phaseId: phaseId,
        };
        return this.feedService.selectedFeed().pipe(switchMap((f) => this.http.post(`${this.config.atlasApiEndpoint}/api/${f.id}/content/${contentId}/updatetags`, request)
            .pipe(catchError(AtlasSharedService.handleError()))), first());
    }
    getExtension(fileName) {
        let split = fileName.split('.'); // Split by dot
        return split.pop();
    }
    /**
     * Upload a binary file.
     * @param contentId
     * @param versionId
     * @param file
     */
    uploadFile(contentId, versionId, file, feedId, organizationId, assetSetId, assetFileId) {
        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
        let safeFileName = file.name.replace("&", "_");
        let ext = this.getExtension(file.name);
        return this.assetFilesService.GetMimeTypeForFile(file).pipe(switchMap((fileTypeResult) => {
            let fileType;
            if (fileTypeResult == null) {
                if (file.type == null) {
                    fileType = new FileContentType(ext, "application/octet-stream"); // Been unable to sniff content type - treat as unknown binary with ext that was provided.
                }
                else {
                    fileType = new FileContentType(ext, file.type);
                }
            }
            else {
                // CFB hack
                if (fileTypeResult.mime == "application/x-cfb") {
                    // CFB is the only file type that we can't properly sniff, all we know is it's a legacy office type (doc, xls etc)
                    // As it's legacy it's not worth putting too much effort in, so we'll just assume its valid and use the provided ext (not the sniffed ext which will be .cfb) to determine the type.
                    if (ext == "doc") {
                        fileType = new FileContentType(ext, "application/msword");
                    }
                    else if (ext == "xls") {
                        fileType = new FileContentType(ext, "application/vnd.ms-excel");
                    }
                    else if (ext == "ppt" || ext == "pps") {
                        fileType = new FileContentType(ext, "application/vnd.ms-powerpoint");
                    }
                    else {
                        fileType = new FileContentType(ext, file.type);
                    }
                }
                else {
                    fileType = new FileContentType(fileTypeResult.ext, fileTypeResult.mime); // Breaking dependency on File-Type library.
                }
            }
            return this.requestUpload(contentId, versionId, safeFileName, fileType, file.size, feedId, organizationId, assetSetId, assetFileId).pipe(switchMap((response) => {
                return this.assetFilesService.BucketUploadAsync(response.assetFileId, response.awsUrl, file).pipe(switchMap((uploadResponse) => {
                    if (uploadResponse.status === 200) {
                        return this.assetsService.uploadSuccess(response.assetFileId, safeFileName, fileType, file.size).pipe(map((uploadSuccessResponse) => {
                            // We're now uploaded and told Assets the file is uploaded.
                            return new PlatformUploadResponse(uploadSuccessResponse, uploadResponse.progress, false, true);
                        }));
                    }
                    else if (uploadResponse.status == null && uploadResponse.progress > 0) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, true, false));
                    }
                    else if (uploadResponse instanceof HttpErrorResponse) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, false, false));
                    }
                    // We could be waiting for the first response from the server, so return a progress update.
                    return of(new PlatformUploadResponse(null, 0, true, false));
                }));
            }), catchError(AtlasSharedService.handleError()));
        }));
    }
    /**
     *
     * @param projectId
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param textSetId
     * @param textSetName
     * @param textSetDefinitionId
     * @param textSetVersion
     * @param comment
     * @param privateComment
     * @returns
     */
    updateText(contentId, versionId, taskId, textSetId, textSetName, textSetDefinitionId, textSetVersion, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            name: textSetName,
            textSetDefinitionId: textSetDefinitionId,
            version: textSetVersion,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = `content/${contentId}/versions/${versionId}/tasks/${taskId}/update-text`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
ContentService.ɵfac = function ContentService_Factory(t) { return new (t || ContentService)(i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
ContentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ContentService, factory: ContentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContentService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: FeedService }, { type: i3.HttpClient }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class IdeationService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, jsonDecryptEncrypt, websocket, assetFileService, assetsService, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.assetFileService = assetFileService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * Accept an approval.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    acceptApproval(projectId, ideaId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/acceptapproval` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/acceptapproval`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add an approval round.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param approverOwnerId
     * @param comment
     */
    addApproval(projectId, ideaId, phaseId, taskId, approverOwnerId, comment, dueDate) {
        let request = {
            comment: comment,
            ownerId: approverOwnerId,
            dependentTaskId: taskId,
            dueDate: dueDate,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/addapproval` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/addapproval`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add an approval round and directly request approval at the same time.
     * @param ideaId
     * @param phaseId
     * @param conversationTaskId
     * @param approverOwnerId
     * @param comment
     */
    addAndRequestApproval(projectId, ideaId, phaseId, conversationTaskId, approverOwnerId, comment) {
        let request = {
            comment: comment,
            ownerId: approverOwnerId,
            dependentTaskId: conversationTaskId
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/addandrequestapproval` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/addandrequestapproval`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add an attachment to the idea thread.
     * @param ideaId
     * @param phaseId
     * @param assetSetId
     * @param assetFileId
     * @param filename
     * @param comment
     */
    addAttachment(projectId, ideaId, phaseId, assetSetId, assetFileId, filename, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            filename: filename,
            comment: comment,
        };
        if (phaseId) {
            const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/addattachment` :
                `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/addattachment`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        else {
            const urlSlug = !projectId ? `idea/${ideaId}/addattachment` :
                `masterprojects/${projectId}/idea/${ideaId}/addattachment`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Add an ideation stage to the idea project.
     * @param ideaId
     * @param stageName
     * @param productDefinitionId
     * @param comment
     * @param startDate
     * @param endDate
     * @param dependentOnPhaseId
     */
    addIdeationStage(projectId, ideaId, stageName, templateId, comment, startDate, endDate, roles, dependentOnPhaseId, units) {
        let request = {
            comment: comment,
            templateId: templateId,
            stageName: stageName,
            startDate: startDate,
            endDate: endDate,
            roles: roles,
            dependentOnPhaseId: dependentOnPhaseId,
            units: units,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/addideationstage` :
            `masterprojects/${projectId}/idea/${ideaId}/addideationstage`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add a comment to an idea thread
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    addMessage(projectId, ideaId, phaseId, taskId, comment) {
        let request = { comment: comment };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/addmessage` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/addmessage`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add a textset to an idea.
     * @param ideaId
     * @param phaseId
     * @param templateId
     * @param name
     * @param accessPublic
     * @param comment
     */
    addText(projectId, ideaId, phaseId, templateId, name, accessPublic, comment, privateComment) {
        let request = {
            templateId: templateId,
            accessType: accessPublic === true ? { id: 'Public', name: 'Public' } : { id: 'Private', name: 'Private' },
            name: name,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        if (phaseId) {
            const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/addtext` :
                `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/addtext`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        else {
            const urlSlug = !projectId ? `idea/${ideaId}/addtext` :
                `masterprojects/${projectId}/idea/${ideaId}/addtext`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Amend the owner assigned to an approval round.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param approverOwnerId
     * @param comment
     */
    amendApproval(projectId, ideaId, phaseId, taskId, approverOwnerId, comment) {
        let request = {
            comment: comment,
            ownerId: approverOwnerId,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/amendapproval` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/amendapproval`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Assign a task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    assignTask(projectId, ideaId, phaseId, taskId, ownerId, comment) {
        let request = {
            comment: comment,
            ownerId: ownerId,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/assign` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/assign`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Cancel an idea project
     * @param ideaId
     * @param phaseId
     */
    cancel(projectId, ideaId, phaseId, comment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/cancel` :
            `masterprojects/${projectId}/idea/${ideaId}/cancel`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change attachment access level.
     * @param projectId
     * @param ideaId
     * @param assetSetId
     * @param assetFileId
     * @param privateAsset
     * @param comment
     * @param privateComment
     */
    changeAttachmentAccessLevel(projectId, ideaId, assetSetId, assetFileId, accessLevel, comment, privateComment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            accessLevel: accessLevel,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/changeattachmentaccesslevel` :
            `masterprojects/${projectId}/idea/${ideaId}/changeattachmentaccesslevel`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change text access level.
     * @param projectId
     * @param ideaId
     * @param assetSetId
     * @param assetFileId
     * @param privateAsset
     * @param comment
     * @param privateComment
     */
    changeTextAccessLevel(projectId, ideaId, textSetId, accessLevel, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            accessLevel: accessLevel,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/changetextaccesslevel` :
            `masterprojects/${projectId}/idea/${ideaId}/changetextaccesslevel`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the owner of an idea.
     * @param ideaId
     * @param ownerId
     * @param phaseId
     * @param comment
     */
    changeOwner(projectId, ideaId, ownerId, phaseId, comment) {
        let request = {
            ownerId: ownerId,
            phaseId: phaseId,
            comment: comment
        };
        const urlSlug = !projectId ? `idea/${ideaId}/changeowner` :
            `masterprojects/${projectId}/idea/${ideaId}/changeowner`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the idea contribtors.
     * @param ideaId
     * @param contributorOwnerIdAdditions
     * @param contributorOwnerIdRemovals
     * @param phaseId
     */
    changeContributors(projectId, ideaId, contributorOwnerIdAdditions, contributorOwnerIdRemovals, phaseId) {
        let request = { contributorOwnerIdAdditions: contributorOwnerIdAdditions, contributorOwnerIdRemovals: contributorOwnerIdRemovals, phaseId: phaseId };
        const urlSlug = !projectId ? `idea/${ideaId}/changecontributors` :
            `masterprojects/${projectId}/idea/${ideaId}/changecontributors`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the idea due date.
     * @param ideaId
     * @param dueDate
     * @param phaseId
     */
    changeDueDate(projectId, ideaId, dueDate, phaseId) {
        let request = { dueDate: dueDate, phaseId: phaseId };
        const urlSlug = !projectId ? `idea/${ideaId}/changeduedate` :
            `masterprojects/${projectId}/idea/${ideaId}/changeduedate`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the target product type of the idea.
     * @param ideaId
     * @param productTypeTagId
     * @param phaseId
     */
    changeProductType(projectId, ideaId, productTypeTagId, phaseId, comment) {
        let request = {
            productTypeTagId: productTypeTagId,
            phaseId: phaseId,
            comment: comment
        };
        const urlSlug = !projectId ? `idea/${ideaId}/changeproducttype` :
            `masterprojects/${projectId}/idea/${ideaId}/changeproducttype`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the task dates.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param startDate
     * @param dueDate
     * @param phaseId
     */
    changeTaskDates(projectId, ideaId, phaseId, taskId, startDate, dueDate) {
        let request = { startDate: startDate, dueDate: dueDate };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/changedates` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/changedates`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the task work dates.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param startDate
     * @param dueDate
     * @param phaseId
     */
    changeTaskWorkDates(projectId, ideaId, phaseId, taskId, startDate, dueDate) {
        let request = { startDate: startDate, dueDate: dueDate };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/changeworkdates` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/changeworkdates`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change units.
     * @param projectId
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param units
     */
    changeUnits(projectId, ideaId, phaseId, taskId, units, comment, privateComment) {
        let request = {
            units: units,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        let urlSlug = '';
        if (projectId) {
            urlSlug += `/masterprojects/${projectId}`;
        }
        urlSlug += `/idea/${ideaId}`;
        if (phaseId) {
            urlSlug += `/phase/${phaseId}`;
        }
        if (taskId) {
            urlSlug += `/task/${taskId}`;
        }
        urlSlug += `/changeunits`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete the idea conversation task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeConversation(projectId, ideaId, phaseId, taskId, comment) {
        let request = { comment: comment };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/complete` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/complete`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Force complete the whole idea.
     * @param ideaId
     * @param comment
     */
    completeIdea(projectId, ideaId, comment) {
        let request = { comment: comment };
        const urlSlug = !projectId ? `idea/${ideaId}/complete` :
            `masterprojects/${projectId}/idea/${ideaId}/complete`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete a task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeTask(projectId, ideaId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/complete-task` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/complete-task`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete an Attachment task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeAttachmentTask(projectId, ideaId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/complete-attachment` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/complete-attachment`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete a text task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeTextTask(projectId, ideaId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/complete-text` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/complete-text`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Confirm schedule of a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    confirmSchedule(projectId, ideaId, phaseId, taskId, startDate, endDate, ownerId, comment, privateComment) {
        let request = {
            comment: comment,
            startDate: startDate,
            endDate: endDate,
            ownerId: ownerId,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/confirmschedule` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/confirmschedule`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Converts an existing ideation project into a production that contains the existing ideation stages.
     * @param ideaId
     * @param comment
     * @param productionName
     * @param startDate
     * @param endDate
     * @param productDefinitionId
     * @param workOwnerId
     * @param approvalOwnerId
     * @param hasApproval
     * @param dependantOnPhaseId
     */
    convertToProduction(projectId, ideaId, comment, productionName, startDate, endDate, productDefinitionId, workOwnerId, approvalOwnerId, hasApproval = true, dependentOnPhaseId, defaultStageName) {
        let request = {
            comment: comment,
            productionName: productionName,
            startDate: startDate,
            endDate: endDate,
            productDefinitionId: productDefinitionId,
            workOwnerId: workOwnerId,
            approvalOwnerId: approvalOwnerId,
            hasApproval: hasApproval,
            dependentOnPhaseId: dependentOnPhaseId,
            defaultStageName: defaultStageName,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/convert` :
            `masterprojects/${projectId}/idea/${ideaId}/convert`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a new idea
     * @param name
     * @param templateId
     */
    createIdea(projectId, name, templateId, campaignId, date) {
        let request = {
            name: name,
            templateId: templateId,
            campaignId: campaignId,
            date: date,
        };
        const urlSlug = !projectId ? `idea` :
            `masterprojects/${projectId}/idea`;
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Delete an idea project
     * @param ideaId
     */
    delete(projectId, ideaId) {
        const urlSlug = !projectId ? `idea/${ideaId}` :
            `masterprojects/${projectId}/idea/${ideaId}`;
        return this.http.delete(`${this.config.atlasApiEndpoint}/api/${urlSlug}`)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove associate to an existing campaign to the production
     * @param productionId
     * @param name
     * @param templateId
     * @param comment
     */
    deSelectCampaign(projectId, ideaId, comment) {
        let request = {
            campaignId: undefined,
            comment: comment,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/deselectcampaign` :
            `masterprojects/${projectId}/idea/${ideaId}/deselectcampaign`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /***
     * Get's an idea from the api, whilst also subsribing to the websocket refresh topic, and using a merge cache strategy
     */
    getIdea(ideaId, options) {
        return this.websocket.smartApiWrapper(`/idea/${ideaId}`, `/idea/${ideaId}`, options || new SmartWrapperOptions(1, false));
    }
    /***
     * Get's an idea from the api, whilst also subsribing to the websocket refresh topic, and using a merge cache strategy
     */
    getIdeaWithMessages(ideaId, options) {
        return this.websocket.smartApiWrapper(`/idea/${ideaId}/withmessages`, `/idea/${ideaId}`, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get all assets for an idea.
     * @param ideaId
     */
    getIdeaAssets(ideaId, options) {
        return this.websocket.smartApiWrapper(`/idea/${ideaId}/assets`, `/idea/${ideaId}/assets`, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get the phase details of an idea.
     * @param ideaId
     * @param phaseId
     */
    getPhaseDetails(ideaId, phaseId, options) {
        return this.websocket.smartApiWrapper(`/idea/${ideaId}/phase/${phaseId}`, `/idea/${ideaId}/phase/${phaseId}`, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Hold an idea project
     * @param ideaId
     * @param phaseId
     */
    hold(projectId, ideaId, phaseId, comment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/hold` :
            `masterprojects/${projectId}/idea/${ideaId}/hold`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
    * Link a file url to the idea thread.
    * @param ideaId
    * @param phaseId
    * @param url
    */
    linkFile(projectId, ideaId, phaseId, url, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            fileUrl: url,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/upload-link` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/upload-link`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * List all ideas on the current feed and using a merge cache strategy
     * @param page
     * @param pageSize
     * @param workStatusTypeIds
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listIdeas(page, pageSize, feedIds, workStatusTypeIds, fromDate, toDate, ownerId, orderByCriteria, campaignIds, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (workStatusTypeIds)
            params = params.set('workStatuses', workStatusTypeIds.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/idea?${params.toString()}`;
        const results = this.websocket.smartApiWrapper(urlSlug, 'ideas', options || new SmartWrapperOptions(8, false, true));
        return results;
    }
    /**
     * List all ideas on the current feed and using a merge cache strategy
     * @param page
     * @param pageSize
     * @param workStatusTypeIds
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listIdeaStages(page, pageSize, feedIds, workStatusTypeIds, fromDate, toDate, ownerId, orderByCriteria, campaignIds, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (workStatusTypeIds)
            params = params.set('workStatuses', workStatusTypeIds.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/idea/stages?${params.toString()}`;
        const results = this.websocket.smartApiWrapper(urlSlug, 'ideas', options || new SmartWrapperOptions(8, false, true));
        return results;
    }
    /**
     * List all ideas on the current feed and using a merge cache strategy
     * @param page
     * @param pageSize
     * @param workStatusTypeIds
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listIdeasWithMessages(page, pageSize, feedIds, workStatusTypeIds, fromDate, toDate, ownerId, orderByCriteria, campaignIds, contentTypeIds, tagIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (workStatusTypeIds)
            params = params.set('workStatuses', workStatusTypeIds.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/idea/withmessages?${params.toString()}`;
        const results = this.websocket.smartApiWrapper(urlSlug, 'ideas', options || new SmartWrapperOptions(8, false, true));
        return results;
    }
    /**
     * List all messages for an idea.
     * @param ideaId
     * @param phaseId
     * @param page
     * @param pageSize
     */
    listMessages(ideaId, phaseId, page, pageSize, options) {
        const urlSlug = phaseId ? `/idea/${ideaId}/phase/${phaseId}/messages` : `/idea/${ideaId}/messages`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, options || new SmartWrapperOptions(8, false));
    }
    /**
     * List templates
     * @param productType - should be 'ProductChild' or 'ProductHead'
     */
    listTemplates(productType, options) {
        let params = new HttpParams();
        params = params.set('productType', productType.toString());
        // formal url slug
        const urlSlug = `/idea/templates?${params.toString()}`;
        const socketTopic = `/idea/templates`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(500, false, true));
    }
    /**
     * Lock a task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    lock(projectId, ideaId, phaseId, taskId, lockStart, lockEnd, lockUnits, comment, privateComment) {
        let request = {
            comment: comment,
            lockStart: lockStart,
            lockEnd: lockEnd,
            lockUnits: lockUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/lock` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/lock`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Poke a task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    poke(projectId, ideaId, phaseId, taskId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/poke` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/poke`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename an idea.
     * @param ideaId
     * @param name
     * @param phaseId
     */
    renameProject(projectId, ideaId, name, phaseId) {
        let request = { name: name, phaseId: phaseId };
        const urlSlug = !projectId ? `idea/${ideaId}/renameproject` :
            `masterprojects/${projectId}/idea/${ideaId}/renameproject`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename an idea thread.
     * @param ideaId
     * @param phaseId
     * @param name
     */
    renameThread(projectId, ideaId, phaseId, name) {
        let request = { name: name };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/renamethread` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/renamethread`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Reject an approval.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    rejectApproval(projectId, ideaId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/rejectapproval` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/rejectapproval`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove an existing approval task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     */
    removeApproval(projectId, ideaId, phaseId, taskId) {
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/removeapproval` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/removeapproval`;
        return this.http.delete(`${this.config.atlasApiEndpoint}/api/${urlSlug}`)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove an attachment from an idea.
     * @param ideaId
     * @param assetSetId
     * @param comment
     */
    removeAttachment(projectId, ideaId, assetSetId, assetFileId, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/removeattachment` :
            `masterprojects/${projectId}/idea/${ideaId}/removeattachment`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove a text from an idea.
     * @param ideaId
     * @param textSetId
     * @param comment
     */
    removeText(projectId, ideaId, textSetId, comment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/removetext` :
            `masterprojects/${projectId}/idea/${ideaId}/removetext`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove an idea stage.
     * @param ideaId
     * @param phaseId
     */
    removeThread(projectId, ideaId, phaseId, comment) {
        let request = {
            comment: comment,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/remove` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/remove`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename an attachment from an idea.
     * @param ideaId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameAttachment(projectId, ideaId, assetSetId, assetFileId, newName, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            name: newName
        };
        const urlSlug = !projectId ? `idea/${ideaId}/renameattachment` :
            `masterprojects/${projectId}/idea/${ideaId}/renameattachment`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a text from an idea.
     * @param ideaId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameText(projectId, ideaId, textSetId, newName, comment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            name: newName
        };
        const urlSlug = !projectId ? `idea/${ideaId}/renametext` :
            `masterprojects/${projectId}/idea/${ideaId}/renametext`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a task.
     * @param ideaId
     * @param newName
     * @param phaseId
     */
    renameTask(projectId, ideaId, phaseId, taskId, newName) {
        let request = {
            name: newName,
            comment: null
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/rename` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/rename`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Reset a task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    reset(projectId, ideaId, phaseId, taskId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/reset` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/reset`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Resume an idea project
     * @param ideaId
     * @param phaseId
     */
    resume(projectId, ideaId, phaseId, comment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/resume` :
            `masterprojects/${projectId}/idea/${ideaId}/resume`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Request approval from the active idea conversation task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     * @param approverOwnerId
     */
    requestApproval(projectId, ideaId, phaseId, taskId, comment, approverOwnerId) {
        let request = {
            comment: comment,
            ownerId: approverOwnerId,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/requestapproval` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/requestapproval`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Request the upload of a binary file to the asset system.
     * @param ideaId
     * @param phaseId
     * @param filename
     * @param fileType
     * @param fileSizeInBytes
     */
    requestUpload(projectId, ideaId, phaseId, filename, fileType, fileSizeInBytes, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            filename: filename,
            fileType: fileType,
            fileSizeInBytes: fileSizeInBytes,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/upload` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/upload`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
       * Assoiate an existing campaign to the idea
       * @param ideaId
       * @param name
       * @param templateId
       * @param comment
       */
    selectCampaign(projectId, ideaId, campaignId, comment) {
        let request = {
            campaignId: campaignId,
            comment: comment,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/selectcampaign` :
            `masterprojects/${projectId}/idea/${ideaId}/selectcampaign`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Start a task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    startTask(projectId, ideaId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/start-task` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/start-task`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete a select text set task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    selectTextSet(projectId, ideaId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/select-text-set` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/select-text-set`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Start an attachment task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    startAttachmentTask(projectId, ideaId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/start-attachment` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/start-attachment`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Start a text task.
     * @param ideaId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    startTextTask(projectId, ideaId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/start-text` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/start-text`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Switch the dependency of a idea phase or idea head.
     * @param ideaId
     * @param phaseId
     * @param dependentOnPhaseId
     * @param dueDate
     * @param comment
     */
    switchDependency(projectId, ideaId, phaseId, dependentOnPhaseId, dueDate, comment) {
        let request = {
            dependentOnPhaseId: dependentOnPhaseId,
            dueDate: dueDate,
            comment: comment
        };
        // idea head specific
        if (phaseId === undefined) {
            const urlSlug = !projectId ? `idea/${ideaId}/switchdependency` :
                `masterprojects/${projectId}/idea/${ideaId}/switchdependency`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        // phase specific
        else {
            const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/switchdependency` :
                `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/switchdependency`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Mark a task as tobescheduled.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    toBeScheduled(projectId, ideaId, phaseId, taskId, hold = false, comment, privateComment) {
        let request = {
            comment: comment,
            type: hold === true ? { id: "ScheduleHold", displayName: "Schedule Hold" } : { id: "Schedule", displayName: "Schedule" },
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/tobescheduled` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/tobescheduled`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Trim the units of a production.
     * @param ideaId
     * @param comment
     */
    trimUnits(projectId, ideaId, phaseId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        let urlSlug = '';
        if (projectId) {
            urlSlug += `/masterprojects/${projectId}`;
        }
        urlSlug += `/idea/${ideaId}`;
        if (phaseId) {
            urlSlug += `/phase/${phaseId}`;
        }
        urlSlug += `/trimunits`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * update the tags on an idea.
     * @param ideaId
     * @param comment
     * @param existingTagIdsToAdd
     * @param existingTagIdsToRemove
     * @param newTagNamesToCreateAndAdd
     * @param phaseId
     */
    updateTags(projectId, ideaId, comment, existingTagIdsToAdd, existingTagIdsToRemove, newTagNamesToCreateAndAdd, phaseId) {
        let request = {
            comment: comment,
            existingTagIdsToAdd: existingTagIdsToAdd,
            existingTagIdsToRemove: existingTagIdsToRemove,
            newTagNamesToCreateAndAdd: newTagNamesToCreateAndAdd,
            phaseId: phaseId,
        };
        const urlSlug = !projectId ? `idea/${ideaId}/updatetags` :
            `masterprojects/${projectId}/idea/${ideaId}/updatetags`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    getExtension(fileName) {
        let split = fileName.split('.'); // Split by dot
        return split.pop();
    }
    /**
     * Upload a binary file.
     * @param ideaId
     * @param phaseId
     * @param file
     */
    uploadFile(projectId, ideaId, phaseId, file, feedId, organizationId, assetSetId, assetFileId) {
        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
        let safeFileName = file.name.replace("&", "_");
        let ext = this.getExtension(file.name);
        return this.assetFileService.GetMimeTypeForFile(file).pipe(switchMap((fileTypeResult) => {
            let fileType;
            if (fileTypeResult == null) {
                if (file.type == null) {
                    fileType = new FileContentType(ext, "application/octet-stream"); // Been unable to sniff content type - treat as unknown binary with ext that was provided.
                }
                else {
                    fileType = new FileContentType(ext, file.type);
                }
            }
            else {
                // CFB hack
                if (fileTypeResult.mime == "application/x-cfb") {
                    // CFB is the only file type that we can't properly sniff, all we know is it's a legacy office type (doc, xls etc)
                    // As it's legacy it's not worth putting too much effort in, so we'll just assume its valid and use the provided ext (not the sniffed ext which will be .cfb) to determine the type.
                    if (ext == "doc") {
                        fileType = new FileContentType(ext, "application/msword");
                    }
                    else if (ext == "xls") {
                        fileType = new FileContentType(ext, "application/vnd.ms-excel");
                    }
                    else if (ext == "ppt" || ext == "pps") {
                        fileType = new FileContentType(ext, "application/vnd.ms-powerpoint");
                    }
                    else {
                        fileType = new FileContentType(ext, file.type);
                    }
                }
                else {
                    fileType = new FileContentType(fileTypeResult.ext, fileTypeResult.mime); // Breaking dependency on File-Type library.
                }
            }
            return this.requestUpload(projectId, ideaId, phaseId, safeFileName, fileType, file.size, feedId, organizationId, assetSetId, assetFileId).pipe(switchMap((response) => {
                return this.assetFileService.BucketUploadAsync(response.assetFileId, response.awsUrl, file).pipe(switchMap((uploadResponse) => {
                    if (uploadResponse.status === 200) {
                        return this.assetsService.uploadSuccess(response.assetFileId, safeFileName, fileType, file.size).pipe(map((uploadSuccessResponse) => {
                            // We're now uploaded and told Assets the file is uploaded.
                            return new PlatformUploadResponse(uploadSuccessResponse, uploadResponse.progress, false, true);
                        }));
                    }
                    else if (uploadResponse.status == null && uploadResponse.progress > 0) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, true, false));
                    }
                    else if (uploadResponse instanceof HttpErrorResponse) {
                        return of(new PlatformUploadResponse(null, null, false, false));
                    }
                    // We could be waiting for the first response from the server, so return a progress update.
                    return of(new PlatformUploadResponse(null, 0, true, false));
                }));
            }), catchError(AtlasSharedService.handleError()));
        }));
    }
    /**
     *
     * @param projectId
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param textSetId
     * @param textSetName
     * @param textSetDefinitionId
     * @param textSetVersion
     * @param comment
     * @param privateComment
     * @returns
     */
    updateText(projectId, ideaId, phaseId, taskId, textSetId, textSetName, textSetDefinitionId, textSetVersion, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            name: textSetName,
            textSetDefinitionId: textSetDefinitionId,
            version: textSetVersion,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `idea/${ideaId}/phase/${phaseId}/task/${taskId}/update-text` :
            `masterprojects/${projectId}/idea/${ideaId}/phase/${phaseId}/task/${taskId}/update-text`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
IdeationService.ɵfac = function IdeationService_Factory(t) { return new (t || IdeationService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
IdeationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IdeationService, factory: IdeationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IdeationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class MasterProjectsService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, jsonDecryptEncrypt, websocket, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * Add an idea to the master project.
     * @param projectId
     * @param stageName
     * @param productDefinitionId
     * @param comment
     * @param startDate
     * @param endDate
     * @param dependentOnPhaseId
     */
    addIdea(projectId, name, templateId, comment, date, dependentOnPhaseId, units, roles) {
        let request = {
            comment: comment,
            templateId: templateId,
            name: name,
            date: date,
            dependentOnPhaseId: dependentOnPhaseId,
            units: units,
            roles: roles,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/addidea`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add a production to the master project.
     * @param projectId
     * @param stageName
     * @param productDefinitionId
     * @param comment
     * @param startDate
     * @param endDate
     * @param dependantOnPhaseId
     */
    addProduction(projectId, name, templateId, comment, startDate, endDate, dependentOnPhaseId, units, roles) {
        let request = {
            comment: comment,
            templateId: templateId,
            name: name,
            startDate: startDate,
            endDate: endDate,
            dependentOnPhaseId: dependentOnPhaseId,
            units: units,
            roles: roles,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/addproduction`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add a publish to the master project.
     * @param projectId
     * @param stageName
     * @param productDefinitionId
     * @param comment
     * @param startDate
     * @param endDate
     * @param dependantOnPhaseId
     */
    addPublish(projectId, name, templateId, comment, startDate, endDate, dependentOnPhaseId, units, roles) {
        let request = {
            comment: comment,
            templateId: templateId,
            name: name,
            startDate: startDate,
            endDate: endDate,
            dependentOnPhaseId: dependentOnPhaseId,
            units: units,
            roles: roles,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/addpublish`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Cancel a production project
     * @param projectId
     * @param phaseId
     */
    cancel(projectId, phaseId, comment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/cancel`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the owner of a production.
     * @param projectId
     * @param ownerId
     * @param phaseId
     */
    changeOwner(projectId, ownerId, phaseId, comment) {
        let request = {
            ownerId: ownerId,
            phaseId: phaseId,
            comment: comment
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/changeowner`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change access level.
     * @param projectId
     * @param accessLevel
     */
    changeAccessLevel(projectId, accessLevel, comment) {
        let request = {
            accessLevel: accessLevel === 'Private' ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            comment: comment
        };
        const urlSlug = `masterprojects/${projectId}/changeaccesslevel`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the production contribtors.
     * @param projectId
     * @param contributorOwnerIdAdditions
     * @param contributorOwnerIdRemovals
     * @param phaseId
     */
    changeContributors(projectId, contributorOwnerIdAdditions, contributorOwnerIdRemovals, phaseId) {
        let request = { contributorOwnerIdAdditions: contributorOwnerIdAdditions, contributorOwnerIdRemovals: contributorOwnerIdRemovals, phaseId: phaseId };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/changecontributors`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the production dates.
     * @param projectId
     * @param startDate
     * @param dueDate
     */
    changeDates(projectId, startDate, dueDate, comment, privateComment) {
        let request = {
            startDate: startDate,
            dueDate: dueDate,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/changedates`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the target product type of the idea.
     * @param projectId
     * @param productTypeTagId
     * @param phaseId
     */
    changeProductType(projectId, productTypeTagId, phaseId, comment) {
        let request = {
            productTypeTagId: productTypeTagId,
            phaseId: phaseId,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/changeproducttype`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change roles.
     * @param projectId
     * @param roles
     */
    changeRoles(projectId, roles, comment, privateComment) {
        let request = {
            roles: roles,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/changeroles`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change units.
     * @param projectId
     * @param units
     */
    changeUnits(projectId, units, comment) {
        let request = { units: units, comment: comment };
        const urlSlug = `masterprojects/${projectId}/changeunits`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a new project
     * @param name
     * @param templateId
     */
    createProject(organizationId, name, templateId, date, comment, campaignId, existingTagIdsToAdd, newTagNamesToCreateAndAdd, feedId, startDate, roles) {
        let request = {
            name: name,
            feedId: feedId,
            templateId: templateId,
            dueDate: date,
            startDate: startDate,
            comment: comment,
            campaignId: campaignId,
            assets: [],
            existingTagIdsToAdd: existingTagIdsToAdd,
            newTagNamesToCreateAndAdd: newTagNamesToCreateAndAdd,
            roles: roles,
        };
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/masterprojects/${organizationId}`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a production using a full placeholder line.
     * @param name
     * @param templateId
     */
    createFull(parentId, phaseId, request, comment, privateComment) {
        request.comment = comment;
        request.commentAccessLevel = privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' };
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/masterprojects/${parentId}/phases/${phaseId}/createfull`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a single production within a multi placeholder line.
     * @param name
     * @param templateId
     */
    createSingle(parentId, phaseId, request, comment, privateComment) {
        request.comment = comment;
        request.commentAccessLevel = privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' };
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/masterprojects/${parentId}/phases/${phaseId}/createsingle`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create multiple productions within a multi placeholder line.
     * @param name
     * @param templateId
     */
    createMulti(parentId, phaseId, request, comment, privateComment) {
        request.comment = comment;
        request.commentAccessLevel = privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' };
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/masterprojects/${parentId}/phases/${phaseId}/createmulti`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Delete a production project
     * @param projectId
     */
    delete(projectId) {
        return this.http.delete(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}`)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove associate to an existing campaign to the production
     * @param projectId
     * @param name
     * @param templateId
     * @param comment
     */
    deSelectCampaign(projectId, comment) {
        let request = {
            campaignId: undefined,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/deselectcampaign`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Get's the head details of a production project
     * @param productionProjectId
     */
    getProjectDetails(projectId, options) {
        return this.websocket.smartApiWrapper(`/masterprojects/${projectId}`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get's the assets for a project.
     * @param projectId
     */
    getProjectAssets(projectId, options) {
        return this.websocket.smartApiWrapper(`/masterprojects/${projectId}/assets`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get's the assets for a phase.
     * @param projectId
     * @param phaseId
     */
    getPhaseAssets(projectId, phaseId, options) {
        return this.websocket.smartApiWrapper(`/masterprojects/${projectId}/phase/${phaseId}/assets`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get the production phase.
     * @param projectId
     * @param phaseId
     */
    getPhase(projectId, phaseId, options) {
        return this.websocket.smartApiWrapper(`/masterprojects/${projectId}/phase/${phaseId}`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get the production phases.
     * @param projectId
     */
    getPhases(projectId, options) {
        return this.websocket.smartApiWrapper(`/masterprojects/${projectId}/phase`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Hold a production project
     * @param projectId
     * @param phaseId
     */
    hold(projectId, phaseId, comment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/hold`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * List all messages related to a project.
     * @param productionId
     * @param phaseId
     */
    listMessages(projectId, options) {
        return this.websocket.smartApiWrapper(`/masterprojects/${projectId}/messages`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * List productions
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listProjects(page = 1, pageSize = 10, feedIds, statuses, ownerIds, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, immediateParentIds, immediateParentPhaseIds, teamIds, loadDeep, loadAssets, taskStatuses, taskOwnerIds, taskTeamIds, taskModuleIds, managedOwnerIds, managedTeamIds, templateIds, baseTemplateIds, productClassIds, productVariantIds, text, industryCategory, industrySubCategory, accessLevel, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed id criteria
        if (feedIds)
            params = params.set('feedIds', feedIds);
        // status criteria
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // Parent filter
        if (immediateParentIds)
            params = params.set('immediateParentIds', immediateParentIds);
        // Parent Phase filter
        if (immediateParentPhaseIds)
            params = params.set('immediateParentPhaseIds', immediateParentPhaseIds);
        // Teams filter
        if (teamIds)
            params = params.set('teamIds', teamIds);
        // deep load or not
        if (loadDeep)
            params = params.set('loadDeep', loadDeep.toString());
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // load assets or not
        if (loadAssets)
            params = params.set('loadAssets', loadAssets.toString());
        // filter by status of some child tasks
        if (taskStatuses)
            params = params.set('taskStatuses', taskStatuses.toString());
        // filter by ownership of some child tasks
        if (taskOwnerIds)
            params = params.set('taskOwnerIds', taskOwnerIds.toString());
        // filter by team ownnership of some child tasks
        if (taskTeamIds)
            params = params.set('taskTeamIds', taskTeamIds.toString());
        // filter by modules of some child tasks
        if (taskModuleIds)
            params = params.set('taskModuleIds', taskModuleIds.toString());
        // ancestor owner id criteria
        if (managedOwnerIds)
            params = params.set('managedOwnerIds', managedOwnerIds);
        // ancestor team id criteria
        if (managedTeamIds)
            params = params.set('managedTeamIds', managedTeamIds);
        // template ids criteria
        if (templateIds)
            params = params.set('templateIds', templateIds);
        // product ids criteria
        if (baseTemplateIds)
            params = params.set('productIds', baseTemplateIds);
        // product class ids criteria
        if (productClassIds)
            params = params.set('productClassIds', productClassIds);
        // product variant ids criteria
        if (productVariantIds)
            params = params.set('productVariantIds', productVariantIds);
        // text search
        if (text && text.length > 0)
            params = params.set('text', text);
        // industry category search
        if (industryCategory && industryCategory.length > 0)
            params = params.set('industryCategory', industryCategory);
        // industry sub-category search
        if (industrySubCategory && industrySubCategory.length > 0)
            params = params.set('industrySubCategory', industrySubCategory);
        // acecss level
        if (accessLevel)
            params = params.set('accessLevel', accessLevel);
        // formal url slug
        const urlSlug = `/masterprojects?${params.toString()}`;
        const socketTopic = `/masterprojects`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true, undefined, 10000));
    }
    /**
     * List spaces
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listSpaces(page = 1, pageSize = 10, feedIds, moduleIds, statuses, ownerIds, spaceTypes, fromDate, toDate, fromDueDate, toDueDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, teamIds, loadDeep, loadAssets, mustBeInMaster, taskStatuses, taskOwnerIds, taskTeamIds, taskModuleIds, managedOwnerIds, managedTeamIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed id criteria
        if (feedIds)
            params = params.set('feedIds', feedIds);
        // module id criteria
        if (moduleIds)
            params = params.set('moduleIds', moduleIds);
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (spaceTypes)
            params = params.set('spaceTypes', spaceTypes.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        if (fromDueDate)
            // convert to unix epoch time and string
            params = params.set('fromDueDate', fromDueDate.valueOf().toString());
        if (toDueDate)
            // convert to unix epoch time and string
            params = params.set('toDueDate', toDueDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // Teams filter
        if (teamIds)
            params = params.set('teamIds', teamIds);
        // deep load or not
        if (loadDeep)
            params = params.set('loadDeep', loadDeep.toString());
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // load assets or not
        if (loadAssets !== undefined)
            params = params.set('loadAssets', loadAssets.toString());
        // filter on in master or not
        if (mustBeInMaster !== undefined)
            params = params.set('mustBeInMaster', mustBeInMaster.toString());
        // filter by status of some child tasks
        if (taskStatuses)
            params = params.set('taskStatuses', taskStatuses.toString());
        // filter by ownership of some child tasks
        if (taskOwnerIds)
            params = params.set('taskOwnerIds', taskOwnerIds.toString());
        // filter by team ownnership of some child tasks
        if (taskTeamIds)
            params = params.set('taskTeamIds', taskTeamIds.toString());
        // filter by modules of some child tasks
        if (taskModuleIds)
            params = params.set('taskModuleIds', taskModuleIds.toString());
        // ancestor owner id criteria
        if (managedOwnerIds)
            params = params.set('managedOwnerIds', managedOwnerIds);
        // ancestor team id criteria
        if (managedTeamIds)
            params = params.set('managedTeamIds', managedTeamIds);
        // formal url slug
        const urlSlug = `/masterprojects/spaces?${params.toString()}`;
        const socketTopic = `/spaces`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * List stages
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listStages(projectId, page = 1, pageSize = 10, feedIds, moduleIds, statuses, ownerIds, spaceTypes, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, teamIds, loadDeep, loadAssets, managedOwnerIds, managedTeamIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed id criteria
        if (feedIds)
            params = params.set('feedIds', feedIds);
        // module id criteria
        if (moduleIds)
            params = params.set('moduleIds', moduleIds);
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (spaceTypes)
            params = params.set('spaceTypes', spaceTypes.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // Teams filter
        if (teamIds)
            params = params.set('teamIds', teamIds);
        // deep load or not
        if (loadDeep)
            params = params.set('loadDeep', loadDeep.toString());
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // load assets or not
        if (loadAssets)
            params = params.set('loadAssets', loadAssets.toString());
        // ancestor owner id criteria
        if (managedOwnerIds)
            params = params.set('managedOwnerIds', managedOwnerIds);
        // ancestor team id criteria
        if (managedTeamIds)
            params = params.set('managedTeamIds', managedTeamIds);
        // formal url slug
        const urlSlug = projectId ? `/masterprojects/${projectId}/stages?${params.toString()}` : `/masterprojects/stages?${params.toString()}`;
        const socketTopic = projectId ? `/masterprojects/${projectId}/stages` : `/tasks`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * List tasks
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listTasks(projectId, page = 1, pageSize = 10, feedIds, moduleIds, statuses, ownerIds, spaceTypes, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, teamIds, loadAssets, managedOwnerIds, managedTeamIds, unitType, templateIds, baseTemplateIds, hasUnits, text, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed id criteria
        if (feedIds)
            params = params.set('feedIds', feedIds);
        // module id criteria
        if (moduleIds)
            params = params.set('moduleIds', moduleIds);
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (spaceTypes)
            params = params.set('spaceTypes', spaceTypes.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // Teams filter
        if (teamIds)
            params = params.set('teamIds', teamIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // load assets or not
        if (loadAssets)
            params = params.set('loadAssets', loadAssets.toString());
        // ancestor owner id criteria
        if (managedOwnerIds)
            params = params.set('managedOwnerIds', managedOwnerIds);
        // ancestor team id criteria
        if (managedTeamIds)
            params = params.set('managedTeamIds', managedTeamIds);
        // unitType
        if (unitType)
            params = params.set('unitType', unitType);
        // template ids criteria
        if (templateIds)
            params = params.set('templateIds', templateIds);
        // product ids criteria
        if (baseTemplateIds)
            params = params.set('baseTemplateIds', baseTemplateIds);
        // hasUnits
        if (hasUnits)
            params = params.set('hasUnits', hasUnits.toString());
        // text search
        if (text && text.length > 0)
            params = params.set('text', text);
        // formal url slug
        const urlSlug = projectId ? `/masterprojects/${projectId}/tasks?${params.toString()}` : `/masterprojects/tasks?${params.toString()}`;
        const socketTopic = projectId ? `/masterprojects/${projectId}/tasks` : `/tasks`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * List templates
     */
    listTemplates(feedId, options) {
        let params = new HttpParams();
        if (feedId)
            params = params.set('feedId', feedId.toString());
        // formal url slug
        const urlSlug = `/masterprojects/templates?${params.toString()}`;
        const socketTopic = `/masterprojects/templates?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(500, false, true));
    }
    /**
     * Rename a production.
     * @param projectId
     * @param newName
     * @param phaseId
     */
    renameProject(projectId, newName, phaseId) {
        let request = {
            name: newName,
            phaseId: phaseId,
            comment: null
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/rename`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Resume a production project
     * @param projectId
     * @param phaseId
     */
    resume(projectId, phaseId, comment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/resume`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Assoiate an existing campaign to the production
     * @param projectId
     * @param name
     * @param templateId
     * @param comment
     */
    selectCampaign(projectId, campaignId, comment) {
        let request = {
            campaignId: campaignId,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/selectcampaign`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
       * Get the space-type totals.
       */
    spaceTotals(options) {
        return this.websocket.smartApiWrapper(`/masterprojects/spacetotals`, `spaces`, options || new SmartWrapperOptions(2, false, true));
    }
    /**
       * Get the status-type totals.
       */
    statusTotals(options) {
        return this.websocket.smartApiWrapper(`/masterprojects/statustotals`, `spaces`, options || new SmartWrapperOptions(2, false, true));
    }
    /**
     * transfer a contractline to another sow.
     * @param productionId
     * @param comment
     */
    transferContractLine(sourceSowId, contractLineId, targetSowId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            targetSOWId: targetSowId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/masterprojects/${sourceSowId}/contractlines/${contractLineId}/transfer`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Trim units.
     * @param projectId
     * @param units
     */
    trimUnits(projectId, comment) {
        let request = { comment: comment };
        const urlSlug = `masterprojects/${projectId}/trimunits`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * update the tags on a production.
     * @param projectId
     * @param comment
     * @param existingTagIdsToAdd
     * @param existingTagIdsToRemove
     * @param newTagNamesToCreateAndAdd
     * @param phaseId
     */
    updateTags(projectId, comment, existingTagIdsToAdd, existingTagIdsToRemove, newTagNamesToCreateAndAdd, phaseId) {
        let request = {
            comment: comment,
            existingTagIdsToAdd: existingTagIdsToAdd,
            existingTagIdsToRemove: existingTagIdsToRemove,
            newTagNamesToCreateAndAdd: newTagNamesToCreateAndAdd,
            phaseId: phaseId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/masterprojects/${projectId}/updatetags`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
MasterProjectsService.ɵfac = function MasterProjectsService_Factory(t) { return new (t || MasterProjectsService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
MasterProjectsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MasterProjectsService, factory: MasterProjectsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MasterProjectsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class OrganizationsService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(feedService, http, websocket, assetFileService, assetsService, config) {
        this.feedService = feedService;
        this.http = http;
        this.websocket = websocket;
        this.assetFileService = assetFileService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    addAttachment(organizationId, assetSetId, assetFileId, filename, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            filename: filename,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/addattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add a textset to a org.
     * @param productionId
     * @param phaseId
     * @param templateId
     * @param name
     * @param accessPublic
     * @param comment
     */
    addText(organizationId, templateId, name, accessPublic, comment, privateComment) {
        let request = {
            templateId: templateId,
            accessType: accessPublic === true ? { id: 'Public', name: 'Public' } : { id: 'Private', name: 'Private' },
            name: name,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/addtext`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    // public addSOW(organizationId: string, salesforceAssetId: string, startDate: Date, endDate: Date, sowName: string, units: number, sowDocumentUrl?: string, roles?: RoleHintRequest[], comment?: string): Observable<ProjectStub> {
    //   let request: CreateNewSOWRequest = {
    //     salesforceAssetId: salesforceAssetId,
    //     startDate: startDate,
    //     endDate: endDate,
    //     sowName: sowName,
    //     sowDocumentHyperlink: sowDocumentUrl,
    //     totalUnits: units,
    //     roles: roles,
    //     comment: comment,
    //   };
    //
    //   return this.http.post<ProjectStub>(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/createsow`, request)
    //     .pipe(
    //       catchError(
    //         AtlasSharedService.handleError<ProjectStub>()
    //       )
    //     );
    // }
    /**
     * Create a new SOW
     */
    addSOW(organizationId, hubspotSOWId, startDate, endDate, sowName, units, sowDocumentUrl, roles, comment) {
        let request = {
            hubSpotSOWId: hubspotSOWId,
            startDate: startDate,
            endDate: endDate,
            sowName: sowName,
            sowDocumentHyperlink: sowDocumentUrl,
            totalUnits: units,
            roles: roles,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/createsow`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a new org generically.
     * @param name
     * @param accountOwnerId
     * @param region
     * @param fullLicenses
     * @param partialLicenses
     * @param comment
     */
    createOrganization(name, accountOwnerId, region, fullLicenses, partialLicenses, comment) {
        let request = {
            name: name,
            accountManagerProfileId: accountOwnerId,
            fullPlatformLicenses: fullLicenses,
            partialPlatformLicenses: partialLicenses,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/organizations`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a new org from a specific salesforce account id.
     * @param salesforceAccountId
     * @param name
     * @param accountOwnerId
     * @param fullLicenses
     * @param partialLicenses
     * @param comment
     */
    createOrganizationFromSalesforce(salesforceAccountId, name, accountOwnerId, fullLicenses, partialLicenses, comment) {
        let request = {
            salesforceAccountId: salesforceAccountId,
            name: name,
            accountManagerProfileId: accountOwnerId,
            fullPlatformLicenses: fullLicenses,
            partialPlatformLicenses: partialLicenses,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/organizations/createfromsalesforce`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a new org from a specific hubspot company id.
     * @param hubspotCompanyId
     * @param name
     * @param accountOwnerId
     * @param fullLicenses
     * @param partialLicenses
     * @param comment
     */
    createOrganizationFromHubSpot(hubspotCompanyId, name, accountOwnerId, fullLicenses, partialLicenses, comment) {
        let request = {
            hubSpotCompanyId: hubspotCompanyId,
            name: name,
            accountManagerProfileId: accountOwnerId,
            fullPlatformLicenses: fullLicenses,
            partialPlatformLicenses: partialLicenses,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/organizations/createfromhubspot`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change roles.
     * @param organizationId
     * @param roles
     */
    changeRoles(organizationId, roles, comment) {
        let request = {
            roles: roles,
            comment: comment
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/changeroles`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change Type.
     * @param organizationId
     * @param sowTypeId
     * @param comment
     */
    changeType(organizationId, orgTypeId, comment) {
        let request = {
            orgTemplateTypeId: orgTypeId,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/changetype`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change attachment access level.
     * @param organizationId
     * @param assetSetId
     * @param assetFileId
     * @param privateAsset
     * @param comment
     * @param privateComment
     */
    changeAttachmentAccessLevel(organizationId, assetSetId, assetFileId, accessLevel, comment, privateComment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            accessLevel: accessLevel,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/changeattachmentaccesslevel`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change text access level.
     * @param organizationId
     * @param textSetId
     * @param privateText
     * @param comment
     * @param privateComment
     */
    changeTextAccessLevel(organizationId, textSetId, accessLevel, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            accessLevel: accessLevel,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/changetextaccesslevel`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /***
    * Get's an idea from the api, whilst also subsribing to the websocket refresh topic, and using a merge cache strategy
    */
    getOrganization(id, options) {
        return this.websocket.smartApiWrapper(`/organizations/${id}`, `/organizations`, options || new SmartWrapperOptions(8, false, true));
    }
    /***
    * Get's an idea from the api, whilst also subsribing to the websocket refresh topic, and using a merge cache strategy
    */
    getOrganizationFromFeed(feedId, options) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        return this.websocket.smartApiWrapper(`/organizations/fromFeed?${params.toString()}`, `/organizations`, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * Get's the assets for a project.
     * @param productionId
     */
    getOrganizationAssets(options) {
        return this.websocket.smartApiWrapper(`/organizations/assets`, undefined, options || new SmartWrapperOptions(8, false, true));
    }
    /**
    * Link a file url to the content version.
    * @param contentId
    * @param versionId
    * @param url
    */
    linkFile(organizationId, url, feedId, assetSetId, assetFileId) {
        let request = {
            fileUrl: url,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/upload-link`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    // public listOrganizations(page: number = 1, pageSize: number = 10, feedIds?: string, statuses?: string, ownerIds?: string, salesforceAccountId?: string, options?: SmartWrapperOptions): Observable<IPagedList<Organization>> {
    //   let params = new HttpParams();
    //
    //   params = params.set('page', page.toString());
    //   params = params.set('pageSize', pageSize.toString());
    //
    //   // feed id criteria
    //   if (feedIds)
    //     params = params.set('feedIds', feedIds);
    //
    //   // status criteria
    //   if (statuses)
    //     params = params.set('statuses', statuses.toString());
    //
    //   // owner id criteria
    //   if (ownerIds)
    //     params = params.set('ownerIds', ownerIds);
    //
    //   // salesforce account id criteria
    //   if (salesforceAccountId)
    //     params = params.set('salesforceAccountId', salesforceAccountId);
    //
    //   // formal url slug
    //   const urlSlug = `/organizations?${params.toString()}`;
    //   const socketTopic = `/organizations`
    //
    //   return this.websocket.smartApiWrapper<IPagedList<Organization>>(
    //     urlSlug, socketTopic, options || new SmartWrapperOptions(8, false));
    // }
    listOrganizations(page = 1, pageSize = 10, feedIds, statuses, ownerIds, hubspotCompanyId, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed id criteria
        if (feedIds)
            params = params.set('feedIds', feedIds);
        // status criteria
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        // hubspot company id criteria
        if (hubspotCompanyId)
            params = params.set('hubspotCompanyId', hubspotCompanyId.toString());
        // formal url slug
        const urlSlug = `/organizations?${params.toString()}`;
        const socketTopic = `/organizations`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false));
    }
    listContributors(feedId, options) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        return this.websocket.smartApiWrapper(`/organizations/contributors?${params.toString()}`, undefined, options || new SmartWrapperOptions(8, false));
    }
    /**
     * List all messages related to the active user
     */
    listMessages(page = 1, pageSize = 10, organizationId, feedId, hasComment, affectedOwnerId, operatorId, affectedOwnerOrOperatorId, affectedOwnerOperatorOrDeliverableOwnerId, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed id criteria
        if (feedId)
            params = params.set('feedId', feedId.toString());
        // hasComment
        if (hasComment !== undefined)
            params = params.set('hasComment', hasComment.toString());
        // affectedOwnerId
        if (affectedOwnerId)
            params = params.set('affectedOwnerId', affectedOwnerId.toString());
        // operatorId
        if (operatorId)
            params = params.set('operatorId', operatorId.toString());
        // affectedOwnerOrOperatorId
        if (affectedOwnerOrOperatorId !== undefined)
            params = params.set('affectedOwnerOrOperatorId', affectedOwnerOrOperatorId.toString());
        // affectedOwnerOperatorOrDeliverableOwnerId
        if (affectedOwnerOperatorOrDeliverableOwnerId)
            params = params.set('affectedOwnerOperatorOrDeliverableOwnerId', affectedOwnerOperatorOrDeliverableOwnerId.toString());
        return this.websocket.smartApiWrapper(`/organizations/${organizationId}/messages?${params.toString()}`, `messages`, options || new SmartWrapperOptions(1, false, true));
    }
    /**
     * List salesforce assets on this organization.
     * @param organizationId
     */
    listSalesforceAssets(organizationId, sfAccountId) {
        if (organizationId)
            return this.websocket.smartApiWrapper(`/organizations/${organizationId}/salesforceassets`, undefined, new SmartWrapperOptions(8, false));
        else
            return this.websocket.smartApiWrapper(`/organizations/salesforceassets?sfAccountId=${sfAccountId}`, undefined, new SmartWrapperOptions(8, false));
    }
    /**
     * List salesforce accounts.
     * @param organizationId
     */
    listSalesforceAccounts(name, accountTypes) {
        let params = new HttpParams();
        params = params.set('name', name.toString());
        // account types
        if (accountTypes)
            params = params.set('accountTypes', accountTypes.toString());
        return this.websocket.smartApiWrapper(`/organizations/salesforceaccounts?${params.toString()}`, undefined, new SmartWrapperOptions(8, false));
    }
    listHubSpotAssets(organizationId, hsCompanyId) {
        if (organizationId)
            return this.websocket.smartApiWrapper(`/organizations/${organizationId}/hubspotassets`, undefined, new SmartWrapperOptions(8, false));
        else
            return this.websocket.smartApiWrapper(`/organizations/hubspotassets?hsCompanyId=${hsCompanyId}`, undefined, new SmartWrapperOptions(8, false));
    }
    /**
     * List HubSpot accounts.
     * @param organizationId
     */
    listHubSpotAccounts(name, accountTypes) {
        let params = new HttpParams();
        params = params.set('name', name.toString());
        // account types
        if (accountTypes)
            params = params.set('accountTypes', accountTypes.toString());
        return this.websocket.smartApiWrapper(`/organizations/hubspotaccounts?${params.toString()}`, undefined, new SmartWrapperOptions(8, false));
    }
    /**
     * List salesforce industry categories.
     * @param organizationId
     */
    listSalesforceIndustryCategories() {
        return this.websocket.smartApiWrapper(`/organizations/salesforceindustrycategories`, undefined, new SmartWrapperOptions(8, false));
    }
    /**
     * List salesforce sub-industry categories.
     * @param organizationId
     */
    listSalesforceSubIndustryCategories() {
        return this.websocket.smartApiWrapper(`/organizations/salesforceindustrysubcategories`, undefined, new SmartWrapperOptions(8, false));
    }
    /**
    * Get the organization object totals.
    */
    objectTotals(feedId, options) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        return this.websocket.smartApiWrapper(`/organizations/objecttotals?${params.toString()}`, `objecttotals`, options || new SmartWrapperOptions(2, false, true));
    }
    /**
     * Remove an attachment from a production.
     * @param productionId
     * @param assetSetId
     * @param comment
     */
    removeAttachment(organizationId, assetSetId, assetFileId, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${organizationId}/removeattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename an Organization
     * @param sowId
     * @param name
     * @param comment
     */
    rename(organizationId, name, comment) {
        let request = {
            comment: comment,
            name: name,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/rename`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename an attachment from a production.
     * @param organizationId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameAttachment(organizationId, assetSetId, assetFileId, newName, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            name: newName,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/renameattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove a text from a organization.
     * @param productionId
     * @param textSetId
     * @param comment
     */
    removeText(organizationId, textSetId, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/removetext`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a text from a organization.
     * @param contentId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameText(organizationId, textSetId, newName, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            name: newName,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/renametext`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Request the upload of a binary file to the asset system.
     * @param contentId
     * @param versionId
     * @param filename
     * @param fileType
     * @param fileSizeInBytes
     */
    requestUpload(organizationId, filename, fileType, fileSizeInBytes, feedId, assetSetId, assetFileId) {
        let request = {
            filename: filename,
            fileType: fileType,
            fileSizeInBytes: fileSizeInBytes,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/upload`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Update the platform license seats for an org.
     * @param organizationId
     * @param fullSeats
     * @param partialSeats
     */
    updateSeats(organizationId, fullSeats, partialSeats) {
        let request = {
            fullSeats: fullSeats,
            partialSeats: partialSeats,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/organizations/${organizationId}/updateseats`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Upload a binary file.
     * @param ideaId
     * @param phaseId
     * @param file
     */
    uploadFile(organizationId, file, feedId, assetSetId, assetFileId) {
        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
        let safeFileName = file.name.replace("&", "_");
        let ext = this.getExtension(file.name);
        return this.assetFileService.GetMimeTypeForFile(file).pipe(switchMap((fileTypeResult) => {
            let fileType;
            if (fileTypeResult == null) {
                if (file.type == null) {
                    fileType = new FileContentType(ext, "application/octet-stream"); // Been unable to sniff content type - treat as unknown binary with ext that was provided.
                }
                else {
                    fileType = new FileContentType(ext, file.type);
                }
            }
            else {
                // CFB hack
                if (fileTypeResult.mime == "application/x-cfb") {
                    // CFB is the only file type that we can't properly sniff, all we know is it's a legacy office type (doc, xls etc)
                    // As it's legacy it's not worth putting too much effort in, so we'll just assume its valid and use the provided ext (not the sniffed ext which will be .cfb) to determine the type.
                    if (ext == "doc") {
                        fileType = new FileContentType(ext, "application/msword");
                    }
                    else if (ext == "xls") {
                        fileType = new FileContentType(ext, "application/vnd.ms-excel");
                    }
                    else if (ext == "ppt" || ext == "pps") {
                        fileType = new FileContentType(ext, "application/vnd.ms-powerpoint");
                    }
                    else {
                        fileType = new FileContentType(ext, file.type);
                    }
                }
                else {
                    fileType = new FileContentType(fileTypeResult.ext, fileTypeResult.mime); // Breaking dependency on File-Type library.
                }
            }
            return this.requestUpload(organizationId, safeFileName, fileType, file.size, feedId, assetSetId, assetFileId).pipe(switchMap((response) => {
                return this.assetFileService.BucketUploadAsync(response.assetFileId, response.awsUrl, file).pipe(switchMap((uploadResponse) => {
                    if (uploadResponse.status === 200) {
                        return this.assetsService.uploadSuccess(response.assetFileId, safeFileName, fileType, file.size).pipe(map((uploadSuccessResponse) => {
                            // We're now uploaded and told Assets the file is uploaded.
                            return new PlatformUploadResponse(uploadSuccessResponse, uploadResponse.progress, false, true);
                        }));
                    }
                    else if (uploadResponse.status == null && uploadResponse.progress > 0) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, true, false));
                    }
                    else if (uploadResponse instanceof HttpErrorResponse) {
                        return of(new PlatformUploadResponse(null, null, false, false));
                    }
                    // We could be waiting for the first response from the server, so return a progress update.
                    return of(new PlatformUploadResponse(null, 0, true, false));
                }));
            }), catchError(AtlasSharedService.handleError()));
        }));
    }
    getExtension(fileName) {
        let split = fileName.split('.'); // Split by dot
        return split.pop();
    }
}
OrganizationsService.ɵfac = function OrganizationsService_Factory(t) { return new (t || OrganizationsService)(i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
OrganizationsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OrganizationsService, factory: OrganizationsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrganizationsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: FeedService }, { type: i3.HttpClient }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class PeopleService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, websocket, http, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.websocket = websocket;
        this.http = http;
        this.config = config;
        this.appName = 'platform-api';
        this.config = config;
    }
    listContributors(feedId, options) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        return this.websocket.smartApiWrapper(`/people/contributors?${params.toString()}`, undefined, options || new SmartWrapperOptions(8, false));
    }
    getPerson(id, options) {
        return this.websocket.smartApiWrapper(`/people/${id}`, undefined, options || new SmartWrapperOptions(8, false));
    }
    getAccountManager(feedId, options) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        return this.websocket.smartApiWrapper(`/people/account-manager?${params.toString()}`, undefined, options || new SmartWrapperOptions(8, false));
    }
    getProjectManager(feedId, options) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        return this.websocket.smartApiWrapper(`/people/project-manager?${params.toString()}`, undefined, options || new SmartWrapperOptions(8, false));
    }
}
PeopleService.ɵfac = function PeopleService_Factory(t) { return new (t || PeopleService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
PeopleService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PeopleService, factory: PeopleService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PeopleService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: WebsocketService }, { type: i3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class ProductionsService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, jsonDecryptEncrypt, websocket, assetFilesService, assetsService, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.assetFilesService = assetFilesService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * Accept an approval.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    acceptApproval(projectId, productionId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/acceptapproval` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/acceptapproval`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add an approval round.
     * @param productionId
     * @param phaseId
     * @param workTaskId
     * @param approverOwnerId
     * @param comment
     */
    addApproval(projectId, productionId, phaseId, workTaskId, approverOwnerId, comment, dueDate, privateComment) {
        let request = {
            comment: comment,
            ownerId: approverOwnerId,
            dependentTaskId: workTaskId,
            dueDate: dueDate,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${workTaskId}/addapproval` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${workTaskId}/addapproval`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add an attachment to the production stage.
     * @param productionId
     * @param phaseId
     * @param assetSetId
     * @param assetFileId
     * @param filename
     * @param comment
     */
    addAttachment(projectId, productionId, phaseId, assetSetId, assetFileId, filename, comment, privateComment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            filename: filename,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        if (phaseId) {
            const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/addattachment` :
                `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/addattachment`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        else {
            const urlSlug = !projectId ? `productions/${productionId}/addattachment` :
                `masterprojects/${projectId}/productions/${productionId}/addattachment`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Add an attachment placeholder to the production.
     * @param productionId
     * @param phaseId
     * @param templateId
     * @param name
     * @param accessPublic
     * @param comment
     */
    addAttachmentPlaceholder(projectId, productionId, phaseId, templateId, name, accessPublic, comment, privateComment) {
        let request = {
            templateId: templateId,
            accessType: accessPublic === true ? { id: 'Public', name: 'Public' } : { id: 'Private', name: 'Private' },
            name: name,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        if (phaseId) {
            const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/addattachmentplaceholder` :
                `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/addattachmentplaceholder`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        else {
            const urlSlug = !projectId ? `productions/${productionId}/addattachmentplaceholder` :
                `masterprojects/${projectId}/productions/${productionId}/addattachmentplaceholder`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Add a textset to a production.
     * @param productionId
     * @param phaseId
     * @param templateId
     * @param name
     * @param accessPublic
     * @param comment
     */
    addText(projectId, productionId, phaseId, templateId, name, accessPublic, comment, privateComment) {
        let request = {
            templateId: templateId,
            accessType: accessPublic === true ? { id: 'Public', name: 'Public' } : { id: 'Private', name: 'Private' },
            name: name,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        if (phaseId) {
            const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/addtext` :
                `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/addtext`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        else {
            const urlSlug = !projectId ? `productions/${productionId}/addtext` :
                `masterprojects/${projectId}/productions/${productionId}/addtext`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Add a comment to the production task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    addMessage(projectId, productionId, phaseId, taskId, comment, privateComment) {
        let request = {
            feedback: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/addmessage` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/addmessage`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add an ideation stage to the production project.
     * @param productionId
     * @param stageName
     * @param productDefinitionId
     * @param comment
     * @param startDate
     * @param endDate
     * @param dependentOnPhaseId
     */
    //public addIdeationStage(projectId: string | undefined, productionId: string, stageName: string, templateId: string, comment?: string, startDate?: Date, endDate?: Date, dependentOnPhaseId?: string, privateComment?: boolean): Observable<any> {
    //  let request: AddIdeationStageRequest = {
    //    comment: comment,
    //    templateId: templateId,
    //    stageName: stageName,
    //    startDate: startDate,
    //    endDate: endDate,
    //    dependentOnPhaseId: dependentOnPhaseId,
    //    approvalOwnerId: undefined,
    //    workOwnerId: undefined,
    //    hasApproval: false,
    //    commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
    //  };
    //  const urlSlug = !projectId ? `productions/${productionId}/addideationstage` :
    //    `masterprojects/${projectId}/productions/${productionId}/addideationstage`;
    //  return this.http.post<any>(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
    //    .pipe(
    //      catchError(
    //        AtlasSharedService.handleError<any>()
    //      )
    //    );
    //}
    /**
     * Add a production stage to the production project.
     * @param productionId
     * @param stageName
     * @param productDefinitionId
     * @param comment
     * @param startDate
     * @param endDate
     * @param workOwnerId
     * @param approvalOwnerId
     * @param hasApproval
     * @param dependantOnPhaseId
     */
    addProductionStage(projectId, productionId, stageName, productDefinitionId, comment, startDate, endDate, roles, dependentOnPhaseId, privateComment, units) {
        let request = {
            comment: comment,
            productDefinitionId: productDefinitionId,
            stageName: stageName,
            startDate: startDate,
            endDate: endDate,
            roles: roles,
            dependentOnPhaseId: dependentOnPhaseId,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            units: units,
        };
        const urlSlug = !projectId ? `productions/${productionId}/addproductionstage` :
            `masterprojects/${projectId}/productions/${productionId}/addproductionstage`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Assign a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    assignTask(projectId, productionId, phaseId, taskId, ownerId, comment, privateComment) {
        let request = {
            comment: comment,
            ownerId: ownerId,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/assign` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/assign`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Cancel a production project
     * @param productionId
     * @param phaseId
     */
    cancel(projectId, productionId, phaseId, comment, privateComment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/cancel` :
            `masterprojects/${projectId}/productions/${productionId}/cancel`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change attachment access level.
     * @param projectId
     * @param productionId
     * @param assetSetId
     * @param assetFileId
     * @param privateAsset
     * @param comment
     * @param privateComment
     */
    changeAttachmentAccessLevel(projectId, productionId, assetSetId, assetFileId, accessLevel, comment, privateComment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            accessLevel: accessLevel,
        };
        const urlSlug = !projectId ? `productions/${productionId}/changeattachmentaccesslevel` :
            `masterprojects/${projectId}/productions/${productionId}/changeattachmentaccesslevel`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change text access level.
     * @param projectId
     * @param productionId
     * @param assetSetId
     * @param assetFileId
     * @param privateAsset
     * @param comment
     * @param privateComment
     */
    changeTextAccessLevel(projectId, productionId, textSetId, accessLevel, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            accessLevel: accessLevel,
        };
        const urlSlug = !projectId ? `productions/${productionId}/changetextaccesslevel` :
            `masterprojects/${projectId}/productions/${productionId}/changetextaccesslevel`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the owner of a production.
     * @param productionId
     * @param ownerId
     * @param phaseId
     */
    changeOwner(projectId, productionId, ownerId, phaseId, comment, privateComment) {
        let request = {
            ownerId: ownerId,
            phaseId: phaseId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/changeowner` :
            `masterprojects/${projectId}/productions/${productionId}/changeowner`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the production contribtors.
     * @param productionId
     * @param contributorOwnerIdAdditions
     * @param contributorOwnerIdRemovals
     * @param phaseId
     */
    changeContributors(projectId, productionId, contributorOwnerIdAdditions, contributorOwnerIdRemovals, phaseId) {
        let request = {
            contributorOwnerIdAdditions: contributorOwnerIdAdditions,
            contributorOwnerIdRemovals: contributorOwnerIdRemovals,
            phaseId: phaseId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/changecontributors` :
            `masterprojects/${projectId}/productions/${productionId}/changecontributors`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the production dates.
     * @param productionId
     * @param dueDate
     * @param phaseId
     */
    changeDates(projectId, productionId, startDate, dueDate, comment, privateComment) {
        let request = {
            startDate: startDate,
            dueDate: dueDate,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/changedates` :
            `masterprojects/${projectId}/productions/${productionId}/changedates`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the target product type of the idea.
     * @param productionId
     * @param productTypeTagId
     * @param phaseId
     */
    changeProductType(projectId, productionId, productTypeTagId, phaseId, comment, privateComment) {
        let request = {
            productTypeTagId: productTypeTagId,
            phaseId: phaseId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/changeproducttype` :
            `masterprojects/${projectId}/productions/${productionId}/changeproducttype`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change roles.
     * @param projectId
     * @param productionId
     * @param phaseId
     * @param roles
     */
    changeRoles(projectId, productionId, phaseId, roles, comment, privateComment) {
        let request = {
            roles: roles,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        let urlSlug = !projectId ? `productions/${productionId}/` :
            `masterprojects/${projectId}/productions/${productionId}/`;
        if (phaseId) {
            urlSlug += `phase/${phaseId}/changeroles`;
        }
        else
            urlSlug += `changeroles`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the stage due dates.
     * @param productionId
     * @param stageId
     * @param taskId
     * @param startDate
     * @param dueDate
     * @param phaseId
     */
    changeStageDates(projectId, productionId, stageId, startDate, dueDate) {
        let request = { startDate: startDate, dueDate: dueDate };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${stageId}/changestagedates` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${stageId}/changestagedates`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the task due dates.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param startDate
     * @param dueDate
     * @param phaseId
     */
    changeTaskDates(projectId, productionId, phaseId, taskId, startDate, dueDate) {
        let request = { startDate: startDate, dueDate: dueDate };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/changedates` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/changedates`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the task work dates.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param startDate
     * @param dueDate
     * @param phaseId
     */
    changeTaskWorkDates(projectId, productionId, phaseId, taskId, startDate, dueDate) {
        let request = { startDate: startDate, dueDate: dueDate };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/changeworkdates` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/changeworkdates`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change units.
     * @param projectId
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param units
     */
    changeUnits(projectId, productionId, phaseId, taskId, units, comment, privateComment) {
        let request = {
            units: units,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        let urlSlug = '';
        if (projectId) {
            urlSlug += `/masterprojects/${projectId}`;
        }
        urlSlug += `/productions/${productionId}`;
        if (phaseId) {
            urlSlug += `/phase/${phaseId}`;
        }
        if (taskId) {
            urlSlug += `/task/${taskId}`;
        }
        urlSlug += `/changeunits`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeTask(projectId, productionId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/complete` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/complete`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete an AI task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeAITask(projectId, productionId, phaseId, taskId, textSetId, sourceText, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            textSetId: textSetId,
            sourceText: sourceText,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/complete-ai` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/complete-ai`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete an Attachment task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeAttachmentTask(projectId, productionId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/complete-attachment` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/complete-attachment`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete a text task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeTextTask(projectId, productionId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/complete-text` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/complete-text`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Confirm schedule of a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    confirmSchedule(projectId, productionId, phaseId, taskId, startDate, endDate, ownerId, comment, privateComment) {
        let request = {
            comment: comment,
            startDate: startDate,
            endDate: endDate,
            ownerId: ownerId,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/confirmschedule` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/confirmschedule`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a new production
     * @param name
     * @param templateId
     */
    createProduction(projectId, name, templateId, date, comment, campaignId, privateComment) {
        let request = {
            name: name,
            templateId: templateId,
            dueDate: date,
            comment: comment,
            campaignId: campaignId,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions` :
            `masterprojects/${projectId}/productions`;
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a production using a full placeholder line.
     * @param name
     * @param templateId
     */
    createFull(parentId, phaseId, request, comment, privateComment) {
        request.comment = comment;
        request.commentAccessLevel = privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' };
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/productions/${parentId}/phases/${phaseId}/createfull`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create a single production within a multi placeholder line.
     * @param name
     * @param templateId
     */
    createSingle(parentId, phaseId, request, comment, privateComment) {
        request.comment = comment;
        request.commentAccessLevel = privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' };
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/productions/${parentId}/phases/${phaseId}/createsingle`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Create multiple productions within a multi placeholder line.
     * @param name
     * @param templateId
     */
    createMulti(parentId, phaseId, request, comment, privateComment) {
        request.comment = comment;
        request.commentAccessLevel = privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' };
        return this.http
            .post(`${this.config.atlasApiEndpoint}/api/productions/${parentId}/phases/${phaseId}/createmulti`, request)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    /**
     * Delete a production project
     * @param productionId
     */
    delete(projectId, productionId, removePhase = true) {
        const urlSlug = !projectId ? `productions/${productionId}/${removePhase.toString()}` :
            `masterprojects/${projectId}/productions/${productionId}/${removePhase.toString()}`;
        return this.http.delete(`${this.config.atlasApiEndpoint}/api/${urlSlug}`)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove associate to an existing campaign to the production
     * @param productionId
     * @param name
     * @param templateId
     * @param comment
     */
    deSelectCampaign(projectId, productionId, comment, privateComment) {
        let request = {
            campaignId: undefined,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/deselectcampaign` :
            `masterprojects/${projectId}/productions/${productionId}/deselectcampaign`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * FastForward a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    fastForward(projectId, productionId, phaseId, taskId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/fastforward` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/fastforward`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Get's the head details of a production project
     * @param productionProjectId
     */
    getProductionDetails(productionId, options) {
        return this.websocket.smartApiWrapper(`/productions/${productionId}`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get's the assets for a project.
     * @param productionId
     */
    getProductionAssets(productionId, options) {
        return this.websocket.smartApiWrapper(`/productions/${productionId}/assets`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get's the assets for a phase.
     * @param productionId
     * @param phaseId
     */
    getPhaseAssets(productionId, phaseId, options) {
        return this.websocket.smartApiWrapper(`/productions/${productionId}/phase/${phaseId}/assets`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get's the production project and recent associated messages in a single object.
     * @param productionId
     */
    getProductionWithMessages(productionId, options) {
        return this.websocket.smartApiWrapper(`/productions/${productionId}/withmessages`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get the production phase.
     * @param productionId
     * @param phaseId
     */
    getPhase(productionId, phaseId, options) {
        return this.websocket.smartApiWrapper(`/productions/${productionId}/phase/${phaseId}`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get the production phases.
     * @param productionId
     */
    getPhases(productionId, options) {
        return this.websocket.smartApiWrapper(`/productions/${productionId}/phase`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Hold a production project
     * @param productionId
     * @param phaseId
     */
    hold(projectId, productionId, phaseId, comment, privateComment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/hold` :
            `masterprojects/${projectId}/productions/${productionId}/hold`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
    * Link a file url to the production stage.
    * @param productionId
    * @param phaseId
    * @param url
    */
    linkFile(projectId, productionId, phaseId, url, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            fileUrl: url,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/upload-link` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/upload-link`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * List all entries for the production calendar.
     * @param productionId
     */
    //public listProductionCalendar(projectId: string | undefined, productionId: string, options?: SmartWrapperOptions): Observable<CalendarEntry[]> {
    //  const urlSlug = !projectId ? `productions/${productionId}/calendar` :
    //    `masterprojects/${projectId}/productions/${productionId}/calendar`;
    //  return this.websocket.smartApiWrapper<CalendarEntry[]>(
    //    `/${urlSlug}`,
    //    undefined, options || new SmartWrapperOptions(1, false)
    //  );
    //}
    /**
     * List all messages related to a production project phase
     * @param productionId
     * @param phaseId
     */
    listProductionMessages(projectId, productionId, phaseId, options) {
        // phase based
        if (phaseId) {
            const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/messages` :
                `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/messages`;
            return this.websocket.smartApiWrapper(`/${urlSlug}`, undefined, options || new SmartWrapperOptions(1, false));
        }
        // production based
        else {
            const urlSlug = !projectId ? `productions/${productionId}/messages` :
                `masterprojects/${projectId}/productions/${productionId}/messages`;
            return this.websocket.smartApiWrapper(`/${urlSlug}`, undefined, options || new SmartWrapperOptions(1, false));
        }
    }
    /**
     * List productions
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listProductions(page = 1, pageSize = 10, feedIds, statuses, ownerId, fromDate, toDate, fromDueDate, toDueDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, legacyBraftonOnly, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        if (fromDueDate)
            // convert to unix epoch time and string
            params = params.set('fromDueDate', fromDueDate.valueOf().toString());
        if (toDueDate)
            // convert to unix epoch time and string
            params = params.set('toDueDate', toDueDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // filter on brafton Only
        if (legacyBraftonOnly !== undefined)
            params = params.set('legacyBraftonOnly', legacyBraftonOnly.toString());
        // formal url slug
        const urlSlug = `/productions?${params.toString()}`;
        const socketTopic = `/productions`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * List productions with associated messages.
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listProductionsWithMessages(page = 1, pageSize = 10, feedIds, statuses, ownerId, fromDate, toDate, fromDueDate, toDueDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, legacyBraftonOnly, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        if (fromDueDate)
            // convert to unix epoch time and string
            params = params.set('fromDueDate', fromDueDate.valueOf().toString());
        if (toDueDate)
            // convert to unix epoch time and string
            params = params.set('toDueDate', toDueDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // filter on brafton Only
        if (legacyBraftonOnly !== undefined)
            params = params.set('legacyBraftonOnly', legacyBraftonOnly.toString());
        // formal url slug
        const urlSlug = `productions/withmessages?${params.toString()}`;
        const socketTopic = `/productions`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    listStages(page = 1, pageSize = 10, feedIds, statuses, ownerId, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/productions/stages?${params.toString()}`;
        const socketTopic = `/productions`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * List / search for tasks across the feed or on a specific production Id.
     * @param page
     * @param pageSize
     * @param productionId
     * @param statuses
     * @param ownerIds
     * @param orderByCriteria
     */
    listTasks(page = 1, pageSize = 10, productionId, feedIds, statuses, ownerId, fromDate, toDate, orderByCriteria, workTypeIds, workTypeNotIds, campaignIds, contentTypeIds, tagIds, sowIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // included worktype
        if (workTypeIds)
            params = params.set('workTypeIds', workTypeIds);
        // exclude worktypes
        if (workTypeNotIds)
            params = params.set('workTypeNotIds', workTypeNotIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // formal url slug
        const urlSlug = productionId ? `/productions/${productionId}/tasks?${params.toString()}` : `/productions/tasks?${params.toString()}`;
        const socketTopic = productionId ? `/productions/${productionId}/tasks` : `/tasks`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * List templates
     * @param productType - should be 'ProductChild' or 'ProductHead'
     */
    listTemplates(productType, options) {
        let params = new HttpParams();
        params = params.set('productType', productType.toString());
        // formal url slug
        const urlSlug = `/productions/templates?${params.toString()}`;
        const socketTopic = `/productions/templates`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(500, false, true));
    }
    /**
     * List operational templates
     */
    listOperationalTemplates(options) {
        // formal url slug
        const urlSlug = `/productions/operational-templates`;
        const socketTopic = `/productions/templates`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(500, false, true));
    }
    /**
     * Lock a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    lock(projectId, productionId, phaseId, taskId, lockStart, lockEnd, lockUnits, comment, privateComment) {
        let request = {
            comment: comment,
            lockStart: lockStart,
            lockEnd: lockEnd,
            lockUnits: lockUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/lock` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/lock`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Poke a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    poke(projectId, productionId, phaseId, taskId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/poke` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/poke`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Reject the production approval.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    rejectApproval(projectId, productionId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/rejectapproval` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/rejectapproval`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Reject the client approval.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    rejectClientApproval(projectId, productionId, phaseId, taskId, comment, privateComment) {
        let request = {
            feedback: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/rejectclientapproval` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/rejectclientapproval`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove an approval round.
     * @param productionId
     * @param phaseId
     * @param workTaskId
     * @param approverOwnerId
     * @param comment
     */
    removeApproval(projectId, productionId, phaseId, approvalTaskId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${approvalTaskId}/removeapproval` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${approvalTaskId}/removeapproval`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param approverOwnerId
     * @param comment
     */
    removeTask(projectId, productionId, phaseId, taskId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/removetask` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/removetask`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove an attachment from a production.
     * @param productionId
     * @param assetSetId
     * @param comment
     */
    removeAttachment(projectId, productionId, assetSetId, assetFileId, comment, privateComment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/removeattachment` :
            `masterprojects/${projectId}/productions/${productionId}/removeattachment`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove a text from a production.
     * @param productionId
     * @param textSetId
     * @param comment
     */
    removeText(projectId, productionId, textSetId, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/removetext` :
            `masterprojects/${projectId}/productions/${productionId}/removetext`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove a production stage.
     * @param productionId
     * @param phaseId
     * @param comment
     */
    removeStage(projectId, productionId, phaseId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/remove` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/remove`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename an attachment from a production.
     * @param contentId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameAttachment(projectId, productionId, assetSetId, assetFileId, newName, comment, privateComment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            name: newName,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/renameattachment` :
            `masterprojects/${projectId}/productions/${productionId}/renameattachment`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a text from a production.
     * @param contentId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameText(projectId, productionId, textSetId, newName, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            name: newName,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/renametext` :
            `masterprojects/${projectId}/productions/${productionId}/renametext`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a production.
     * @param productionId
     * @param newName
     * @param phaseId
     */
    renameProduction(projectId, productionId, newName) {
        let request = {
            name: newName,
            comment: null
        };
        const urlSlug = !projectId ? `productions/${productionId}/rename` :
            `masterprojects/${projectId}/productions/${productionId}/rename`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a production stage.
     * @param productionId
     * @param phaseId
     * @param name
     */
    renameStage(projectId, productionId, phaseId, name) {
        let request = { name: name };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/rename` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/rename`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a task.
     * @param productionId
     * @param newName
     * @param phaseId
     */
    renameTask(projectId, productionId, phaseId, taskId, newName) {
        let request = {
            name: newName,
            comment: null
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/rename` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/rename`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Request a task date change.
     * @param projectId
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param date
     * @param comment
     * @param privateComment
     */
    requestTaskDateChange(projectId, productionId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            dueDate: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/requestdatechange` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/requestdatechange`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Reset a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    reset(projectId, productionId, phaseId, taskId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/reset` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/reset`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Restart a production.
     * @param productionId
     * @param comment
     */
    restart(projectId, productionId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/restart` :
            `masterprojects/${projectId}/productions/${productionId}/restart`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Resume a production project
     * @param productionId
     * @param phaseId
     */
    resume(projectId, productionId, phaseId, comment, privateComment) {
        let request = {
            phaseId: phaseId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/resume` :
            `masterprojects/${projectId}/productions/${productionId}/resume`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Request the upload of a binary file to the asset system.
     * @param productionId
     * @param phaseId
     * @param filename
     * @param fileType
     * @param fileSizeInBytes
     */
    requestUpload(projectId, productionId, phaseId, filename, fileType, fileSizeInBytes, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            filename: filename,
            fileType: fileType,
            fileSizeInBytes: fileSizeInBytes,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/upload` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/upload`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Assoiate an existing campaign to the production
     * @param productionId
     * @param name
     * @param templateId
     * @param comment
     */
    selectCampaign(projectId, productionId, campaignId, comment, privateComment) {
        let request = {
            campaignId: campaignId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/selectcampaign` :
            `masterprojects/${projectId}/productions/${productionId}/selectcampaign`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete a select text set task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    selectTextSet(projectId, productionId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/select-text-set` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/select-text-set`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a general AI Task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runAIGeneral(projectId, productionId, phaseId, taskId, date, restart, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            restart: restart
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-general` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-general`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a Keywords to Outline AI task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runAIKeywordsToOutline(projectId, productionId, phaseId, taskId, keywordsTextSetId, titleTextSetId, title, targetAudienceBriefTextSetId, outlineTextSetId, numberOfSections, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordsTextSetId: keywordsTextSetId,
            outlineTextSetId: outlineTextSetId,
            titleTextSetId: titleTextSetId,
            numberOfSections: numberOfSections,
            targetAudienceBriefTextSetId: targetAudienceBriefTextSetId,
            title: title,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-keywords-to-outline` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-keywords-to-outline`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run an Outline + Keywords to Copy AI task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runAIOutlineKeywordsToCopy(projectId, productionId, phaseId, taskId, keywordsTextSetId, outlineTextSetId, writingBriefTextSetId, targetAudienceBriefTextSetId, copyTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordsTextSetId: keywordsTextSetId,
            writingBriefTextSetId: writingBriefTextSetId,
            targetAudienceBriefTextSetId: targetAudienceBriefTextSetId,
            outlineTextSetId: outlineTextSetId,
            copyTextSetId: copyTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-outline-keywords-to-copy` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-outline-keywords-to-copy`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a Keywords + Copy to Optimized Copy AI Task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runAICopyKeywordsToOptimizedCopy(projectId, productionId, phaseId, taskId, keywordsTextSetId, copyTextSetId, outputCopyTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordsTextSetId: keywordsTextSetId,
            copyTextSetId: copyTextSetId,
            outputCopyTextSetId: outputCopyTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-copy-keywords-to-optimized-copy` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-copy-keywords-to-optimized-copy`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a Copy to Tweets AI Operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runAICopyToTweets(projectId, productionId, phaseId, taskId, copyTextSetId, numberOfTweets, targetURL, outputTweetsTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            numberOfTweets: numberOfTweets,
            copyTextSetId: copyTextSetId,
            targetURL: targetURL,
            tweetsTextSetId: outputTweetsTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-copy-to-tweets` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-copy-to-tweets`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a title to image AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runAITitleToImage(projectId, productionId, phaseId, taskId, titleTextSetId, title, assetSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            titleOverride: title,
            titleTextSetId: titleTextSetId,
            assetSetId: assetSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-title-to-image` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-title-to-image`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a keyword to title AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runAIKeywordToTitle(projectId, productionId, phaseId, taskId, keywordTextSetId, titleTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordTextSetId: keywordTextSetId,
            titleTextSetId: titleTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-keyword-to-title` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-keyword-to-title`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a title + copy + keywords to metadata AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runAITitleCopyKeywordsToMetaData(projectId, productionId, phaseId, taskId, titleTextSetId, copyTextSetId, keywordsTextSetId, metadataTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordsTextSetId: keywordsTextSetId,
            titleTextSetId: titleTextSetId,
            copyTextSetId: copyTextSetId,
            metaDataTextSetId: metadataTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-title-copy-keywords-to-metadata` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-ai-title-copy-keywords-to-metadata`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runKeywordToKeywordsDensity(projectId, productionId, phaseId, taskId, keywordTextSetId, keyword, keywordsDensityTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordOverride: keyword,
            keywordTextSetId: keywordTextSetId,
            outputKeywordsTextSetId: keywordsDensityTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-keyword-to-keywords-density` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-keyword-to-keywords-density`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runCopyToLinkedInPost(projectId, productionId, phaseId, taskId, copyTextSetId, targetURL, linkedInPostTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            targetURL: targetURL,
            copyTextSetId: copyTextSetId,
            linkedInPostTextSetId: linkedInPostTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-linkedin-post` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-linkedin-post`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runKeywordToTitles(projectId, productionId, phaseId, taskId, keywordTextSetId, keyword, titlesTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordOverride: keyword,
            keywordTextSetId: keywordTextSetId,
            titlesTextSetId: titlesTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-keyword-to-titles` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-keyword-to-titles`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runOutlineToCopy(projectId, productionId, phaseId, taskId, copyTextSetId, writingBriefTextSetId, targetAudienceBriefTextSetId, outlineTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            outlineTextSetId: outlineTextSetId,
            writingBriefTextSetId: writingBriefTextSetId,
            targetAudienceBriefTextSetId: targetAudienceBriefTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-outline-to-copy` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-outline-to-copy`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runTopicToOutline(projectId, productionId, phaseId, taskId, topicTextSetId, topic, outlineTextSetId, numberOfSections, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            topicOverride: topic,
            topicTextSetId: topicTextSetId,
            outlineTextSetId: outlineTextSetId,
            numberOfSections: numberOfSections,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-topic-to-outline` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-topic-to-outline`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runTopicToTopics(projectId, productionId, phaseId, taskId, topicTextSetId, topic, topicsTextSetId, numberOfTopics, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            topicOverride: topic,
            topicTextSetId: topicTextSetId,
            topicsTextSetId: topicsTextSetId,
            numberOfTopics: numberOfTopics
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-topic-to-topics` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-topic-to-topics`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runTextToKeywordsDensity(projectId, productionId, phaseId, taskId, textTextSetId, text, keywordsDensityTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            textOverride: text,
            textTextSetId: textTextSetId,
            outputKeywordsTextSetId: keywordsDensityTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-text-to-keywords-density` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-text-to-keywords-density`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run copy to writing brief AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runCopyToWritingBrief(projectId, productionId, phaseId, taskId, copyTextSetId, writingBriefTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            writingBriefTextSetId: writingBriefTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-writing-brief` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-writing-brief`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run copy to german copy AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runCopyToGermanCopy(projectId, productionId, phaseId, taskId, copyTextSetId, germanCopyTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            germanCopyTextSetId: germanCopyTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-german-copy` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-german-copy`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run copy to target audience brief AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runCopyToTargetAudienceBrief(projectId, productionId, phaseId, taskId, copyTextSetId, targetAudienceBriefTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            targetAudienceBriefTextSetId: targetAudienceBriefTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-target-audience-brief` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-target-audience-brief`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run copy to fact citations AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    runCopyToFacts(projectId, productionId, phaseId, taskId, copyTextSetId, factsTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            factsTextSetId: factsTextSetId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-facts` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/run-copy-to-facts`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Start a task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    startTask(projectId, productionId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/start` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/start`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Start an attachment task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    startAttachmentTask(projectId, productionId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/start-attachment` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/start-attachment`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Start a text task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    startTextTask(projectId, productionId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/start-text` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/start-text`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Switch the dependency of a production phase or production head.
     * @param productionId
     * @param phaseId
     * @param dependentOnPhaseId
     * @param dueDate
     * @param comment
     */
    switchDependency(projectId, productionId, phaseId, dependentOnPhaseId, dueDate, comment, privateComment) {
        let request = {
            dependentOnPhaseId: dependentOnPhaseId,
            dueDate: dueDate,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        // production head specific
        if (phaseId === undefined) {
            const urlSlug = !projectId ? `productions/${productionId}/switchdependency` :
                `masterprojects/${projectId}/productions/${productionId}/switchdependency`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        // phase specific
        else {
            const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/switchdependency` :
                `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/switchdependency`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Switch the template of a production.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    switchTemplate(projectId, productionId, phaseId, productDefinitionId, productClassId, productVariantId, roles, comment, privateComment) {
        let request = {
            comment: comment,
            productDefinitionId: productDefinitionId,
            productClassId: productClassId,
            productVariantId: productVariantId,
            roles: roles,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/switchtemplate` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/switchtemplate`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Mark a task as tobescheduled.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    toBeScheduled(projectId, productionId, phaseId, taskId, hold = false, comment, privateComment) {
        let request = {
            comment: comment,
            type: hold === true ? { id: "ScheduleHold", displayName: "Schedule Hold" } : { id: "Schedule", displayName: "Schedule" },
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/tobescheduled` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/tobescheduled`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * transfer a contractline to another sow.
     * @param productionId
     * @param comment
     */
    transferContractLine(sourceSowId, contractLineId, targetSowId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            targetSOWId: targetSowId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/productions/${sourceSowId}/contractlines/${contractLineId}/transfer`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Trim the units of a production.
     * @param productionId
     * @param comment
     */
    trimUnits(projectId, productionId, phaseId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        let urlSlug = '';
        if (projectId) {
            urlSlug += `/masterprojects/${projectId}`;
        }
        urlSlug += `/productions/${productionId}`;
        if (phaseId) {
            urlSlug += `/phase/${phaseId}`;
        }
        urlSlug += `/trimunits`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
       * Get the production totals.
       */
    totals(options) {
        return this.websocket.smartApiWrapper(`/productions/totals`, `productiontotals`, options || new SmartWrapperOptions(2, false, true));
    }
    /**
     * Update the notes for a production.
     * @param projectId
     * @param productionId
     * @param notes
     */
    updateNotes(projectId, productionId, notes, privateComment) {
        let request = {
            comment: notes,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/updatenotes` :
            `masterprojects/${projectId}/productions/${productionId}/updatenotes`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * update the tags on a production.
     * @param productionId
     * @param comment
     * @param existingTagIdsToAdd
     * @param existingTagIdsToRemove
     * @param newTagNamesToCreateAndAdd
     * @param phaseId
     */
    updateTags(projectId, productionId, comment, existingTagIdsToAdd, existingTagIdsToRemove, newTagNamesToCreateAndAdd, phaseId) {
        let request = {
            comment: comment,
            existingTagIdsToAdd: existingTagIdsToAdd,
            existingTagIdsToRemove: existingTagIdsToRemove,
            newTagNamesToCreateAndAdd: newTagNamesToCreateAndAdd,
            phaseId: phaseId,
        };
        const urlSlug = !projectId ? `productions/${productionId}/updatetags` :
            `masterprojects/${projectId}/productions/${productionId}/updatetags`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    getExtension(fileName) {
        let split = fileName.split('.'); // Split by dot
        return split.pop();
    }
    /**
     * Upload a binary file.
     * @param productionId
     * @param phaseId
     * @param file
     */
    uploadFile(projectId, productionId, phaseId, file, feedId, organizationId, assetSetId, assetFileId) {
        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
        let safeFileName = file.name.replace("&", "_");
        let ext = this.getExtension(file.name);
        return this.assetFilesService.GetMimeTypeForFile(file).pipe(switchMap((fileTypeResult) => {
            let fileType;
            if (fileTypeResult == null) {
                if (file.type == null) {
                    fileType = new FileContentType(ext, "application/octet-stream"); // Been unable to sniff content type - treat as unknown binary with ext that was provided.
                }
                else {
                    fileType = new FileContentType(ext, file.type);
                }
            }
            else {
                // CFB hack
                if (fileTypeResult.mime == "application/x-cfb") {
                    // CFB is the only file type that we can't properly sniff, all we know is it's a legacy office type (doc, xls etc)
                    // As it's legacy it's not worth putting too much effort in, so we'll just assume its valid and use the provided ext (not the sniffed ext which will be .cfb) to determine the type.
                    if (ext == "doc") {
                        fileType = new FileContentType(ext, "application/msword");
                    }
                    else if (ext == "xls") {
                        fileType = new FileContentType(ext, "application/vnd.ms-excel");
                    }
                    else if (ext == "ppt" || ext == "pps") {
                        fileType = new FileContentType(ext, "application/vnd.ms-powerpoint");
                    }
                    else {
                        fileType = new FileContentType(ext, file.type);
                    }
                }
                else {
                    fileType = new FileContentType(fileTypeResult.ext, fileTypeResult.mime); // Breaking dependency on File-Type library.
                }
            }
            return this.requestUpload(projectId, productionId, phaseId, safeFileName, fileType, file.size, feedId, organizationId, assetSetId, assetFileId).pipe(switchMap((response) => {
                return this.assetFilesService.BucketUploadAsync(response.assetFileId, response.awsUrl, file).pipe(switchMap((uploadResponse) => {
                    if (uploadResponse.status === 200) {
                        return this.assetsService.uploadSuccess(response.assetFileId, safeFileName, fileType, file.size).pipe(map((uploadSuccessResponse) => {
                            // We're now uploaded and told Assets the file is uploaded.
                            return new PlatformUploadResponse(uploadSuccessResponse, uploadResponse.progress, false, true);
                        }));
                    }
                    else if (uploadResponse.status == null && uploadResponse.progress > 0) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, true, false));
                    }
                    else if (uploadResponse instanceof HttpErrorResponse) {
                        return of(new PlatformUploadResponse(null, null, false, false));
                    }
                    // We could be waiting for the first response from the server, so return a progress update.
                    return of(new PlatformUploadResponse(null, 0, true, false));
                }));
            }), catchError(AtlasSharedService.handleError()));
        }));
    }
    selectAttachmentFromAttachments(projectId, productionId, phaseId, taskId, attachmentRequest, date, partialUnits, comment, privateComment) {
        let request = {
            targetAssetSetId: attachmentRequest.targetAssetSetId,
            targetAssetFileId: attachmentRequest.targetAssetFileId,
            selectedAssetFileId: attachmentRequest.selectedAssetFileId,
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/select-attachment-from-attachments` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/select-attachment-from-attachments`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    resizeAttachment(projectId, productionId, phaseId, taskId, attachmentRequest, date, partialUnits, comment, privateComment) {
        let request = {
            targetAssetSetId: attachmentRequest.targetAssetSetId,
            targetAssetFileId: attachmentRequest.targetAssetFileId,
            selectedAssetFileId: attachmentRequest.selectedAssetFileId,
            selectedAssetSetId: attachmentRequest.selectedAssetSetId,
            dimensionPromptId: attachmentRequest.dimensionPromptId,
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/resize-attachment` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/resize-attachment`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     *
     * @param projectId
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param textSetId
     * @param textSetName
     * @param textSetDefinitionId
     * @param textSetVersion
     * @param comment
     * @param privateComment
     * @returns
     */
    updateText(projectId, productionId, phaseId, taskId, textSetId, textSetName, textSetDefinitionId, textSetVersion, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            name: textSetName,
            textSetDefinitionId: textSetDefinitionId,
            version: textSetVersion,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `productions/${productionId}/phase/${phaseId}/task/${taskId}/update-text` :
            `masterprojects/${projectId}/productions/${productionId}/phase/${phaseId}/task/${taskId}/update-text`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
ProductionsService.ɵfac = function ProductionsService_Factory(t) { return new (t || ProductionsService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
ProductionsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductionsService, factory: ProductionsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductionsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class ProductsService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(websocket, config) {
        this.websocket = websocket;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * List all tags on the current feed and using a merge cache strategy
     */
    listProducts(feedIds) {
        let params = new HttpParams();
        // feed id criteria
        if (feedIds)
            params = params.set('feedIds', feedIds);
        // formal url slug
        const urlSlug = `/products?${params.toString()}`;
        return this.websocket.wrapper(urlSlug, 8);
    }
    /**
     * List Templates
     * @param page
     * @param pageSize
     * @param templateType
     * @param currentVersionOnly
     * @param productClassId
     * @param module
     * @param options
     */
    listTemplates(page = 1, pageSize = 50, templateType, currentVersionOnly, productClassIds, moduleIds, tagIds, hasClasses, fullDefinitions, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (templateType)
            params = params.set('templateType', templateType);
        if (currentVersionOnly)
            params = params.set('currentVersionOnly', currentVersionOnly.toString());
        if (moduleIds)
            params = params.set('modules', moduleIds);
        if (productClassIds)
            params = params.set('productClassIds', productClassIds);
        if (tagIds)
            params = params.set('tagIds', tagIds);
        if (hasClasses)
            params = params.set('hasClasses', hasClasses.toString());
        if (fullDefinitions)
            params = params.set('fullDefinitions', fullDefinitions.toString());
        // formal url slug
        const urlSlug = `/products/templates?${params.toString()}`;
        const socketTopic = `/products/templates`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(500, false, true));
    }
    /**
     * List product classes.
     * @param enabled
     * @param module
     * @param options
     */
    listClasses(enabled, module, options) {
        let params = new HttpParams();
        if (enabled)
            params = params.set('enabled', enabled.toString());
        if (module)
            params = params.set('module', module);
        // formal url slug
        const urlSlug = `/products/classes?${params.toString()}`;
        const socketTopic = `/products/classes`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(500, false, true));
    }
}
ProductsService.ɵfac = function ProductsService_Factory(t) { return new (t || ProductsService)(i0.ɵɵinject(WebsocketService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
ProductsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductsService, factory: ProductsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: WebsocketService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class PublishService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, jsonDecryptEncrypt, websocket, assetFilesService, assetsService, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.assetFilesService = assetFilesService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * Accept an approval.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    acceptApproval(projectId, publishId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/acceptapproval` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/acceptapproval`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add a comment to the production task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    addMessage(projectId, publishId, phaseId, taskId, comment) {
        let request = { comment: comment };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/addmessage` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/addmessage`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add a publish stage to the publish project.
     * @param publishId
     * @param stageName
     * @param productDefinitionId
     * @param comment
     * @param startDate
     * @param endDate
     * @param publishOwnerId
     * @param approvalOwnerId
     * @param dependantOnPhaseId
     */
    addPublishStage(projectId, publishId, stageName, templateId, comment, startDate, endDate, roles, dependentOnPhaseId, units) {
        let request = {
            comment: comment,
            templateId: templateId,
            stageName: stageName,
            startDate: startDate,
            endDate: endDate,
            roles: roles,
            dependentOnPhaseId: dependentOnPhaseId,
            units: units,
        };
        const urlSlug = !projectId ? `publish/${publishId}/addpublishstage` :
            `masterprojects/${projectId}/publish/${publishId}/addpublishstage`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Assign a task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    assignTask(projectId, publishId, phaseId, taskId, ownerId, comment) {
        let request = {
            comment: comment,
            ownerId: ownerId,
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/assign` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/assign`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the owner of a production.
     * @param publishId
     * @param ownerId
     * @param phaseId
     */
    changeOwner(projectId, publishId, ownerId, phaseId, comment) {
        let request = {
            ownerId: ownerId,
            phaseId: phaseId,
            comment: comment
        };
        const urlSlug = !projectId ? `publish/${publishId}/changeowner` :
            `masterprojects/${projectId}/publish/${publishId}/changeowner`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the production dates.
     * @param publishId
     * @param dueDate
     * @param phaseId
     */
    changeDates(projectId, publishId, startDate, dueDate) {
        let request = { startDate: startDate, dueDate: dueDate };
        const urlSlug = !projectId ? `publish/${publishId}/changedates` :
            `masterprojects/${projectId}/publish/${publishId}/changedates`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the task dates.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param startDate
     * @param dueDate
     * @param phaseId
     */
    changeTaskDates(projectId, publishId, phaseId, taskId, startDate, dueDate) {
        let request = { startDate: startDate, dueDate: dueDate };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/changedates` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/changedates`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change the task work dates.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param startDate
     * @param dueDate
     * @param phaseId
     */
    changeTaskWorkDates(projectId, publishId, phaseId, taskId, startDate, dueDate) {
        let request = { startDate: startDate, dueDate: dueDate };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/changeworkdates` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/changeworkdates`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change units.
     * @param projectId
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param units
     */
    changeUnits(projectId, publishId, phaseId, taskId, units, comment, privateComment) {
        let request = {
            units: units,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        let urlSlug = '';
        if (projectId) {
            urlSlug += `/masterprojects/${projectId}`;
        }
        urlSlug += `/publish/${publishId}`;
        if (phaseId) {
            urlSlug += `/phase/${phaseId}`;
        }
        if (taskId) {
            urlSlug += `/task/${taskId}`;
        }
        urlSlug += `/changeunits`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete a task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeTask(projectId, publishId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/complete` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/complete`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete an Attachment task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeAttachmentTask(projectId, publishId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/complete-attachment` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/complete-attachment`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete a text task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    completeTextTask(projectId, publishId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/complete-text` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/complete-text`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Confirm schedule of a task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    confirmSchedule(projectId, publishId, phaseId, taskId, startDate, endDate, ownerId, comment, privateComment) {
        let request = {
            comment: comment,
            startDate: startDate,
            endDate: endDate,
            ownerId: ownerId,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/confirmschedule` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/confirmschedule`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Delete a production project
     * @param publishId
     */
    delete(projectId, publishId) {
        const urlSlug = !projectId ? `publish/${publishId}` :
            `masterprojects/${projectId}/publish/${publishId}`;
        return this.http.delete(`${this.config.atlasApiEndpoint}/api/${urlSlug}`)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Get's the head details of a production project
     * @param publishId
     */
    getPublishDetails(publishId, options) {
        return this.websocket.smartApiWrapper(`/publish/${publishId}`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get the production phase.
     * @param publishId
     * @param phaseId
     */
    getPhase(publishId, phaseId, options) {
        return this.websocket.smartApiWrapper(`/publish/${publishId}/phase/${phaseId}`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * Get the production phases.
     * @param publishId
     */
    getPhases(publishId, options) {
        return this.websocket.smartApiWrapper(`/publish/${publishId}/phase`, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * List all messages for a publish phase.
     * @param publishId
     * @param phaseId
     * @param page
     * @param pageSize
     */
    listMessages(publishId, phaseId, page, pageSize, options) {
        const urlSlug = phaseId ? `/publish/${publishId}/phase/${phaseId}/messages` : `/publish/${publishId}/messages`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, options || new SmartWrapperOptions(8, false));
    }
    /**
     * List productions
     * @param page
     * @param pageSize
     * @param statuses
     * @param ownerId
     * @param fromDate
     * @param toDate
     * @param orderByCriteria
     */
    listPublish(page = 1, pageSize = 10, feedIds, statuses, ownerId, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/publish?${params.toString()}`;
        const socketTopic = `/publish`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    listStages(page = 1, pageSize = 10, feedIds, statuses, ownerId, fromDate, toDate, orderByCriteria, campaignIds, contentTypeIds, tagIds, sowIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // formal url slug
        const urlSlug = `/publish/stages?${params.toString()}`;
        const socketTopic = `/publish`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, true));
    }
    /**
     * List / search for tasks across the feed or on a specific production Id.
     * @param page
     * @param pageSize
     * @param publishId
     * @param statuses
     * @param ownerIds
     * @param orderByCriteria
     */
    listTasks(page = 1, pageSize = 10, publishId, feedIds, statuses, ownerId, fromDate, toDate, orderByCriteria, workTypeIds, workTypeNotIds, campaignIds, contentTypeIds, tagIds, sowIds, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (feedIds)
            params = params.set('feedIds', feedIds.toString());
        if (statuses)
            params = params.set('statuses', statuses.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        // campaign filter
        if (campaignIds)
            params = params.set('campaignIds', campaignIds);
        // content type filter
        if (contentTypeIds)
            params = params.set('contentTypeIds', contentTypeIds);
        // tagid filter
        if (tagIds)
            params = params.set('tagIds', tagIds);
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // included worktype
        if (workTypeIds)
            params = params.set('workTypeIds', workTypeIds);
        // exclude worktypes
        if (workTypeNotIds)
            params = params.set('workTypeNotIds', workTypeNotIds);
        // SOW filter
        if (sowIds)
            params = params.set('sowIds', sowIds);
        // formal url slug
        const urlSlug = publishId ? `/publish/${publishId}/tasks?${params.toString()}` : `/publish/tasks?${params.toString()}`;
        const socketTopic = publishId ? `/publish/${publishId}/tasks` : `/tasks`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(8, false, publishId ? false : true));
    }
    /**
     * List templates
     * @param productType - should be 'ProductChild' or 'ProductHead'
     */
    listTemplates(productType, options) {
        let params = new HttpParams();
        params = params.set('productType', productType.toString());
        // formal url slug
        const urlSlug = `/publish/templates?${params.toString()}`;
        const socketTopic = `/publish/templates`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(500, false, true));
    }
    /**
     * Lock a task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    lock(projectId, publishId, phaseId, taskId, lockStart, lockEnd, lockUnits, comment, privateComment) {
        let request = {
            comment: comment,
            lockStart: lockStart,
            lockEnd: lockEnd,
            lockUnits: lockUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/lock` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/lock`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Poke a task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    poke(projectId, publishId, phaseId, taskId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/poke` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/poke`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Publish to the content library.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    publishContentLibrary(projectId, publishId, phaseId, taskId, name, contentTypeId, existingTagsToAdd, newTagsToCreate, campaignId, date, comment, privateComment, assetSetIds, textSetIds) {
        let request = {
            comment: comment,
            name: name,
            contentTypeId: contentTypeId,
            campaignId: campaignId,
            existingTagsToAdd: existingTagsToAdd,
            newTagsToCreate: newTagsToCreate,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            assetSetIds: assetSetIds,
            textSetIds: textSetIds
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/publish-content-library` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/publish-content-library`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Publish with location update.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    publishLocation(projectId, publishId, phaseId, taskId, contentItemId, contentVersionId, publishURL, publishDate, date, comment, privateComment) {
        let request = {
            comment: comment,
            publishURL: publishURL,
            publishDate: publishDate,
            contentVersionId: contentVersionId,
            contentItemId: contentItemId,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/publish-location` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/publish-location`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Simple Publish Action.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    publish(projectId, publishId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/publish` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/publish`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Reject the production approval.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    rejectApproval(projectId, publishId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/rejectapproval` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/rejectapproval`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove a publish stage.
     * @param publishId
     * @param phaseId
     * @param comment
     */
    removeStage(projectId, publishId, phaseId, comment) {
        let request = { comment: comment };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/remove` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/remove`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a production.
     * @param publishId
     * @param newName
     * @param phaseId
     */
    rename(projectId, publishId, newName, phaseId) {
        let request = {
            name: newName,
            phaseId: phaseId,
            comment: null
        };
        const urlSlug = !projectId ? `publish/${publishId}/rename` :
            `masterprojects/${projectId}/publish/${publishId}/rename`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a production stage.
     * @param publishId
     * @param phaseId
     * @param name
     */
    renameStage(projectId, publishId, phaseId, name) {
        let request = { name: name };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/rename` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/rename`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a task.
     * @param publishId
     * @param newName
     * @param phaseId
     */
    renameTask(projectId, publishId, phaseId, taskId, newName) {
        let request = {
            name: newName,
            comment: null
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/rename` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/rename`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Reset a task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    reset(projectId, publishId, phaseId, taskId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/reset` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/reset`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Start a task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    startTask(projectId, publishId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/start` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/start`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Complete a select text set task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    selectTextSet(projectId, publishId, phaseId, taskId, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/select-text-set` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/select-text-set`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Start an attachment task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    startAttachmentTask(projectId, publishId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/start-attachment` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/start-attachment`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Start a text task.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    startTextTask(projectId, publishId, phaseId, taskId, date, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/start-text` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/start-text`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Switch the dependency of a publish phase or publish head.
     * @param publishId
     * @param phaseId
     * @param dependentOnPhaseId
     * @param dueDate
     * @param comment
     */
    switchDependency(projectId, publishId, phaseId, dependentOnPhaseId, dueDate, comment) {
        let request = {
            dependentOnPhaseId: dependentOnPhaseId,
            dueDate: dueDate,
            comment: comment
        };
        // publish head specific
        if (phaseId === undefined) {
            const urlSlug = !projectId ? `publish/${publishId}/switchdependency` :
                `masterprojects/${projectId}/publish/${publishId}/switchdependency`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
        // phase specific
        else {
            const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/switchdependency` :
                `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/switchdependency`;
            return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
                .pipe(catchError(AtlasSharedService.handleError()));
        }
    }
    /**
     * Mark a task as tobescheduled.
     * @param publishId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    toBeScheduled(projectId, publishId, phaseId, taskId, hold = false, comment, privateComment) {
        let request = {
            comment: comment,
            type: hold === true ? { id: "ScheduleHold", displayName: "Schedule Hold" } : { id: "Schedule", displayName: "Schedule" },
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        const urlSlug = !projectId ? `publish/${publishId}/phase/${phaseId}/task/${taskId}/tobescheduled` :
            `masterprojects/${projectId}/publish/${publishId}/phase/${phaseId}/task/${taskId}/tobescheduled`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Trim the units of a production.
     * @param publishId
     * @param comment
     */
    trimUnits(projectId, publishId, phaseId, comment, privateComment) {
        let request = {
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        let urlSlug = '';
        if (projectId) {
            urlSlug += `/masterprojects/${projectId}`;
        }
        urlSlug += `/publish/${publishId}`;
        if (phaseId) {
            urlSlug += `/phase/${phaseId}`;
        }
        urlSlug += `/trimunits`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
PublishService.ɵfac = function PublishService_Factory(t) { return new (t || PublishService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
PublishService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PublishService, factory: PublishService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PublishService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class ProfilesService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(http, websocket, config) {
        this.http = http;
        this.websocket = websocket;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * List all available units for a team member.
     */
    AvailableUnitTotals(profileId, startDate, endDate, unitType) {
        let params = new HttpParams();
        if (startDate)
            // convert to unix epoch time and string
            params = params.set('startDate', startDate.valueOf().toString());
        if (endDate)
            // convert to unix epoch time and string
            params = params.set('endDate', endDate.valueOf().toString());
        if (unitType)
            // unit Type param
            params = params.set('unitType', unitType);
        // formal url slug
        const urlSlug = `/profiles/${profileId.toString()}/units?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, new SmartWrapperOptions(8, false, true));
    }
    /**
     * List all available units for a team member.
     */
    AvailableUnitTotalsByDate(profileId, startDate, endDate, unitType) {
        let params = new HttpParams();
        if (startDate)
            // convert to unix epoch time and string
            params = params.set('startDate', startDate.valueOf().toString());
        if (endDate)
            // convert to unix epoch time and string
            params = params.set('endDate', endDate.valueOf().toString());
        if (unitType)
            // unit Type param
            params = params.set('unitType', unitType);
        // formal url slug
        const urlSlug = `/profiles/${profileId.toString()}/units/dates?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, new SmartWrapperOptions(8, false, true));
    }
    /**
     * Get profile details.
     * @param profileId
     * @param options
     */
    getTeam(profileId, options) {
        return this.websocket.smartApiWrapper(`/profiles/${profileId.toString()}`, undefined, options || new SmartWrapperOptions(8, false));
    }
    /**
     * List all profile alerts.
     * @param profileId
     * @param options
     */
    listAlerts(profileId, options) {
        // formal url slug
        const urlSlug = `/profiles/${profileId.toString()}/alerts`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, options || new SmartWrapperOptions(24, false));
    }
    /**
     * List all profile time off.
     * @param profileId
     * @param options
     */
    ListTimeOff(profileId, startDate, endDate, options) {
        let params = new HttpParams();
        if (startDate)
            // convert to unix epoch time and string
            params = params.set('startDate', startDate.valueOf().toString());
        if (endDate)
            // convert to unix epoch time and string
            params = params.set('endDate', endDate.valueOf().toString());
        // formal url slug
        const urlSlug = `/profiles/${profileId.toString()}/timeoff?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, options || new SmartWrapperOptions(8, false));
    }
    /**
     * Update an alert.
     * @param profileId
     * @param topicId
     * @param enabled
     * @param ownerId
     */
    updateAlert(profileId, topicId, enabled, ownerId) {
        let request = {
            alertTopicId: topicId,
            alertOwnerId: ownerId,
            enabled: enabled,
        };
        // formal url slug
        const urlSlug = `/profiles/${profileId.toString()}/updatealert`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
ProfilesService.ɵfac = function ProfilesService_Factory(t) { return new (t || ProfilesService)(i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
ProfilesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProfilesService, factory: ProfilesService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfilesService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i3.HttpClient }, { type: WebsocketService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class RegistrationService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    RegisterAccount(profile) {
        return this.http.post(`${this.config.atlasApiEndpoint}/api/registration`, profile)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    GetByGuid(guid) {
        return this.http.get(`${this.config.atlasApiEndpoint}/api/registration/${guid}`)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
RegistrationService.ɵfac = function RegistrationService_Factory(t) { return new (t || RegistrationService)(i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
RegistrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RegistrationService, factory: RegistrationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RegistrationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class SowService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(websocket, http, assetFilesService, assetsService, config) {
        this.websocket = websocket;
        this.http = http;
        this.assetFilesService = assetFilesService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    addAttachment(sowId, assetSetId, assetFileId, filename, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            filename: filename,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/addattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Add a textset to a sow.
     * @param productionId
     * @param phaseId
     * @param templateId
     * @param name
     * @param accessPublic
     * @param comment
     */
    addText(sowId, templateId, name, accessPublic, comment, privateComment) {
        let request = {
            templateId: templateId,
            accessType: accessPublic === true ? { id: 'Public', name: 'Public' } : { id: 'Private', name: 'Private' },
            name: name,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/addtext`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    addFixedContractLine(sowId, addFixedRequest) {
        return this.http.post(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/addfixedcontractline`, addFixedRequest)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    addRollingContractLine(sowId, addRollingRequest) {
        return this.http.post(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/addrollingcontractline`, addRollingRequest)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    cancel(sowId, comment) {
        let request = {
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/cancel`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    changeContractualEndDate(sowId, date, comment) {
        let request = {
            comment: comment,
            dueDate: date,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/changecontractualenddate`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    changeDates(sowId, startDate, endDate, comment) {
        let request = {
            startDate: startDate,
            dueDate: endDate,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/changedates`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change Type.
     * @param sowId
     * @param sowTypeId
     * @param comment
     */
    changeType(sowId, sowTypeId, comment) {
        let request = {
            sowTemplateTypeId: sowTypeId,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/changetype`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change units on an sow.
     * @param sowId
     * @param units
     * @param comment
     */
    changeUnits(sowId, units, comment) {
        let request = {
            units: units,
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/changeunits`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change attachment access level.
     * @param sowId
     * @param assetSetId
     * @param assetFileId
     * @param privateAsset
     * @param comment
     * @param privateComment
     */
    changeAttachmentAccessLevel(sowId, assetSetId, assetFileId, accessLevel, comment, privateComment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            accessLevel: accessLevel,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/changeattachmentaccesslevel`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change text access level.
     * @param sowId
     * @param assetSetId
     * @param assetFileId
     * @param privateAsset
     * @param comment
     * @param privateComment
     */
    changeTextAccessLevel(sowId, textSetId, accessLevel, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            accessLevel: accessLevel,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/changetextaccesslevel`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Change roles.
     * @param organizationId
     * @param roles
     */
    changeRoles(organizationId, roles, comment) {
        let request = {
            roles: roles,
            comment: comment
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${organizationId}/changeroles`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    createFOCSOW(orgId, startDate, endDate, sowName, totalUnits, roles, comment) {
        let request = {
            startDate: startDate,
            endDate: endDate,
            sowName: sowName,
            totalUnits: totalUnits,
            roles: roles,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/sows/${orgId}/createFOCSOW`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Delete an sow.
     * @param sowId
     */
    delete(sowId) {
        return this.http.delete(`${this.config.atlasApiEndpoint}/api/sows/${sowId}`)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Expire units on an sow.
     * @param sowId
     * @param comment
     */
    ExpireUnits(sowId, comment) {
        let request = {
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/expireunits`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    getSOW(sowId) {
        return this.websocket.smartApiWrapper(`/sows/${sowId}`, undefined, new SmartWrapperOptions(48, false));
    }
    getSowSummary(feedId) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        return this.websocket.smartApiWrapper(`/sows/summary?${params.toString()}`, undefined, new SmartWrapperOptions(196, false, true));
    }
    hold(sowId, comment) {
        let request = {
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/hold`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
    * Link a file url to the content version.
    * @param contentId
    * @param versionId
    * @param url
    */
    linkFile(sowId, url, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            fileUrl: url,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/upload-link`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    listContributors(sowId, options) {
        return this.websocket.smartApiWrapper(`/sows/${sowId}/contributors`, undefined, options || new SmartWrapperOptions(8, false));
    }
    listSOWs(page = 1, pageSize = 10, feedIds, statuses, ownerIds, loadAssets, orderByCriteria, teamIds, templateIds, baseTemplateIds, fromDate, toDate, completedPaceOffsetPercentageFrom, completedPaceOffsetPercentageTo, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // feed id criteria
        if (feedIds)
            params = params.set('feedIds', feedIds);
        // status criteria
        if (statuses)
            params = params.set('statuses', statuses.toString());
        // owner id criteria
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        // load assets
        if (loadAssets)
            params = params.set('loadAssets', loadAssets.toString());
        // sort order
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        // team id criteria
        if (teamIds)
            params = params.set('teamIds', teamIds);
        // template id criteria
        if (templateIds)
            params = params.set('templateIds', templateIds);
        // base template id criteria
        if (baseTemplateIds)
            params = params.set('baseTemplateIds', baseTemplateIds);
        if (fromDate)
            // convert to unix epoch time and string
            params = params.set('fromDate', fromDate.valueOf().toString());
        if (toDate)
            // convert to unix epoch time and string
            params = params.set('toDate', toDate.valueOf().toString());
        if (completedPaceOffsetPercentageFrom)
            params = params.set('completedPaceOffsetPercentageFrom', completedPaceOffsetPercentageFrom.toString());
        if (completedPaceOffsetPercentageTo)
            params = params.set('completedPaceOffsetPercentageTo', completedPaceOffsetPercentageTo.toString());
        // formal url slug
        const urlSlug = `/sows?${params.toString()}`;
        const socketTopic = `/sows`;
        return this.websocket.smartApiWrapper(urlSlug, socketTopic, options || new SmartWrapperOptions(196, false));
    }
    /**
     * List all messages related to the sow.
     */
    listMessages(page = 1, pageSize = 10, sowId, hasComment, affectedOwnerId, operatorId, affectedOwnerOrOperatorId, affectedOwnerOperatorOrDeliverableOwnerId, directDeliverableOnly, options) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // hasComment
        if (hasComment !== undefined)
            params = params.set('hasComment', hasComment.toString());
        // affectedOwnerId
        if (affectedOwnerId)
            params = params.set('affectedOwnerId', affectedOwnerId.toString());
        // operatorId
        if (operatorId)
            params = params.set('operatorId', operatorId.toString());
        // affectedOwnerOrOperatorId
        if (affectedOwnerOrOperatorId !== undefined)
            params = params.set('affectedOwnerOrOperatorId', affectedOwnerOrOperatorId.toString());
        // affectedOwnerOperatorOrDeliverableOwnerId
        if (affectedOwnerOperatorOrDeliverableOwnerId)
            params = params.set('affectedOwnerOperatorOrDeliverableOwnerId', affectedOwnerOperatorOrDeliverableOwnerId.toString());
        // direct deliverable or not
        if (directDeliverableOnly !== undefined)
            params = params.set('directDeliverableOnly', directDeliverableOnly.toString());
        return this.websocket.smartApiWrapper(`/sows/${sowId}/messages?${params.toString()}`, `messages`, options || new SmartWrapperOptions(4, false));
    }
    /**
     * Lock the sow.
     * @param sowId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    lock(sowId, lockStart, lockEnd, lockUnits, comment, privateComment) {
        let request = {
            comment: comment,
            lockStart: lockStart,
            lockEnd: lockEnd,
            lockUnits: lockUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/lock`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove an attachment from an sow.
     * @param sowId
     * @param assetSetId
     * @param comment
     */
    removeAttachment(sowId, assetSetId, assetFileId, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/removeattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename an SOW
     * @param sowId
     * @param name
     * @param comment
     */
    rename(sowId, name, comment) {
        let request = {
            comment: comment,
            name: name,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/rename`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename an attachment from an sow.
     * @param sowId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameAttachment(sowId, assetSetId, assetFileId, newName, comment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            comment: comment,
            name: newName,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/renameattachment`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Remove a text from a organization.
     * @param sowId
     * @param textSetId
     * @param comment
     */
    removeText(sowId, textSetId, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/removetext`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Rename a text from a organization.
     * @param contentId
     * @param assetSetId
     * @param newName
     * @param comment
     */
    renameText(sowId, textSetId, newName, comment, privateComment) {
        let request = {
            textSetId: textSetId,
            comment: comment,
            name: newName,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/renametext`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Request the upload of a binary file to the asset system.
     * @param contentId
     * @param versionId
     * @param filename
     * @param fileType
     * @param fileSizeInBytes
     */
    requestUpload(sowId, filename, fileType, fileSizeInBytes, feedId, organizationId, assetSetId, assetFileId) {
        let request = {
            filename: filename,
            fileType: fileType,
            fileSizeInBytes: fileSizeInBytes,
            feedId: feedId,
            organizationId: organizationId,
            assetSetId: assetSetId,
            assetFileId: assetFileId,
        };
        return this.http.post(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/upload`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    resume(sowId, comment) {
        let request = {
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/resume`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    trimUnits(sowId, comment) {
        let request = {
            comment: comment,
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/trimunits`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Update the notes for an SOW.
     * @param projectId
     * @param productionId
     * @param notes
     */
    updateNotes(sowId, notes, privateComment) {
        let request = {
            comment: notes,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
        };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/sows/${sowId}/updatenotes`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Upload a binary file.
     * @param contentId
     * @param versionId
     * @param file
     */
    uploadFile(sowId, file, feedId, organizationId, assetSetId, assetFileId) {
        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
        let safeFileName = file.name.replace("&", "_");
        let ext = this.getExtension(file.name);
        return this.assetFilesService.GetMimeTypeForFile(file).pipe(switchMap((fileTypeResult) => {
            let fileType;
            if (fileTypeResult == null) {
                if (file.type == null) {
                    fileType = new FileContentType(ext, "application/octet-stream"); // Been unable to sniff content type - treat as unknown binary with ext that was provided.
                }
                else {
                    fileType = new FileContentType(ext, file.type);
                }
            }
            else {
                // CFB hack
                if (fileTypeResult.mime == "application/x-cfb") {
                    // CFB is the only file type that we can't properly sniff, all we know is it's a legacy office type (doc, xls etc)
                    // As it's legacy it's not worth putting too much effort in, so we'll just assume its valid and use the provided ext (not the sniffed ext which will be .cfb) to determine the type.
                    if (ext == "doc") {
                        fileType = new FileContentType(ext, "application/msword");
                    }
                    else if (ext == "xls") {
                        fileType = new FileContentType(ext, "application/vnd.ms-excel");
                    }
                    else if (ext == "ppt" || ext == "pps") {
                        fileType = new FileContentType(ext, "application/vnd.ms-powerpoint");
                    }
                    else {
                        fileType = new FileContentType(ext, file.type);
                    }
                }
                else {
                    fileType = new FileContentType(fileTypeResult.ext, fileTypeResult.mime); // Breaking dependency on File-Type library.
                }
            }
            return this.requestUpload(sowId, safeFileName, fileType, file.size, feedId, organizationId, assetSetId, assetFileId).pipe(switchMap((response) => {
                return this.assetFilesService.BucketUploadAsync(response.assetFileId, response.awsUrl, file).pipe(switchMap((uploadResponse) => {
                    if (uploadResponse.status === 200) {
                        return this.assetsService.uploadSuccess(response.assetFileId, safeFileName, fileType, file.size).pipe(map((uploadSuccessResponse) => {
                            // We're now uploaded and told Assets the file is uploaded.
                            return new PlatformUploadResponse(uploadSuccessResponse, uploadResponse.progress, false, true);
                        }));
                    }
                    else if (uploadResponse.status == null && uploadResponse.progress > 0) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, true, false));
                    }
                    else if (uploadResponse instanceof HttpErrorResponse) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, false, false));
                    }
                    // We could be waiting for the first response from the server, so return a progress update.
                    return of(new PlatformUploadResponse(null, 0, true, false));
                }));
            }), catchError(AtlasSharedService.handleError()));
        }));
    }
    getExtension(fileName) {
        let split = fileName.split('.'); // Split by dot
        return split.pop();
    }
}
SowService.ɵfac = function SowService_Factory(t) { return new (t || SowService)(i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
SowService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SowService, factory: SowService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SowService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: WebsocketService }, { type: i3.HttpClient }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class TagService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(websocket, config) {
        this.websocket = websocket;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * List all tags on the current feed and using a merge cache strategy
     */
    listTags(parentTagId, feedId) {
        let params = new HttpParams();
        if (feedId) {
            params = params.set('feedId', feedId.toString());
        }
        // formal url slug
        const urlSlug = `/tags/${parentTagId}?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, new SmartWrapperOptions(8, false, true));
    }
}
TagService.ɵfac = function TagService_Factory(t) { return new (t || TagService)(i0.ɵɵinject(WebsocketService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
TagService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TagService, factory: TagService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: WebsocketService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class TeamsService {
    /**
     * Initialises a new instance of the ContractService class.
     *
     * @param http
     * @param config
     */
    constructor(websocket, config) {
        this.websocket = websocket;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * List all available units by team member.
     */
    AvailableUnitTotals(teamId, startDate, endDate, unitType) {
        let params = new HttpParams();
        if (startDate)
            // convert to unix epoch time and string
            params = params.set('startDate', startDate.valueOf().toString());
        if (endDate)
            // convert to unix epoch time and string
            params = params.set('endDate', endDate.valueOf().toString());
        if (unitType)
            // unit Type param
            params = params.set('unitType', unitType);
        // formal url slug
        const urlSlug = `/teams/${teamId.toString()}/units?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, new SmartWrapperOptions(8, false, true));
    }
    /**
     * List all available units by team member.
     */
    AvailableUnitTotalsByDate(teamId, startDate, endDate, unitType) {
        let params = new HttpParams();
        if (startDate)
            // convert to unix epoch time and string
            params = params.set('startDate', startDate.valueOf().toString());
        if (endDate)
            // convert to unix epoch time and string
            params = params.set('endDate', endDate.valueOf().toString());
        if (unitType)
            // unit Type param
            params = params.set('unitType', unitType);
        // formal url slug
        const urlSlug = `/teams/${teamId.toString()}/units/dates?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, new SmartWrapperOptions(8, false, true));
    }
    /**
     * List all available units by team member.
     */
    AvailableUnitTotalsByMember(teamId, startDate, endDate, unitType) {
        let params = new HttpParams();
        if (startDate)
            // convert to unix epoch time and string
            params = params.set('startDate', startDate.valueOf().toString());
        if (endDate)
            // convert to unix epoch time and string
            params = params.set('endDate', endDate.valueOf().toString());
        if (unitType)
            // unit Type param
            params = params.set('unitType', unitType);
        // formal url slug
        const urlSlug = `/teams/${teamId.toString()}/units/members?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, new SmartWrapperOptions(8, false, true));
    }
    /**
     * List all available units by team member and date.
     */
    AvailableUnitTotalsByMemberDates(teamId, startDate, endDate, unitType) {
        let params = new HttpParams();
        if (startDate)
            // convert to unix epoch time and string
            params = params.set('startDate', startDate.valueOf().toString());
        if (endDate)
            // convert to unix epoch time and string
            params = params.set('endDate', endDate.valueOf().toString());
        if (unitType)
            // unit Type param
            params = params.set('unitType', unitType);
        // formal url slug
        const urlSlug = `/teams/${teamId.toString()}/units/memberdates?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, new SmartWrapperOptions(8, false, true));
    }
    /**
     * Get team details.
     * @param teamId
     * @param options
     */
    getTeam(teamId, options) {
        return this.websocket.smartApiWrapper(`/teams/${teamId.toString()}`, undefined, options || new SmartWrapperOptions(8, false));
    }
    /**
     * List all team members.
     * @param teamId
     * @param options
     */
    ListMembers(teamId, options) {
        return this.websocket.smartApiWrapper(`/teams/${teamId.toString()}/members`, undefined, options || new SmartWrapperOptions(100, false));
    }
    /**
     * List all member teams.
     * @param teamId
     * @param options
     */
    ListTeams(teamId, options) {
        return this.websocket.smartApiWrapper(`/teams/${teamId.toString()}/teams`, undefined, options || new SmartWrapperOptions(100, false));
    }
    /**
     * List all team members.
     * @param teamId
     * @param options
     */
    ListTimeOff(teamId, startDate, endDate, options) {
        let params = new HttpParams();
        if (startDate)
            // convert to unix epoch time and string
            params = params.set('startDate', startDate.valueOf().toString());
        if (endDate)
            // convert to unix epoch time and string
            params = params.set('endDate', endDate.valueOf().toString());
        // formal url slug
        const urlSlug = `/teams/${teamId.toString()}/timeoff?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, options || new SmartWrapperOptions(8, false));
    }
}
TeamsService.ɵfac = function TeamsService_Factory(t) { return new (t || TeamsService)(i0.ɵɵinject(WebsocketService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
TeamsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TeamsService, factory: TeamsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: WebsocketService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class UsersService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, jsonDecryptEncrypt, websocket, assetFilesService, assetsService, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.assetFilesService = assetFilesService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * Request the upload of a binary file to the asset system.
     * @param productionId
     * @param phaseId
     * @param filename
     * @param fileType
     * @param fileSizeInBytes
     */
    requestProfilePictureUpload(feedId, filename, fileType, fileSizeInBytes, profileId = null) {
        let request = {
            feedId: feedId,
            filename: filename,
            fileType: fileType,
            fileSizeInBytes: fileSizeInBytes
        };
        let profileUrl = "";
        if (profileId != null)
            profileUrl = `/${profileId}`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/users/${profileUrl}/requestProfilePictureUpload`, request)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    setProfilePicture(assetFileId, profileId = null) {
        let profileUrl;
        if (profileId == null)
            profileUrl = "";
        else
            profileUrl = `/${profileId}`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api/users/${profileUrl}/${assetFileId}/setProfilePicture`, null)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    getExtension(fileName) {
        let split = fileName.split('.'); // Split by dot
        return split.pop();
    }
    listUsers(feedId, enabled = null) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        if (enabled != null)
            params = params.set('enabled', enabled.toString());
        return this.websocket.smartApiWrapper(`/users?${params.toString()}`, `/users`, new SmartWrapperOptions(1, false, true));
    }
    listUsersWithPermissions(feedId, enabled = null) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        if (enabled != null)
            params = params.set('enabled', enabled.toString());
        return this.websocket.smartApiWrapper(`/users/listUsersWithPermissions?${params.toString()}`, `/users`, new SmartWrapperOptions(1, false, true));
    }
    getUser(profileId) {
        return this.websocket.smartApiWrapper(`/users/${profileId}`, `/users`, new SmartWrapperOptions(1, false));
    }
    getUserWithPermissions(profileId) {
        return this.websocket.smartApiWrapper(`/users/${profileId}/getUserWithPermissions`, `/users`, new SmartWrapperOptions(1, false));
    }
    getSeats(orgId) {
        return this.websocket.smartApiWrapper(`/users/${orgId}/seats`, `/users`, new SmartWrapperOptions(1, false, true));
    }
    changePassword(request) {
        return this.http.put(`${this.config.atlasApiEndpoint}/api/users/changePassword`, request)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    /**
     * List all profile alerts.
     * @param profileId
     * @param options
     */
    listAlerts(profileId, organizationId, feedId, options) {
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        params = params.set('organizationId', organizationId);
        // formal url slug
        const urlSlug = `/users/${profileId.toString()}/alerts?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, options || new SmartWrapperOptions(24, false));
    }
    resetPassword(userId) {
        return this.http.post(`${this.config.atlasApiEndpoint}/api/users/${userId}/resetPassword`, null)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    updateUser(userId, request) {
        return this.http.put(`${this.config.atlasApiEndpoint}/api/users/${userId}`, request)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    deleteUser(userId) {
        return this.http.delete(`${this.config.atlasApiEndpoint}/api/users/${userId}`)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    setUserPermission(orgId, userId, permission) {
        var request = { id: permission };
        return this.http.put(`${this.config.atlasApiEndpoint}/api/users/${orgId}/${userId}/setPermission`, request)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    enableUser(orgId, userId) {
        return this.http.put(`${this.config.atlasApiEndpoint}/api/users/${orgId}/${userId}/enable`, null)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    disableUser(userId) {
        return this.http.put(`${this.config.atlasApiEndpoint}/api/users/${userId}/disable`, null)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    createAndInviteUser(orgId, request) {
        return this.http.post(`${this.config.atlasApiEndpoint}/api/users/${orgId}`, request)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    renewInvititationAsync(profileId) {
        return this.http.post(`${this.config.atlasApiEndpoint}/api/users/${profileId}/RenewInvitation`, null)
            .pipe(catchError(AtlasSharedService.handleError()), first());
    }
    /**
   * Update an alert.
   * @param profileId
   * @param topicId
   * @param enabled
   * @param ownerId
   */
    updateAlert(profileId, organizationId, feedId, topicId, alertFeedId, enabled, ownerId) {
        let request = {
            alertTopicId: topicId,
            alertOwnerId: ownerId,
            enabled: enabled,
            alertFeedId: alertFeedId,
        };
        let params = new HttpParams();
        params = params.set('feedId', feedId.toString());
        params = params.set('organizationId', organizationId);
        // formal url slug
        const urlSlug = `/users/${profileId.toString()}/updatealert?${params.toString()}`;
        return this.http.put(`${this.config.atlasApiEndpoint}/api${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /* todo: Refactor this to reuse code rather than copy/pasting */
    /**
     * Upload a binary file.
     * @param productionId
     * @param phaseId
     * @param file
     */
    uploadProfilePictureFile(feedId, file, profileId = null) {
        // note - important to replace & as apigateway / c# http lambda wrapper has issues otherwise...
        debugger;
        let safeFileName = file.name.replace("&", "_");
        let ext = this.getExtension(file.name);
        return this.assetFilesService.GetMimeTypeForFile(file).pipe(switchMap((fileTypeResult) => {
            let fileType;
            if (fileTypeResult == null) {
                if (file.type == null) {
                    fileType = new FileContentType(ext, "application/octet-stream"); // Been unable to sniff content type - treat as unknown binary with ext that was provided.
                }
                else {
                    fileType = new FileContentType(ext, file.type);
                }
            }
            else {
                // CFB hack
                if (fileTypeResult.mime == "application/x-cfb") {
                    // CFB is the only file type that we can't properly sniff, all we know is it's a legacy office type (doc, xls etc)
                    // As it's legacy it's not worth putting too much effort in, so we'll just assume its valid and use the provided ext (not the sniffed ext which will be .cfb) to determine the type.
                    if (ext == "doc") {
                        fileType = new FileContentType(ext, "application/msword");
                    }
                    else if (ext == "xls") {
                        fileType = new FileContentType(ext, "application/vnd.ms-excel");
                    }
                    else if (ext == "ppt" || ext == "pps") {
                        fileType = new FileContentType(ext, "application/vnd.ms-powerpoint");
                    }
                    else {
                        fileType = new FileContentType(ext, file.type);
                    }
                }
                else {
                    fileType = new FileContentType(fileTypeResult.ext, fileTypeResult.mime); // Breaking dependency on File-Type library.
                }
            }
            return this.requestProfilePictureUpload(feedId, safeFileName, fileType, file.size, profileId).pipe(switchMap((response) => {
                return this.assetFilesService.BucketUploadAsync(response.assetFileId, response.awsUrl, file).pipe(switchMap((uploadResponse) => {
                    if (uploadResponse.status === 200) {
                        return this.assetsService.uploadSuccess(response.assetFileId, safeFileName, fileType, file.size).pipe(switchMap((uploadSuccessResponse) => {
                            return this.setProfilePicture(uploadSuccessResponse.id, profileId).pipe(map((setProfilePictureResponse) => {
                                return new PlatformUploadResponse(uploadSuccessResponse, uploadResponse.status, false, true);
                            }));
                        }));
                    }
                    else if (uploadResponse.status == null && uploadResponse.progress > 0) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, true, false));
                    }
                    else if (uploadResponse instanceof HttpErrorResponse) {
                        return of(new PlatformUploadResponse(null, uploadResponse.progress, false, false));
                    }
                    // We could be waiting for the first response from the server, so return a progress update.
                    return of(new PlatformUploadResponse(null, 0, true, false));
                }));
            }), catchError(AtlasSharedService.handleError()));
        }), first());
    }
}
UsersService.ɵfac = function UsersService_Factory(t) { return new (t || UsersService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
UsersService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UsersService, factory: UsersService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UsersService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class SearchService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(http, jsonDecryptEncrypt, config) {
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    performSearch(term, page = 1, pageSize = 25) {
        return this.http.get(`${this.config.atlasApiEndpoint}/api/search/${term}?page=${page}&pageSize=${pageSize}`)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
    performAutocompleteSearch(term) {
        return this.http.get(`${this.config.atlasApiEndpoint}/api/search/autocomplete/${term}`)
            .pipe(map(result => this.jsonDecryptEncrypt.retrocycle(result)), catchError(AtlasSharedService.handleError()));
    }
}
SearchService.ɵfac = function SearchService_Factory(t) { return new (t || SearchService)(i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
SearchService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SearchService, factory: SearchService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class AIService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, jsonDecryptEncrypt, websocket, assetFilesService, assetsService, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.assetFilesService = assetFilesService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * Complete an AI task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    generalAIComplete(projectId, productionId, phaseId, taskId, textSetId, sourceText, date, partialUnits, comment, privateComment) {
        let request = {
            comment: comment,
            date: date,
            partialUnits: partialUnits,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            textSetId: textSetId,
            sourceText: sourceText,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/general-ai-complete` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/general-ai-complete`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a general AI Task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    generalAIStart(projectId, productionId, phaseId, taskId, date, restart, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            restart: restart
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/general-ai-start` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/general-ai-start`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a Keywords to Outline AI task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    keywordsToOutline(projectId, productionId, phaseId, taskId, keywordsTextSetId, titleTextSetId, title, targetAudienceBriefTextSetId, outlineTextSetId, numberOfSections, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordsTextSetId: keywordsTextSetId,
            outlineTextSetId: outlineTextSetId,
            titleTextSetId: titleTextSetId,
            numberOfSections: numberOfSections,
            targetAudienceBriefTextSetId: targetAudienceBriefTextSetId,
            title: title,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/keywords-to-outline` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/keywords-to-outline`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run an Outline + Keywords to Copy AI task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    outlineKeywordsToCopy(projectId, productionId, phaseId, taskId, keywordsTextSetId, outlineTextSetId, writingBriefTextSetId, targetAudienceBriefTextSetId, copyTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordsTextSetId: keywordsTextSetId,
            writingBriefTextSetId: writingBriefTextSetId,
            targetAudienceBriefTextSetId: targetAudienceBriefTextSetId,
            outlineTextSetId: outlineTextSetId,
            copyTextSetId: copyTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/outline-keywords-to-copy` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/outline-keywords-to-copy`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a Keywords + Copy to Optimized Copy AI Task.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    copyKeywordsToOptimizedCopy(projectId, productionId, phaseId, taskId, keywordsTextSetId, copyTextSetId, outputCopyTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordsTextSetId: keywordsTextSetId,
            copyTextSetId: copyTextSetId,
            outputCopyTextSetId: outputCopyTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-keywords-to-optimized-copy` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-keywords-to-optimized-copy`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a Copy to Tweets AI Operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    copyToTweets(projectId, productionId, phaseId, taskId, copyTextSetId, numberOfTweets, targetURL, outputTweetsTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            numberOfTweets: numberOfTweets,
            copyTextSetId: copyTextSetId,
            targetURL: targetURL,
            tweetsTextSetId: outputTweetsTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-tweets` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-tweets`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a title to image AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    titleToImage(projectId, productionId, phaseId, taskId, titleTextSetId, title, assetSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            titleOverride: title,
            titleTextSetId: titleTextSetId,
            assetSetId: assetSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/title-to-image` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/title-to-image`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a copy to image AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     */
    copyToImages(projectId, productionId, phaseId, taskId, copyTextSetId, assetSetId, artStyleTextSetId, promptOutputTextSetId, date, prompt, privateComment) {
        let request = {
            copyTextSetId: copyTextSetId,
            assetSetId: assetSetId,
            artStyleTextSetId: artStyleTextSetId,
            promptOutputTextSetId: promptOutputTextSetId,
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' }
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-images` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-images`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run an attachment to image description AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    attachmentToImageDescription(projectId, productionId, phaseId, taskId, assetSetId, assetFileId, outputTextSetId, date, prompt, privateComment) {
        let request = {
            assetSetId: assetSetId,
            assetFileId: assetFileId,
            outputTextSetId: outputTextSetId,
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' }
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/attachment-to-image-description` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/attachment-to-image-description`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a keyword to title AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    keywordToTitle(projectId, productionId, phaseId, taskId, keywordTextSetId, titleTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordTextSetId: keywordTextSetId,
            titleTextSetId: titleTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/keyword-to-title` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/keyword-to-title`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run a title + copy + keywords to metadata AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    titleCopyKeywordsToMetaData(projectId, productionId, phaseId, taskId, titleTextSetId, copyTextSetId, keywordsTextSetId, metadataTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordsTextSetId: keywordsTextSetId,
            titleTextSetId: titleTextSetId,
            copyTextSetId: copyTextSetId,
            metaDataTextSetId: metadataTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/title-copy-keywords-to-metadata` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/title-copy-keywords-to-metadata`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    keywordToKeywordsDensity(projectId, productionId, phaseId, taskId, keywordTextSetId, keyword, keywordsDensityTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordOverride: keyword,
            keywordTextSetId: keywordTextSetId,
            outputKeywordsTextSetId: keywordsDensityTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/keyword-to-keywords-density` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/keyword-to-keywords-density`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    copyToLinkedInPost(projectId, productionId, phaseId, taskId, copyTextSetId, targetURL, linkedInPostTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            targetURL: targetURL,
            copyTextSetId: copyTextSetId,
            linkedInPostTextSetId: linkedInPostTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-linkedin-post` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-linkedin-post`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    keywordToTitles(projectId, productionId, phaseId, taskId, keywordTextSetId, keyword, titlesTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            keywordOverride: keyword,
            keywordTextSetId: keywordTextSetId,
            titlesTextSetId: titlesTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/keyword-to-titles` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/keyword-to-titles`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    outlineToCopy(projectId, productionId, phaseId, taskId, copyTextSetId, writingBriefTextSetId, targetAudienceBriefTextSetId, outlineTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            outlineTextSetId: outlineTextSetId,
            writingBriefTextSetId: writingBriefTextSetId,
            targetAudienceBriefTextSetId: targetAudienceBriefTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/outline-to-copy` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/outline-to-copy`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    topicToOutline(projectId, productionId, phaseId, taskId, topicTextSetId, topic, outlineTextSetId, numberOfSections, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            topicOverride: topic,
            topicTextSetId: topicTextSetId,
            outlineTextSetId: outlineTextSetId,
            numberOfSections: numberOfSections,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/topic-to-outline` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/topic-to-outline`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    topicToTopics(projectId, productionId, phaseId, taskId, topicTextSetId, topic, topicsTextSetId, numberOfTopics, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            topicOverride: topic,
            topicTextSetId: topicTextSetId,
            topicsTextSetId: topicsTextSetId,
            numberOfTopics: numberOfTopics
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/topic-to-topics` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/topic-to-topics`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run keyword to analyzer keywrod density operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    textToKeywordsDensity(projectId, productionId, phaseId, taskId, textTextSetId, text, keywordsDensityTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            textOverride: text,
            textTextSetId: textTextSetId,
            outputKeywordsTextSetId: keywordsDensityTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/text-to-keywords-density` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/text-to-keywords-density`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run copy to writing brief AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    copyToWritingBrief(projectId, productionId, phaseId, taskId, copyTextSetId, writingBriefTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            writingBriefTextSetId: writingBriefTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-writing-brief` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-writing-brief`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run copy to german copy AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    copyToGermanCopy(projectId, productionId, phaseId, taskId, copyTextSetId, germanCopyTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            germanCopyTextSetId: germanCopyTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-german-copy` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-german-copy`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run copy to target audience brief AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    copyToTargetAudienceBrief(projectId, productionId, phaseId, taskId, copyTextSetId, targetAudienceBriefTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            targetAudienceBriefTextSetId: targetAudienceBriefTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-target-audience-brief` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-target-audience-brief`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Run copy to fact citations AI operation.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    copyToFacts(projectId, productionId, phaseId, taskId, copyTextSetId, factsTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            copyTextSetId: copyTextSetId,
            factsTextSetId: factsTextSetId,
        };
        const urlSlug = !projectId ? `ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-facts` :
            `masterprojects/${projectId}/ai/${productionId}/phase/${phaseId}/task/${taskId}/copy-to-facts`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
AIService.ɵfac = function AIService_Factory(t) { return new (t || AIService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
AIService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AIService, factory: AIService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AIService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class ProcessDefinitionsService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, jsonDecryptEncrypt, websocket, assetFilesService, assetsService, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.assetFilesService = assetFilesService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.urlBase = `/processdefinitions`;
        this.config = config;
    }
    /**
     * Get a process definiton.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    getProcessDefinition(processDefinitionId, options) {
        const urlSlug = `${this.urlBase}/${processDefinitionId}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, options || new SmartWrapperOptions(1, false));
    }
    /**
     * List process definitions.
     * @param orgId
     * @param tagIds
     * @param options
     * @returns
     */
    listProcessDefinitions(orgId, tagIds, options) {
        let params = new HttpParams();
        if (orgId)
            params.set('orgId', orgId);
        if (tagIds)
            params = params.set('tagIds', tagIds);
        const urlSlug = `${this.urlBase}?${params.toString()}`;
        return this.websocket.smartApiWrapper(urlSlug, undefined, options || new SmartWrapperOptions(1, false));
    }
}
ProcessDefinitionsService.ɵfac = function ProcessDefinitionsService_Factory(t) { return new (t || ProcessDefinitionsService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
ProcessDefinitionsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProcessDefinitionsService, factory: ProcessDefinitionsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProcessDefinitionsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();

/* eslint-disable arrow-body-style */
class ProcessExecutionService {
    /**
     * Initialises a new instance of the ProductionsService class.
     *
     * @param http
     * @param config
     */
    constructor(cacheService, feedService, http, jsonDecryptEncrypt, websocket, assetFilesService, assetsService, config) {
        this.cacheService = cacheService;
        this.feedService = feedService;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.websocket = websocket;
        this.assetFilesService = assetFilesService;
        this.assetsService = assetsService;
        this.config = config;
        this.appName = 'atlas-api';
        this.config = config;
    }
    /**
     * Run a generic process.
     * @param productionId
     * @param phaseId
     * @param taskId
     * @param comment
     */
    executeAiTextSetsToTextSetAsync(projectId, productionId, phaseId, taskId, processId, inputs, outputTextSetId, date, prompt, privateComment) {
        let request = {
            comment: prompt,
            date: date,
            commentAccessLevel: privateComment === true ? { 'id': 'Private', 'name': 'Private' } : { 'id': 'Public', 'name': 'Public' },
            aiProcessId: processId,
            inputs: inputs,
            outputTextSetId: outputTextSetId,
        };
        const urlSlug = !projectId ? `processexecution/${productionId}/phase/${phaseId}/task/${taskId}/execute-ai-textsets-to-textset` :
            `masterprojects/${projectId}/processexecution/${productionId}/phase/${phaseId}/task/${taskId}/execute-ai-textsets-to-textset`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Test the prompt.
     * @param processId
     * @param inputs
     */
    testPrompt(processId, inputs) {
        let request = {
            aiProcessId: processId,
            inputs: inputs,
        };
        const urlSlug = `processexecution/${processId}/test-prompt`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request)
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Test the input prompt.
     * @param processId
     * @param inputs
     */
    testInputPrompt(processId, inputs) {
        let request = {
            aiProcessId: processId,
            inputs: inputs,
        };
        const urlSlug = `processexecution/${processId}/test-input-prompt`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request, { responseType: 'text' })
            .pipe(catchError(AtlasSharedService.handleError()));
    }
    /**
     * Test the sysmte prompt.
     * @param processId
     * @param inputs
     */
    testSystemPrompt(processId, inputs) {
        let request = {
            aiProcessId: processId,
            inputs: inputs,
        };
        const urlSlug = `processexecution/${processId}/test-system-prompt`;
        return this.http.post(`${this.config.atlasApiEndpoint}/api/${urlSlug}`, request, { responseType: 'text' })
            .pipe(catchError(AtlasSharedService.handleError()));
    }
}
ProcessExecutionService.ɵfac = function ProcessExecutionService_Factory(t) { return new (t || ProcessExecutionService)(i0.ɵɵinject(CacheService), i0.ɵɵinject(FeedService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(JsonEncryptDecrypt), i0.ɵɵinject(WebsocketService), i0.ɵɵinject(i6.AssetFilesService), i0.ɵɵinject(AssetsService), i0.ɵɵinject(ATLAS_CLIENT_CONFIG)); };
ProcessExecutionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProcessExecutionService, factory: ProcessExecutionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProcessExecutionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CacheService }, { type: FeedService }, { type: i3.HttpClient }, { type: JsonEncryptDecrypt }, { type: WebsocketService }, { type: i6.AssetFilesService }, { type: AssetsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [ATLAS_CLIENT_CONFIG]
            }] }]; }, null); })();
class KeyedTextSet {
    constructor() {
        this.type = InputType.TextSet;
    }
}
class KeyedAssetSet {
    constructor() {
        this.type = InputType.AssetSet;
    }
}
class KeyedString {
    constructor() {
        this.type = InputType.String;
    }
}
class KeyedInteger {
    constructor() {
        this.type = InputType.Integer;
    }
}

class EqualPasswordsValidator {
    static validate(firstField, secondField) {
        const res = (c) => c.controls &&
            c.controls[firstField].value === c.controls[secondField].value
            ? null
            : {
                passwordsEqual: {
                    valid: false,
                },
            };
        return res;
    }
}

class AddFixedContractLineRequest {
}
class AddRollingContractLineRequest {
}

/*
 * Public API Surface of platform-service
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AIService, ATLAS_CLIENT_CONFIG, AddFixedContractLineRequest, AddRollingContractLineRequest, AssetsService, AtlasServiceModule, AtlasSharedService, AuditService, CacheEntry, CacheEntryClass, CacheMode, CacheService, CampaignService, ContentService, DateOwnerUnitsAndCounts, DateOwnerUnitsAvailabilityAndCounts, DateUnitsAndCounts, DateUnitsAvailabilityAndCounts, EnumBase, EqualPasswordsValidator, Error, ErrorDetails, FeedService, IdeationService, JsonEncryptDecrypt, KeyedAssetSet, KeyedInteger, KeyedString, KeyedTextSet, MasterProjectsService, OrganizationsService, OwnerUnitsAndCounts, OwnerUnitsAvailabilityAndCounts, PeopleService, PersonTerm, ProcessDefinitionsService, ProcessExecutionService, ProductionsService, ProductsService, ProfileAlert, ProfilesService, PropertyTypeEnum, PublishService, RegistrationService, SearchService, SmartWrapperOptions, SocketAction, SocketBaseEvent, SocketEventType, SocketPingEvent, SocketPongEvent, SocketSetFeedEvent, SocketTypingEvent, SocketTypingRequest, SocketWrapper, SowService, TagService, TeamsService, TermType, UnitsAndCounts, UnitsAvailabilityAndCounts, UserProfileInvite, UserRegister, UsersService, WebsocketService };
